/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessoriesCreateData,
  AccessoriesCreateError,
  AccessoriesCreatePayload,
  AccessoriesDeleteData,
  AccessoriesDetailData,
  AccessoriesDetailError,
  AccessoriesListData,
  AccessoriesUpdateData,
  AccessoriesUpdateError,
  AccessoriesUpdatePayload,
  AccessoryItemsAssignToBookingCreateData,
  AccessoryItemsAssignToBookingCreateError,
  AccessoryItemsAssignToBookingCreatePayload,
  AccessoryItemsAssignToEquipmentCreateData,
  AccessoryItemsAssignToEquipmentCreateError,
  AccessoryItemsAutoAssignToBookingCreateData,
  AccessoryItemsAutoAssignToBookingCreatePayload,
  AccessoryItemsBulkAssignToEquipmentCreateData,
  AccessoryItemsBulkAssignToEquipmentCreatePayload,
  AccessoryItemsByBookingDetailData,
  AccessoryItemsByBookingEquipmentDetailData,
  AccessoryItemsByEquipmentDetailData,
  AccessoryItemsByLocationDetailData,
  AccessoryItemsBySerialDetailData,
  AccessoryItemsBySerialDetailError,
  AccessoryItemsCreateData,
  AccessoryItemsCreateError,
  AccessoryItemsCreatePayload,
  AccessoryItemsDeleteData,
  AccessoryItemsDetailData,
  AccessoryItemsDetailError,
  AccessoryItemsListData,
  AccessoryItemsListParams,
  AccessoryItemsMarkAvailableCreateData,
  AccessoryItemsMarkAvailableCreateError,
  AccessoryItemsMarkDamagedCreateData,
  AccessoryItemsMarkDamagedCreateError,
  AccessoryItemsMarkMissingCreateData,
  AccessoryItemsMarkMissingCreateError,
  AccessoryItemsMoveCreateData,
  AccessoryItemsMoveCreatePayload,
  AccessoryItemsNextSerialNumberListData,
  AccessoryItemsNextSerialNumberListError,
  AccessoryItemsNextSerialNumberListParams,
  AccessoryItemsReturnFromBookingCreateData,
  AccessoryItemsReturnFromBookingCreateError,
  AccessoryItemsReturnFromBookingCreatePayload,
  AccessoryItemsStatusUpdateData,
  AccessoryItemsStatusUpdateError,
  AccessoryItemsSuggestedForEquipmentDetailData,
  AccessoryItemsSuggestedForEquipmentDetailParams,
  AccessoryItemsUnassignFromEquipmentCreateData,
  AccessoryItemsUnassignFromEquipmentCreateError,
  AccessoryItemsUpdateData,
  AccessoryItemsUpdateError,
  AccessoryItemsUpdatePayload,
  AcknowledgeAdminStrandedRentalData,
  AcknowledgeAdminStrandedRentalError,
  AcknowledgeAdminStrandedRentalParams,
  AcknowledgeAdminStrandedRentalPayload,
  AcknowledgePartnerAdminStrandedRentalData,
  AcknowledgePartnerAdminStrandedRentalError,
  AcknowledgePartnerAdminStrandedRentalParams,
  AcknowledgePartnerAdminStrandedRentalPayload,
  ActivateCustomerData,
  ActivateCustomerError,
  ActivatePartnerAdminUserData,
  ActivatePartnerAdminUserError,
  ActivatePartnerData,
  ActivatePartnerError,
  AdminAppReleasesCleanupCreateData,
  AdminAppReleasesCleanupCreateError,
  AdminAppReleasesCleanupCreateParams,
  AdminAppReleasesDeleteData,
  AdminAppReleasesDeleteError,
  AdminAppReleasesDeprecateCreateData,
  AdminAppReleasesDeprecateCreateError,
  AdminAppReleasesDetailData,
  AdminAppReleasesDetailError,
  AdminAppReleasesDownloadUrlListData,
  AdminAppReleasesDownloadUrlListError,
  AdminAppReleasesExternalCreateData,
  AdminAppReleasesExternalCreateError,
  AdminAppReleasesExternalCreatePayload,
  AdminAppReleasesListData,
  AdminAppReleasesListParams,
  AdminAppReleasesMinimumVersionPartialUpdateData,
  AdminAppReleasesMinimumVersionPartialUpdateError,
  AdminAppReleasesMinimumVersionPartialUpdatePayload,
  AdminAppReleasesPublishCreateData,
  AdminAppReleasesPublishCreateError,
  AdminAppReleasesRollbackCreateData,
  AdminAppReleasesRollbackCreateError,
  AdminAppReleasesUpdateData,
  AdminAppReleasesUpdateError,
  AdminAppReleasesUpdatePayload,
  AdminAppReleasesUploadCreateData,
  AdminAppReleasesUploadCreateError,
  AdminAppReleasesUploadCreatePayload,
  AdminBackgroundJobsDetailData,
  AdminBackgroundJobsDetailError,
  AdminBackgroundJobsEmailDeliveryItemsListData,
  AdminBackgroundJobsEmailDeliveryItemsRetryCreateData,
  AdminBackgroundJobsItemsListData,
  AdminBackgroundJobsItemsListError,
  AdminBackgroundJobsListData,
  AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsListData,
  AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsRetryCreateData,
  AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsRetryCreateError,
  AdminBackgroundJobsPauseCreateData,
  AdminBackgroundJobsPauseCreateError,
  AdminBackgroundJobsResumeCreateData,
  AdminBackgroundJobsResumeCreateError,
  AdminBackgroundJobsRunNowCreateData,
  AdminBackgroundJobsRunNowCreateError,
  AdminBackgroundJobsRunsListData,
  AdminBackgroundJobsRunsListError,
  AdminCustomerReservationsCancelCreateData,
  AdminCustomerReservationsCancelCreateError,
  AdminCustomerReservationsCancelCreatePayload,
  AdminCustomerReservationsCompleteInspectionCreateData,
  AdminCustomerReservationsCompleteInspectionCreateError,
  AdminCustomerReservationsCompleteInspectionCreatePayload,
  AdminCustomerReservationsListData,
  AdminCustomerReservationsListParams,
  AdminCustomerReservationsPendingRefundsListData,
  AdminCustomerReservationsPendingRefundsListParams,
  AdminCustomerReservationsProcessDepositRefundCreateData,
  AdminCustomerReservationsProcessDepositRefundCreateError,
  AdminCustomerReservationsProcessDepositRefundCreatePayload,
  AdminCustomerReservationsProcessReturnCreateData,
  AdminCustomerReservationsProcessReturnCreateError,
  AdminCustomerReservationsProcessReturnCreatePayload,
  AdminEquipmentTypesRelatedCreateError,
  AdminEquipmentTypesRelatedCreatePayload,
  AdminEquipmentTypesRelatedDeleteError,
  AdminEquipmentTypesRelatedReorderUpdateData,
  AdminEquipmentTypesRelatedReorderUpdatePayload,
  AdminExtensionRequestsApproveCreateData,
  AdminExtensionRequestsApproveCreateError,
  AdminExtensionRequestsDetailData,
  AdminExtensionRequestsDetailError,
  AdminExtensionRequestsListData,
  AdminExtensionRequestsListParams,
  AdminExtensionRequestsRejectCreateData,
  AdminExtensionRequestsRejectCreateError,
  AdminExtensionRequestsRejectCreatePayload,
  AdminMonthlyRentalsActionLogsListData,
  AdminMonthlyRentalsCancelCreateData,
  AdminMonthlyRentalsCancelCreateError,
  AdminMonthlyRentalsCancelCreatePayload,
  AdminMonthlyRentalsCompleteInspectionCreateData,
  AdminMonthlyRentalsCompleteInspectionCreateError,
  AdminMonthlyRentalsCompleteInspectionCreatePayload,
  AdminMonthlyRentalsInspectionFailedWorklistListData,
  AdminMonthlyRentalsListData,
  AdminMonthlyRentalsListParams,
  AdminMonthlyRentalsPreviewCancellationListData,
  AdminMonthlyRentalsPreviewCancellationListError,
  AdminMonthlyRentalsProcessDepositRefundCreateData,
  AdminMonthlyRentalsProcessDepositRefundCreateError,
  AdminMonthlyRentalsProcessDepositRefundCreatePayload,
  AdminMonthlyRentalsProcessReturnCreateData,
  AdminMonthlyRentalsProcessReturnCreateError,
  AdminMonthlyRentalsProcessReturnCreatePayload,
  AdminMonthlyRentalsResolveDamageCreateData,
  AdminMonthlyRentalsResolveDamageCreateError,
  AdminMonthlyRentalsResolveDamageCreatePayload,
  AdminMonthlyRentalsScheduledCancellationsClearCreateData,
  AdminMonthlyRentalsScheduledCancellationsListData,
  AdminPartnerInquiriesDeleteData,
  AdminPartnerInquiriesDetailData,
  AdminPartnerInquiriesListData,
  AdminPartnerInquiriesListParams,
  AdminPartnerInquiriesStatsListData,
  AdminPartnerInquiriesStatusUpdateData,
  AdminPartnerInquiriesStatusUpdatePayload,
  AdminPaymentsCaptureAdvanceBookingsCreateData,
  AdminPromoCodesActivateCreateData,
  AdminPromoCodesActivateCreateError,
  AdminPromoCodesCreateData,
  AdminPromoCodesCreateError,
  AdminPromoCodesCreatePayload,
  AdminPromoCodesDeactivateCreateData,
  AdminPromoCodesDeactivateCreateError,
  AdminPromoCodesDetailData,
  AdminPromoCodesDetailError,
  AdminPromoCodesListData,
  AdminPromoCodesListParams,
  AdminPromoCodesOptionsListData,
  AdminPromoCodesOrdersListData,
  AdminPromoCodesOrdersListError,
  AdminPromoCodesOrdersListParams,
  AdminPromoCodesPartialUpdateData,
  AdminPromoCodesPartialUpdateError,
  AdminPromoCodesPartialUpdatePayload,
  AdminPurchaseQuotesDeclineCreateData,
  AdminPurchaseQuotesDeclineCreateError,
  AdminPurchaseQuotesDeclineCreatePayload,
  AdminPurchaseQuotesDetailData,
  AdminPurchaseQuotesDetailError,
  AdminPurchaseQuotesExpireOverdueCreateData,
  AdminPurchaseQuotesListData,
  AdminPurchaseQuotesListParams,
  AdminPurchaseQuotesProcessPurchaseCreateData,
  AdminPurchaseQuotesProcessPurchaseCreateError,
  AdminPurchaseQuotesProcessPurchaseCreatePayload,
  AdminPurchaseQuotesReviewCreateData,
  AdminPurchaseQuotesReviewCreateError,
  AdminPurchaseQuotesReviewCreatePayload,
  AdminPurchaseQuotesSendCreateData,
  AdminPurchaseQuotesSendCreateError,
  AdminReviewsApproveCreateData,
  AdminReviewsApproveCreateError,
  AdminReviewsListData,
  AdminReviewsListError,
  AdminReviewsListParams,
  AdminReviewsRejectCreateData,
  AdminReviewsRejectCreateError,
  AdminReviewsRejectCreatePayload,
  AdminStaffAppReleasesCleanupCreateData,
  AdminStaffAppReleasesCleanupCreateError,
  AdminStaffAppReleasesCleanupCreateParams,
  AdminStaffAppReleasesDeleteData,
  AdminStaffAppReleasesDeleteError,
  AdminStaffAppReleasesDeprecateCreateData,
  AdminStaffAppReleasesDeprecateCreateError,
  AdminStaffAppReleasesDetailData,
  AdminStaffAppReleasesDetailError,
  AdminStaffAppReleasesDownloadUrlListData,
  AdminStaffAppReleasesDownloadUrlListError,
  AdminStaffAppReleasesListData,
  AdminStaffAppReleasesListParams,
  AdminStaffAppReleasesMinimumVersionPartialUpdateData,
  AdminStaffAppReleasesMinimumVersionPartialUpdateError,
  AdminStaffAppReleasesMinimumVersionPartialUpdatePayload,
  AdminStaffAppReleasesPublishCreateData,
  AdminStaffAppReleasesPublishCreateError,
  AdminStaffAppReleasesRollbackCreateData,
  AdminStaffAppReleasesRollbackCreateError,
  AdminStaffAppReleasesUpdateData,
  AdminStaffAppReleasesUpdateError,
  AdminStaffAppReleasesUpdatePayload,
  AdminStaffAppReleasesUploadCreateData,
  AdminStaffAppReleasesUploadCreateError,
  AdminStaffAppReleasesUploadCreatePayload,
  AdminTicketsDetailData,
  AdminTicketsDetailError,
  AdminTicketsListData,
  AdminTicketsListParams,
  AdminTicketsMessagesCreateData,
  AdminTicketsMessagesCreateError,
  AdminTicketsMessagesCreatePayload,
  AdminTicketsStatusPartialUpdateData,
  AdminTicketsStatusPartialUpdateError,
  AdminTicketsStatusPartialUpdatePayload,
  AdminWoocommerceImportRunsApplyCreateData,
  AdminWoocommerceImportRunsApplyCreateError,
  AdminWoocommerceImportRunsApplyCreatePayload,
  AdminWoocommerceImportRunsCreateData,
  AdminWoocommerceImportRunsCreateError,
  AdminWoocommerceImportRunsCreatePayload,
  AdminWoocommerceImportRunsDetailData,
  AdminWoocommerceImportRunsDetailError,
  AdminWoocommerceImportRunsDetailParams,
  AdminWoocommerceImportRunsProductMappingsUpdateData,
  AdminWoocommerceImportRunsProductMappingsUpdateError,
  AdminWoocommerceImportRunsProductMappingsUpdatePayload,
  AdminWoocommerceImportTestCreateData,
  AdminWoocommerceImportTestCreateError,
  AdminWoocommerceImportTestCreatePayload,
  BookingRequestsAdminReservationsCancelCreateData,
  BookingRequestsAdminReservationsCancelCreateError,
  BookingRequestsAdminReservationsCreateData,
  BookingRequestsAdminReservationsCreateError,
  BookingRequestsAdminReservationsCreatePayload,
  BookingRequestsAdminReservationsDetailListData,
  BookingRequestsAdminReservationsDetailListError,
  BookingRequestsAdminReservationsPreviewCreateData,
  BookingRequestsAdminReservationsPreviewCreateError,
  BookingRequestsAdminReservationsPreviewCreatePayload,
  BookingRequestsAdminReservationsResendEmailCreateData,
  BookingRequestsAdminReservationsResendEmailCreateError,
  BookingRequestsAdminReservationsRotateTokenCreateData,
  BookingRequestsAdminReservationsRotateTokenCreateError,
  BookingRequestsAdminReservationsRotateTokenCreatePayload,
  BookingRequestsAdminReservationsSyncFromStripeCreateData,
  BookingRequestsAdminReservationsSyncFromStripeCreateError,
  BookingRequestsAdminReservationsUpdateData,
  BookingRequestsAdminReservationsUpdateError,
  BookingRequestsAdminReservationsUpdatePayload,
  BusinessPartnerCategoriesCreateData,
  BusinessPartnerCategoriesCreatePayload,
  BusinessPartnerCategoriesDeleteData,
  BusinessPartnerCategoriesDetailData,
  BusinessPartnerCategoriesListData,
  BusinessPartnerCategoriesListParams,
  BusinessPartnerCategoriesReorderCreateData,
  BusinessPartnerCategoriesReorderCreatePayload,
  BusinessPartnerCategoriesUpdateData,
  BusinessPartnerCategoriesUpdatePayload,
  BusinesspartnersCreateData,
  BusinesspartnersCreatePayload,
  BusinesspartnersDeleteData,
  BusinesspartnersDetailData,
  BusinesspartnersListData,
  BusinesspartnersListParams,
  BusinesspartnersLogoCreateData,
  BusinesspartnersLogoCreatePayload,
  BusinesspartnersLogoDeleteData,
  BusinesspartnersReorderCreateData,
  BusinesspartnersReorderCreatePayload,
  BusinesspartnersUpdateData,
  BusinesspartnersUpdatePayload,
  CancelBookingRequestData,
  CancelRequestData,
  CancelRequestError,
  CancelRequestPayload,
  CancelReservationSettlementData,
  CategoriesCreateData,
  CategoriesCreatePayload,
  CategoriesDeleteData,
  CategoriesDetailData,
  CategoriesListData,
  CategoriesTreeListData,
  CategoriesTreeListParams,
  CategoriesUpdateData,
  CategoriesUpdatePayload,
  ChangeMyPasswordData,
  ChangeMyPasswordError,
  ChangeMyPasswordPayload,
  CicdAppReleasesExistsDetailData,
  CicdAppReleasesExistsDetailParams,
  CicdAppReleasesUploadCreateData,
  CicdAppReleasesUploadCreateError,
  CicdAppReleasesUploadCreatePayload,
  CicdAppReleasesVersionInfoListData,
  CicdAppReleasesVersionInfoListParams,
  CicdStaffAppReleasesExistsDetailData,
  CicdStaffAppReleasesExistsDetailParams,
  CicdStaffAppReleasesUploadCreateData,
  CicdStaffAppReleasesUploadCreateError,
  CicdStaffAppReleasesUploadCreatePayload,
  CicdStaffAppReleasesVersionInfoListData,
  CicdStaffAppReleasesVersionInfoListParams,
  CloseEquipmentOpenRecordsData,
  CloseEquipmentOpenRecordsError,
  CompensateEquipmentRentalsData,
  CompensateEquipmentRentalsError,
  CompensateEquipmentRentalsPayload,
  ConsolidateEquipmentSerialData,
  ConsolidateEquipmentSerialError,
  ConsolidateEquipmentSerialPayload,
  CreateAreaData,
  CreateAreaError,
  CreateAreaPayload,
  CreateBookingData,
  CreateBookingError,
  CreateBookingPayload,
  CreateBookingRequestData,
  CreateBookingRequestError,
  CreateBookingRequestPayload,
  CreateCompanyContactData,
  CreateCompanyContactPayload,
  CreateCompanyData,
  CreateCompanyPayload,
  CreateCompanyPaymentProfileData,
  CreateCompanyPaymentProfilePayload,
  CreateCustomerAgreementData,
  CreateCustomerAgreementPayload,
  CreateEquipmentData,
  CreateEquipmentError,
  CreateEquipmentPayload,
  CreateEquipmentRentalData,
  CreateEquipmentRentalPayload,
  CreateEquipmentTypeData,
  CreateEquipmentTypeError,
  CreateEquipmentTypePayload,
  CreateLocationData,
  CreateLocationError,
  CreateLocationPayload,
  CreatePartnerAdminLocationData,
  CreatePartnerAdminLocationError,
  CreatePartnerAdminLocationPayload,
  CreatePartnerAdminUserData,
  CreatePartnerAdminUserError,
  CreatePartnerAdminUserPayload,
  CreatePartnerData,
  CreatePartnerError,
  CreatePartnerPayload,
  CreateRentalData,
  CreateRentalEquipmentTypeData,
  CreateRentalEquipmentTypePayload,
  CreateRentalPayload,
  CreateRequestData,
  CreateRequestError,
  CreateRequestPayload,
  CreateUserData,
  CreateUserError,
  CreateUserPayload,
  CustomerAccessoriesCheckAvailabilityCreateData,
  CustomerAccessoriesCheckAvailabilityCreateError,
  CustomerAccessoriesCheckAvailabilityCreatePayload,
  CustomerAccessoriesDetailData,
  CustomerAccessoriesDetailError,
  CustomerAccessoriesDetailParams,
  CustomerAccessoriesForEquipmentTypeDetailData,
  CustomerAccessoriesForEquipmentTypeDetailParams,
  CustomerAccessoriesListData,
  CustomerAccessoriesListParams,
  CustomerAgreementsUploadPhotosCreateData,
  CustomerAgreementsUploadPhotosCreatePayload,
  CustomerAuthForgotPasswordCreateData,
  CustomerAuthForgotPasswordCreatePayload,
  CustomerAuthLoginCreateData,
  CustomerAuthLoginCreateError,
  CustomerAuthLoginCreatePayload,
  CustomerAuthPasswordRequirementsListData,
  CustomerAuthProfileListData,
  CustomerAuthProfileListError,
  CustomerAuthProfileUpdateData,
  CustomerAuthProfileUpdateError,
  CustomerAuthProfileUpdatePayload,
  CustomerAuthRefreshCreateData,
  CustomerAuthRefreshCreateError,
  CustomerAuthRefreshCreatePayload,
  CustomerAuthRegisterCreateData,
  CustomerAuthRegisterCreateError,
  CustomerAuthRegisterCreatePayload,
  CustomerAuthResendVerificationCreateData,
  CustomerAuthResendVerificationCreatePayload,
  CustomerAuthResetPasswordCreateData,
  CustomerAuthResetPasswordCreateError,
  CustomerAuthResetPasswordCreatePayload,
  CustomerAuthVerifyEmailCreateData,
  CustomerAuthVerifyEmailCreateError,
  CustomerAuthVerifyEmailCreatePayload,
  CustomerCartAccessoriesCreateData,
  CustomerCartAccessoriesCreateError,
  CustomerCartAccessoriesCreatePayload,
  CustomerCartAccessoriesDeleteData,
  CustomerCartAccessoriesDeleteError,
  CustomerCartAccessoriesUpdateData,
  CustomerCartAccessoriesUpdateError,
  CustomerCartAccessoriesUpdatePayload,
  CustomerCartDeleteData,
  CustomerCartDeleteError,
  CustomerCartItemsCreateData,
  CustomerCartItemsCreateError,
  CustomerCartItemsCreatePayload,
  CustomerCartItemsDeleteData,
  CustomerCartItemsDeleteError,
  CustomerCartItemsPricingCreateData,
  CustomerCartItemsPricingCreateError,
  CustomerCartItemsPricingCreatePayload,
  CustomerCartItemsUpdateData,
  CustomerCartItemsUpdateError,
  CustomerCartItemsUpdatePayload,
  CustomerCartListData,
  CustomerCartPricingCreateData,
  CustomerCartPricingCreateError,
  CustomerCartPricingCreatePayload,
  CustomerCartTransferCreateData,
  CustomerCartTransferCreateError,
  CustomerCartTransferCreatePayload,
  CustomerCartValidateCreateData,
  CustomerCartValidateCreateError,
  CustomerCartValidateCreatePayload,
  CustomerCategoriesBySlugDetailData,
  CustomerCategoriesBySlugDetailError,
  CustomerCategoriesBySlugDetailParams,
  CustomerCategoriesFeaturedListData,
  CustomerCategoriesFeaturedListParams,
  CustomerCategoriesListData,
  CustomerCategoriesListParams,
  CustomerCategoriesRelatedListData,
  CustomerCategoriesRelatedListParams,
  CustomerCategoriesTreeListData,
  CustomerCategoriesTreeListParams,
  CustomerEquipmentTypesAvailableLocationsListData,
  CustomerEquipmentTypesAvailableLocationsListError,
  CustomerEquipmentTypesAvailableLocationsListParams,
  CustomerEquipmentTypesBySlugDetailData,
  CustomerEquipmentTypesBySlugDetailError,
  CustomerEquipmentTypesBySlugDetailParams,
  CustomerEquipmentTypesCategoriesListData,
  CustomerEquipmentTypesCheckAvailabilityCreateData,
  CustomerEquipmentTypesCheckAvailabilityCreateError,
  CustomerEquipmentTypesCheckAvailabilityCreatePayload,
  CustomerEquipmentTypesDetailData,
  CustomerEquipmentTypesDetailError,
  CustomerEquipmentTypesDetailParams,
  CustomerEquipmentTypesFiltersListData,
  CustomerEquipmentTypesFiltersListParams,
  CustomerEquipmentTypesListData,
  CustomerEquipmentTypesListParams,
  CustomerEquipmentTypesRelatedListData,
  CustomerEquipmentTypesRelatedListParams,
  CustomerEquipmentTypesReviewSummaryListData,
  CustomerEquipmentTypesReviewSummaryListError,
  CustomerEquipmentTypesReviewsListData,
  CustomerEquipmentTypesReviewsListError,
  CustomerEquipmentTypesReviewsListParams,
  CustomerEventsBatchCreateData,
  CustomerEventsBatchCreateError,
  CustomerEventsBatchCreatePayload,
  CustomerEventsCreateData,
  CustomerEventsCreateError,
  CustomerEventsCreatePayload,
  CustomerEventsHealthListData,
  CustomerFlightsArrivalsListData,
  CustomerFlightsArrivalsListParams,
  CustomerFlightsDeparturesListData,
  CustomerFlightsDeparturesListParams,
  CustomerLocationsBySlugDetailData,
  CustomerLocationsBySlugDetailError,
  CustomerLocationsBySlugDetailParams,
  CustomerLocationsCurrencyDetailData,
  CustomerLocationsDeliveryQuoteCreateData,
  CustomerLocationsDeliveryQuoteCreateError,
  CustomerLocationsDeliveryQuoteCreatePayload,
  CustomerLocationsDeliverySearchCreateData,
  CustomerLocationsDeliverySearchCreateError,
  CustomerLocationsDeliverySearchCreatePayload,
  CustomerLocationsDetailData,
  CustomerLocationsDetailError,
  CustomerLocationsDetailParams,
  CustomerLocationsFeaturedListData,
  CustomerLocationsFeaturedListParams,
  CustomerLocationsListData,
  CustomerLocationsListParams,
  CustomerMonthlyRentalsCancelCreateData,
  CustomerMonthlyRentalsCancelCreateError,
  CustomerMonthlyRentalsCancelCreatePayload,
  CustomerMonthlyRentalsDetailData,
  CustomerMonthlyRentalsDetailError,
  CustomerMonthlyRentalsListData,
  CustomerMonthlyRentalsListError,
  CustomerMonthlyRentalsPreviewCancellationListData,
  CustomerMonthlyRentalsPreviewCancellationListError,
  CustomerMonthlyRentalsReconcilePenaltyCreateData,
  CustomerMonthlyRentalsReconcilePenaltyCreateError,
  CustomerMonthlyRentalsReconcilePenaltyCreatePayload,
  CustomerMonthlyRentalsUpdatePaymentMethodCreateData,
  CustomerMonthlyRentalsUpdatePaymentMethodCreateError,
  CustomerMonthlyRentalsUpdatePaymentMethodCreatePayload,
  CustomerOrdersViewDetailData,
  CustomerOrdersViewDetailError,
  CustomerPaymentsConfigListData,
  CustomerPaymentsCreateIntentCreateData,
  CustomerPaymentsCreateIntentCreateError,
  CustomerPaymentsCreateIntentCreatePayload,
  CustomerPaymentsCreateIntentCustomCreateData,
  CustomerPaymentsCreateIntentCustomCreateError,
  CustomerPaymentsCreateIntentCustomCreatePayload,
  CustomerPaymentsPaymentMethodsDefaultCreateData,
  CustomerPaymentsPaymentMethodsDefaultCreateError,
  CustomerPaymentsPaymentMethodsDeleteData,
  CustomerPaymentsPaymentMethodsDeleteError,
  CustomerPaymentsPaymentMethodsListData,
  CustomerPaymentsReconcileCreateData,
  CustomerPaymentsReconcileCreateError,
  CustomerPaymentsReconcileCreatePayload,
  CustomerPaymentsSetupIntentCreateData,
  CustomerPaymentsSetupIntentCreateError,
  CustomerPaymentsSetupIntentCreatePayload,
  CustomerPaymentsStatusListData,
  CustomerPaymentsStatusListError,
  CustomerPaymentsStatusListParams,
  CustomerPaymentsSubscriptionsCancelCreateData,
  CustomerPaymentsSubscriptionsCancelCreateError,
  CustomerPaymentsSubscriptionsCancelCreatePayload,
  CustomerPaymentsSubscriptionsCancellationPreviewListData,
  CustomerPaymentsSubscriptionsCancellationPreviewListError,
  CustomerPaymentsSubscriptionsCreateData,
  CustomerPaymentsSubscriptionsCreateError,
  CustomerPaymentsSubscriptionsCreatePayload,
  CustomerPaymentsSubscriptionsPaymentMethodUpdateData,
  CustomerPaymentsSubscriptionsPaymentMethodUpdateError,
  CustomerPaymentsSubscriptionsPaymentMethodUpdatePayload,
  CustomerPaymentsSubscriptionsStatusListData,
  CustomerPaymentsSubscriptionsStatusListError,
  CustomerPricingCalculateCartCreateData,
  CustomerPricingCalculateCartCreateError,
  CustomerPricingCalculateCartCreatePayload,
  CustomerPricingCalculateItemCreateData,
  CustomerPricingCalculateItemCreateError,
  CustomerPricingCalculateItemCreatePayload,
  CustomerPricingValidateCartCreateData,
  CustomerPricingValidateCartCreateError,
  CustomerPricingValidateCartCreatePayload,
  CustomerPromoCodesValidateCreateData,
  CustomerPromoCodesValidateCreatePayload,
  CustomerPurchaseQuotesBookingDetailData,
  CustomerPurchaseQuotesBookingDetailError,
  CustomerPurchaseQuotesRequestCreateData,
  CustomerPurchaseQuotesRequestCreateError,
  CustomerPurchaseQuotesRequestCreatePayload,
  CustomerReservationsAgreementListData,
  CustomerReservationsAgreementListError,
  CustomerReservationsCancelCreateData,
  CustomerReservationsCancelCreateError,
  CustomerReservationsCancelCreatePayload,
  CustomerReservationsDetailData,
  CustomerReservationsDetailError,
  CustomerReservationsExtendCreateData,
  CustomerReservationsExtendCreateError,
  CustomerReservationsExtendCreatePayload,
  CustomerReservationsInvoiceListData,
  CustomerReservationsInvoiceListError,
  CustomerReservationsInvoicePdfListData,
  CustomerReservationsInvoicePdfListError,
  CustomerReservationsListData,
  CustomerReservationsListError,
  CustomerReservationsListParams,
  CustomerReservationsResumeDetailData,
  CustomerReservationsResumeDetailError,
  CustomerReservationsSchedulePartialUpdateData,
  CustomerReservationsSchedulePartialUpdateError,
  CustomerReservationsSchedulePartialUpdatePayload,
  CustomerReviewsCreateData,
  CustomerReviewsCreateError,
  CustomerReviewsCreatePayload,
  CustomerReviewsReservationDetailData,
  CustomerReviewsReservationDetailError,
  CustomerReviewsUpdateData,
  CustomerReviewsUpdateError,
  CustomerReviewsUpdatePayload,
  CustomerSessionInitCreateData,
  CustomerTicketsCreateData,
  CustomerTicketsCreateError,
  CustomerTicketsCreatePayload,
  CustomerTicketsDetailData,
  CustomerTicketsDetailError,
  CustomerTicketsMessagesCreateData,
  CustomerTicketsMessagesCreateError,
  CustomerTicketsMessagesCreatePayload,
  CustomerTicketsReservationDetailData,
  CustomerTicketsReservationDetailError,
  DamageReportsActiveListData,
  DamageReportsActiveListParams,
  DamageReportsEquipmentCreateData,
  DamageReportsEquipmentCreatePayload,
  DamageReportsResolveCreateData,
  DamageReportsResolveCreatePayload,
  DayOffsBulkCreateData,
  DayOffsBulkCreateError,
  DayOffsBulkCreatePayload,
  DayOffsCreateData,
  DayOffsCreateError,
  DayOffsCreatePayload,
  DayOffsDeleteData,
  DayOffsDeleteError,
  DayOffsMyListData,
  DayOffsMyListParams,
  DayOffsTeamDetailData,
  DayOffsTeamDetailParams,
  DeactivateCustomerData,
  DeactivateCustomerError,
  DeactivatePartnerAdminUserData,
  DeactivatePartnerAdminUserError,
  DeactivatePartnerData,
  DeactivatePartnerError,
  DeactivateUserData,
  DeactivateUserError,
  DeleteCompanyData,
  DeleteCompanyPaymentProfileData,
  DeleteCompanyPaymentProfileError,
  DeleteCustomerAgreementData,
  DeleteEquipmentData,
  DeleteEquipmentTypeData,
  DeleteEquipmentTypeError,
  DeleteLocationData,
  DeleteLocationError,
  DeleteUserData,
  DeleteUserError,
  EmailTemplatesActivateCreateData,
  EmailTemplatesActivateCreateError,
  EmailTemplatesCreateData,
  EmailTemplatesCreateError,
  EmailTemplatesCreatePayload,
  EmailTemplatesDeactivateCreateData,
  EmailTemplatesDeactivateCreateError,
  EmailTemplatesDeleteData,
  EmailTemplatesDeleteError,
  EmailTemplatesDetailData,
  EmailTemplatesDetailError,
  EmailTemplatesDuplicateCreateData,
  EmailTemplatesDuplicateCreateError,
  EmailTemplatesFlowsListData,
  EmailTemplatesHistoryDetailData,
  EmailTemplatesListData,
  EmailTemplatesListParams,
  EmailTemplatesPreviewListData,
  EmailTemplatesPreviewListError,
  EmailTemplatesRenderPreviewCreateData,
  EmailTemplatesRenderPreviewCreateError,
  EmailTemplatesRenderPreviewCreatePayload,
  EmailTemplatesStarterTemplatesListData,
  EmailTemplatesTestSendCreateData,
  EmailTemplatesTestSendCreateError,
  EmailTemplatesTestSendCreatePayload,
  EmailTemplatesUpdateData,
  EmailTemplatesUpdateError,
  EmailTemplatesUpdatePayload,
  EmployeeContractsDetailData,
  EmployeeContractsUpdateData,
  EmployeeContractsUpdatePayload,
  EmployeeTeamsDetailData,
  EmployeeTeamsDetailError,
  EmployeeTeamsListData,
  EquipmentSalesAdminForSaleListData,
  EquipmentSalesAdminForSaleListParams,
  EquipmentSalesAdminMarkForSaleCreateData,
  EquipmentSalesAdminMarkForSaleCreateError,
  EquipmentSalesAdminMarkForSaleCreatePayload,
  EquipmentSalesAdminMarkForSaleDeleteData,
  EquipmentSalesAdminMarkForSaleDeleteError,
  EquipmentSalesAdminReleaseSaleCreateData,
  EquipmentSalesAdminReleaseSaleCreateError,
  EquipmentSalesCustomerForSaleListData,
  EquipmentSalesCustomerForSaleListParams,
  EquipmentSalesCustomerPriceListData,
  EquipmentSalesCustomerPriceListError,
  EquipmentSalesCustomerPurchaseCreateData,
  EquipmentSalesCustomerPurchaseCreateError,
  EquipmentSalesCustomerPurchaseCreatePayload,
  EquipmentTypesCatalogueReorderUpdateData,
  EquipmentTypesCatalogueReorderUpdateError,
  EquipmentTypesCatalogueReorderUpdatePayload,
  EquipmentTypesImagesCreateData,
  EquipmentTypesImagesCreateError,
  EquipmentTypesImagesCreatePayload,
  EquipmentTypesImagesDeleteData,
  EquipmentTypesImagesDeleteError,
  EquipmentTypesImagesDeleteParams,
  EquipmentTypesLocationPricingCopyDefaultsCreateData,
  EquipmentTypesLocationPricingDeleteData,
  EquipmentTypesLocationPricingDetailData,
  EquipmentTypesLocationPricingDetailError,
  EquipmentTypesLocationPricingListData,
  EquipmentTypesLocationPricingUpdateData,
  EquipmentTypesLocationPricingUpdatePayload,
  EquipmentTypesLowestPriceListData,
  EquipmentTypesRelatedCreateError,
  EquipmentTypesRelatedCreatePayload,
  EquipmentTypesRelatedDeleteError,
  EquipmentTypesRelatedReorderUpdateData,
  EquipmentTypesRelatedReorderUpdatePayload,
  ExecuteBulkCancelStaleData,
  ExecuteBulkCancelStaleError,
  ExecuteBulkCancelStalePayload,
  ExportEquipmentRentalsData,
  ExportEquipmentRentalsError,
  ExportEquipmentRentalsParams,
  ExportEquipmentsData,
  ExportEquipmentsError,
  ExportEquipmentsParams,
  ExtractExcelHeadersData,
  ExtractExcelHeadersError,
  ExtractExcelHeadersPayload,
  FixDuplicatedRentalsData,
  FixDuplicatedRentalsParams,
  FixEquipmentWrongLocationData,
  FixEquipmentWrongLocationError,
  FixEquipmentWrongStatusData,
  FixEquipmentWrongStatusError,
  ForgotPasswordData,
  ForgotPasswordPayload,
  GenerateApiKeyData,
  GenerateBookingPaymentLinkData,
  GenerateBookingPaymentLinkError,
  GenerateBookingPaymentLinkPayload,
  GetAccessibleAreasData,
  GetAccessibleAreasParams,
  GetAccessibleLocationsData,
  GetAccessibleLocationsParams,
  GetAccessibleRentalsData,
  GetAdminStrandedCountsByLocationData,
  GetAdminStrandedCountsByLocationParams,
  GetAdminStrandedRentalsData,
  GetAdminStrandedRentalsParams,
  GetAllLocationsData,
  GetAllLocationsParams,
  GetAreaData,
  GetAreaError,
  GetAreasData,
  GetAreasParams,
  GetBookingByEquipmentData,
  GetBookingData,
  GetBookingModificationsData,
  GetBookingModificationsError,
  GetBookingPaymentData,
  GetBookingPaymentQuoteData,
  GetBookingRequestData,
  GetBookingRequestsData,
  GetBookingRequestsParams,
  GetBookingsData,
  GetBookingsForRentalData,
  GetBookingsForRentalParams,
  GetBookingsParams,
  GetBookingsStatisticsData,
  GetBookingsStatisticsParams,
  GetCleaningLogsData,
  GetCleaningLogsParams,
  GetCompaniesData,
  GetCompanyBillingReadinessData,
  GetCompanyContactByIdData,
  GetCompanyContactsData,
  GetCompanyContactsParams,
  GetCompanyData,
  GetCompensationCandidatesData,
  GetCompensationCandidatesParams,
  GetCurrentUserAreasData,
  GetCurrentUserData,
  GetCurrentUserError,
  GetCurrentUserRentalsData,
  GetCurrentUserTeamsData,
  GetCustomerAgreementByBookingEquipmentIdData,
  GetCustomerAgreementsByBookingIdData,
  GetCustomerDetailData,
  GetCustomerDetailError,
  GetCustomersData,
  GetCustomersParams,
  GetDocumentationGuideData,
  GetDocumentationGuideError,
  GetDocumentationIndexData,
  GetDocumentationSpecData,
  GetDocumentationSpecError,
  GetEquipmentBookingsData,
  GetEquipmentByCodeData,
  GetEquipmentByCodeError,
  GetEquipmentByIdData,
  GetEquipmentByIdError,
  GetEquipmentCleaningLogsData,
  GetEquipmentCleaningLogsParams,
  GetEquipmentData,
  GetEquipmentForecastDemandData,
  GetEquipmentForecastDemandError,
  GetEquipmentForecastDemandParams,
  GetEquipmentForecastPartnerRentalsData,
  GetEquipmentForecastPartnerRentalsError,
  GetEquipmentForecastPartnerRentalsParams,
  GetEquipmentForecastSummaryData,
  GetEquipmentForecastSummaryError,
  GetEquipmentForecastSummaryParams,
  GetEquipmentGraveyardData,
  GetEquipmentGraveyardParams,
  GetEquipmentLocationLogsData,
  GetEquipmentLocationLogsParams,
  GetEquipmentMappableFieldsData,
  GetEquipmentNeedingCleaningData,
  GetEquipmentNeedingCleaningParams,
  GetEquipmentParams,
  GetEquipmentRentalData,
  GetEquipmentRentalMovementsData,
  GetEquipmentRentalsData,
  GetEquipmentRentalsParams,
  GetEquipmentScanEventsData,
  GetEquipmentScanEventsParams,
  GetEquipmentStatusesData,
  GetEquipmentTypeData,
  GetEquipmentTypeError,
  GetEquipmentTypeStockData,
  GetEquipmentTypeStockError,
  GetEquipmentTypesByLocationData,
  GetEquipmentTypesData,
  GetEquipmentTypesParams,
  GetFuseNavigationData,
  GetItemsWithWrongLocationOrStatusData,
  GetItemsWithWrongLocationOrStatusParams,
  GetLastRecordGoFileUploadData,
  GetLastSixtFileUploadData,
  GetLoanedEquipmentData,
  GetLoanedEquipmentParams,
  GetLocationCatalogueOrderData,
  GetLocationCatalogueOrderError,
  GetLocationData,
  GetLocationError,
  GetLocationsData,
  GetLocationsError,
  GetLocationsParams,
  GetNextContractReferenceData,
  GetNextData,
  GetNextEquipmentReturnsData,
  GetNextEquipmentReturnsParams,
  GetNextParams,
  GetOverdueReturnsData,
  GetOverdueReturnsParams,
  GetParentLocationsData,
  GetPartnerAdminDashboardSummaryData,
  GetPartnerAdminDashboardSummaryError,
  GetPartnerAdminDashboardSummaryParams,
  GetPartnerAdminEquipmentRentalsData,
  GetPartnerAdminEquipmentRentalsError,
  GetPartnerAdminEquipmentRentalsParams,
  GetPartnerAdminLocationsData,
  GetPartnerAdminLocationsError,
  GetPartnerAdminStrandedCountsByLocationData,
  GetPartnerAdminStrandedCountsByLocationError,
  GetPartnerAdminStrandedCountsByLocationParams,
  GetPartnerAdminStrandedRentalsData,
  GetPartnerAdminStrandedRentalsError,
  GetPartnerAdminStrandedRentalsParams,
  GetPartnerAdminUserDetailData,
  GetPartnerAdminUserDetailError,
  GetPartnerAdminUsersData,
  GetPartnerAdminUsersParams,
  GetPartnerDetailData,
  GetPartnerDetailError,
  GetPartnerRentalCompanyBreakdownData,
  GetPartnerRentalCompanyBreakdownError,
  GetPartnerRentalCompanyBreakdownParams,
  GetPartnersData,
  GetPartnersParams,
  GetPendingPickupBookingsData,
  GetPendingPickupBookingsParams,
  GetPendingRefundsData,
  GetPendingRefundsParams,
  GetPendingReturnBookingsData,
  GetPendingReturnBookingsParams,
  GetPotentiallyMissingReturnsData,
  GetPotentiallyMissingReturnsParams,
  GetRecentEmailTemplateImagesData,
  GetRecentEmailTemplateImagesParams,
  GetRelatedLocationsData,
  GetReleaseNameData,
  GetRentalBookingStatsData,
  GetRentalBookingsData,
  GetRentalBookingsParams,
  GetRentalByIdData,
  GetRentalEquipmentData,
  GetRentalEquipmentParams,
  GetRentalEquipmentStatsData,
  GetRentalEquipmentStatsParams,
  GetRentalEquipmentTypesData,
  GetRentalStockStatsData,
  GetRentalStockStatsParams,
  GetRentalsByNameData,
  GetRentalsData,
  GetRentalsParams,
  GetRentedEquipmentData,
  GetRentedEquipmentParams,
  GetRequestData,
  GetRequestError,
  GetRequestModificationsData,
  GetRequestModificationsError,
  GetRequestsData,
  GetRequestsParams,
  GetReservationSettlementData,
  GetReservationShortageForecastData,
  GetReservationShortageForecastParams,
  GetReservationShortagesData,
  GetReturnedBookingsData,
  GetReturnedBookingsParams,
  GetReturnsToDiffRentalData,
  GetReturnsToDiffRentalParams,
  GetRolesData,
  GetRunningListData,
  GetRunningListParams,
  GetScanSessionData,
  GetScanSessionsData,
  GetScanSessionsParams,
  GetScopeData,
  GetScopeError,
  GetSingleAndSublocationsData,
  GetSingleAndSublocationsError,
  GetSingleAndSublocationsParams,
  GetStatsData,
  GetStatsParams,
  GetTimezonesData,
  GetUnaccountedRentedItemsData,
  GetUnaccountedRentedItemsParams,
  GetUserData,
  GetUserError,
  GetUsersData,
  GetUsersParams,
  GetWarehousesData,
  GetWarehousesError,
  GetWebsiteOrderDetailData,
  GetWebsiteOrdersData,
  GetWebsiteOrdersParams,
  HaccpSummaryListData,
  HaccpSummaryListParams,
  LocalizationBundlesActivateCreateData,
  LocalizationBundlesActivateCreatePayload,
  LocalizationBundlesRebuildCreateData,
  LocalizationBundlesSeedCreateData,
  LocalizationBundlesStagedListData,
  LocalizationLocalesCategoriesTranslationListData,
  LocalizationLocalesCategoriesTranslationUpdateData,
  LocalizationLocalesCategoriesTranslationUpdatePayload,
  LocalizationLocalesCreateData,
  LocalizationLocalesCreatePayload,
  LocalizationLocalesDictionaryEntriesBatchUpdateData,
  LocalizationLocalesDictionaryEntriesBatchUpdatePayload,
  LocalizationLocalesDictionaryEntriesListData,
  LocalizationLocalesDictionaryEntriesUpdateData,
  LocalizationLocalesDictionaryEntriesUpdatePayload,
  LocalizationLocalesDictionaryTranslationsImportCreateData,
  LocalizationLocalesDictionaryTranslationsImportCreatePayload,
  LocalizationLocalesDictionaryTranslationsListData,
  LocalizationLocalesEquipmentTypesTranslationListData,
  LocalizationLocalesEquipmentTypesTranslationUpdateData,
  LocalizationLocalesEquipmentTypesTranslationUpdatePayload,
  LocalizationLocalesListData,
  LocalizationLocalesLocationsTranslationListData,
  LocalizationLocalesLocationsTranslationUpdateData,
  LocalizationLocalesLocationsTranslationUpdatePayload,
  LocalizationLocalesPublishCreateData,
  LocalizationLocalesPublishCreatePayload,
  LocalizationLocalesReadinessListData,
  LocalizationLocalesTranslationSuggestionsCreateData,
  LocalizationLocalesTranslationSuggestionsCreatePayload,
  LoginData,
  LoginPayload,
  ManagerTeamsDetailData,
  ManagerTeamsDetailError,
  ManagerTeamsListData,
  ManagerTeamsMembersCreateData,
  ManagerTeamsMembersCreateError,
  ManagerTeamsMembersCreatePayload,
  ManagerTeamsMembersDeleteData,
  ManagerTeamsMembersDeleteError,
  ManagerUsersCreateData,
  ManagerUsersCreateError,
  ManagerUsersCreatePayload,
  ManagerUsersListData,
  ManagerUsersListParams,
  ManagerUsersResetPasswordCreateData,
  ManagerUsersResetPasswordCreateError,
  ManagerUsersUpdateData,
  ManagerUsersUpdateError,
  ManagerUsersUpdatePayload,
  MarkAsPresentData,
  MarkAsReturnedData,
  MarkAsReturnedPayload,
  MarkEquipmentAsCleanedData,
  MarkEquipmentAsCleanedError,
  MarkEquipmentAsCleanedPayload,
  MigrateCustomerRolesData,
  MigrateUserRecordsData,
  MigrateUserRecordsError,
  MigrateUserRecordsPayload,
  MissingItemsActiveListData,
  MissingItemsBookingCreateData,
  MissingItemsBookingCreatePayload,
  MissingItemsBookingDetailData,
  MissingItemsEquipmentRentalCreateData,
  MissingItemsEquipmentRentalCreatePayload,
  MissingItemsEquipmentRentalDetailData,
  MissingItemsItemCreateData,
  MissingItemsItemCreatePayload,
  MissingItemsItemDetailData,
  MissingItemsRecoverCreateData,
  MissingItemsRecoverCreatePayload,
  MissingItemsReportsActiveExportListData,
  MissingItemsReportsActiveExportListParams,
  MissingItemsReportsActiveListData,
  MissingItemsReportsActiveListParams,
  MoveEquipmentData,
  MoveEquipmentPayload,
  NotificationsFailedListData,
  NotificationsFailedListParams,
  NotificationsRetryCreateData,
  NotificationsRetryCreateError,
  PageContentCreateData,
  PageContentCreatePayload,
  PageContentDeleteData,
  PageContentGetAllData,
  PageContentGetByIdData,
  PageContentGetPageSectionData,
  PageContentGetPageSectionParams,
  PageContentUpdateData,
  PageContentUpdatePayload,
  PartnerAppReleasesDownloadListData,
  PartnerAppReleasesDownloadListError,
  PartnerAppVersionListData,
  PartnerAppVersionListParams,
  PartnerConfirmCreateData,
  PartnerConfirmCreateError,
  PartnerConfirmCreatePayload,
  PartnerContentSectionsCreateData,
  PartnerContentSectionsCreatePayload,
  PartnerContentSectionsDeleteData,
  PartnerContentSectionsDetailData,
  PartnerContentSectionsImageCreateData,
  PartnerContentSectionsImageCreatePayload,
  PartnerContentSectionsImageDeleteData,
  PartnerContentSectionsKeyDetailData,
  PartnerContentSectionsListData,
  PartnerContentSectionsListParams,
  PartnerContentSectionsUpdateData,
  PartnerContentSectionsUpdatePayload,
  PartnerEquipmentListData,
  PartnerEquipmentListError,
  PartnerEquipmentListParams,
  PartnerInquiryCreateData,
  PartnerInquiryCreatePayload,
  PartnerLocationListData,
  PartnerLocationListError,
  PartnerLocationsListData,
  PartnerScanCreateData,
  PartnerScanCreateError,
  PartnerScanCreatePayload,
  PartnerScanHistoryListData,
  PartnerScanHistoryListParams,
  PartnerUpdateLogCreateData,
  PartnerUpdateLogCreateError,
  PartnerUpdateLogCreatePayload,
  PickUpBookingData,
  PickUpBookingParams,
  PreviewBookingPickupData,
  PreviewBookingPickupPayload,
  PreviewBulkCancelStaleData,
  PreviewBulkCancelStaleError,
  PreviewBulkCancelStalePayload,
  PreviewScanSessionSweepData,
  PreviewScanSessionSweepPayload,
  PricingBreakdownCreateData,
  PricingBreakdownCreatePayload,
  PricingCalculateCartCreateData,
  PricingCalculateCartCreatePayload,
  PricingCalculateItemCreateData,
  PricingCalculateItemCreatePayload,
  ProcessLocationRentalDropData,
  ProcessLocationRentalDropPayload,
  ProcessLocationRentalReturnsData,
  ProcessLocationRentalReturnsPayload,
  ProcessLocationRentalsPresentData,
  ProcessLocationRentalsPresentPayload,
  ProcessRefundData,
  ProcessRefundPayload,
  PublicPartnersCategoriesListData,
  PublicPartnersInquiriesCreateData,
  PublicPartnersInquiriesCreatePayload,
  PublicPartnersListData,
  PublicPartnersSectionsDetailData,
  PublicPartnersSectionsListData,
  PushSubscriptionsDeleteData,
  PushSubscriptionsDeleteError,
  PushSubscriptionsDeleteParams,
  PushSubscriptionsUpdateData,
  PushSubscriptionsUpdateError,
  PushSubscriptionsUpdatePayload,
  PushSubscriptionsVapidPublicKeyListData,
  QuoteReservationSettlementData,
  QuoteReservationSettlementPayload,
  ReactivateUserData,
  ReactivateUserError,
  RecordDepositDeductionData,
  RecordDepositDeductionPayload,
  RefreshReservationSettlementData,
  RefreshTokenData,
  RentalsEquipmentTypesStockDetailData,
  RentalsEquipmentTypesStockDetailError,
  RentalsEquipmentTypesStockDetailParams,
  ReportsBookingActivityExcelListData,
  ReportsBookingActivityExcelListParams,
  ReportsCompanyBookingsExcelListData,
  ReportsCompanyBookingsExcelListParams,
  ReportsCompanyCurrentRentalItemsExcelListData,
  ReportsCompanyCurrentRentalItemsExcelListParams,
  ReportsCompanyRentalItemsExcelListData,
  ReportsCompanyRentalItemsExcelListParams,
  ReportsEquipmentDemandForecastExcelListData,
  ReportsEquipmentDemandForecastExcelListParams,
  ReportsRentalItemsNotReturnedExcelListData,
  ReportsRentalItemsNotReturnedExcelListParams,
  ReportsRentalsEquipmentTypesExcelListData,
  ReportsRentalsEquipmentTypesExcelListParams,
  ReportsRentalsEquipmentTypesListData,
  ReportsRentalsEquipmentTypesListParams,
  ReportsUnpickedRequestsExcelListData,
  ReportsUnpickedRequestsExcelListParams,
  ReportsUnseenRentalItemsExcelListData,
  ReportsUnseenRentalItemsExcelListParams,
  ResendReservationSettlementData,
  ResendReservationSettlementPayload,
  ResetEquipmentToWarehouseData,
  ResetEquipmentToWarehouseError,
  ResetEquipmentToWarehousePayload,
  ResetLocationCatalogueOrderData,
  ResetLocationCatalogueOrderError,
  ResetPartnerAdminUserPasswordData,
  ResetPartnerAdminUserPasswordError,
  ResetPartnerPasswordData,
  ResetPartnerPasswordError,
  ResetPasswordData,
  ResetPasswordError,
  ResetPasswordPayload,
  RestoreEquipmentData,
  RestoreEquipmentError,
  RestoreLocationData,
  RestoreLocationError,
  ReturnBookingData,
  ReturnBookingPayload,
  SaveLocationCatalogueOrderData,
  SaveLocationCatalogueOrderError,
  SaveLocationCatalogueOrderPayload,
  SaveReservationSettlementData,
  SaveReservationSettlementPayload,
  SavedBlocksCreateData,
  SavedBlocksCreateError,
  SavedBlocksCreatePayload,
  SavedBlocksDeleteData,
  SavedBlocksDeleteError,
  SavedBlocksDetailData,
  SavedBlocksDetailError,
  SavedBlocksListData,
  SavedBlocksListParams,
  SavedBlocksUpdateData,
  SavedBlocksUpdateError,
  SavedBlocksUpdatePayload,
  ScanData,
  ScanParams,
  ScanSerialNumberData,
  SearchBookingData,
  SearchEquipmentItemsData,
  SearchEquipmentItemsParams,
  SetLocationAliasData,
  SetLocationAliasError,
  SetLocationAliasPayload,
  SetPartnerAdminLocationAliasData,
  SetPartnerAdminLocationAliasError,
  SetPartnerAdminLocationAliasPayload,
  SetScopeData,
  SetScopePayload,
  ShiftsAllListData,
  ShiftsAllListParams,
  ShiftsBulkCreateData,
  ShiftsBulkCreateError,
  ShiftsBulkCreatePayload,
  ShiftsCopyMonthCreateData,
  ShiftsCopyMonthCreateError,
  ShiftsCopyMonthCreatePayload,
  ShiftsCopyWeekForwardCreateData,
  ShiftsCopyWeekForwardCreateError,
  ShiftsCopyWeekForwardCreatePayload,
  ShiftsCreateData,
  ShiftsCreateError,
  ShiftsCreatePayload,
  ShiftsDeleteData,
  ShiftsDeleteError,
  ShiftsDetailData,
  ShiftsDetailError,
  ShiftsLinkCreateData,
  ShiftsLinkCreateError,
  ShiftsLinkCreatePayload,
  ShiftsMyCreateData,
  ShiftsMyCreateError,
  ShiftsMyCreatePayload,
  ShiftsMyDeleteData,
  ShiftsMyDeleteError,
  ShiftsMyListData,
  ShiftsMyListParams,
  ShiftsMyTeamsListData,
  ShiftsMyTeamsListParams,
  ShiftsMyUpdateData,
  ShiftsMyUpdateError,
  ShiftsMyUpdatePayload,
  ShiftsTeamDetailData,
  ShiftsTeamDetailParams,
  ShiftsUpdateData,
  ShiftsUpdateError,
  ShiftsUpdatePayload,
  SingleAndSublocationsData,
  SingleAndSublocationsParams,
  SocialMediaAccountsActiveListData,
  SocialMediaAccountsCreateData,
  SocialMediaAccountsCreatePayload,
  SocialMediaAccountsDeleteData,
  SocialMediaAccountsDetailData,
  SocialMediaAccountsListData,
  SocialMediaAccountsUpdateData,
  SocialMediaAccountsUpdatePayload,
  StaffAppReleasesDownloadListData,
  StaffAppReleasesDownloadListError,
  StaffAppVersionListData,
  StaffAppVersionListParams,
  StaffUpdateLogCreateData,
  StaffUpdateLogCreateError,
  StaffUpdateLogCreatePayload,
  SubmitScanSessionData,
  SubmitScanSessionPayload,
  TeamsCreateData,
  TeamsCreateError,
  TeamsCreatePayload,
  TeamsDeleteData,
  TeamsDeleteError,
  TeamsDetailData,
  TeamsDetailError,
  TeamsHoursSummaryListData,
  TeamsHoursSummaryListParams,
  TeamsListData,
  TeamsListParams,
  TeamsManagersCreateCreateData,
  TeamsManagersCreateCreateError,
  TeamsManagersCreateCreatePayload,
  TeamsManagersCreateData,
  TeamsManagersCreateError,
  TeamsManagersCreatePayload,
  TeamsManagersDeleteData,
  TeamsManagersDeleteError,
  TeamsMembersCreateCreateData,
  TeamsMembersCreateCreateError,
  TeamsMembersCreateCreatePayload,
  TeamsMembersCreateData,
  TeamsMembersCreateError,
  TeamsMembersCreatePayload,
  TeamsMembersDeleteData,
  TeamsMembersDeleteError,
  TeamsOvertimeListData,
  TeamsOvertimeListParams,
  TeamsUpdateData,
  TeamsUpdateError,
  TeamsUpdatePayload,
  TimeEntriesActiveListData,
  TimeEntriesAllListData,
  TimeEntriesAllListParams,
  TimeEntriesClockInCreateData,
  TimeEntriesClockInCreateError,
  TimeEntriesClockInCreatePayload,
  TimeEntriesClockOutCreateData,
  TimeEntriesClockOutCreateError,
  TimeEntriesClockOutCreatePayload,
  TimeEntriesCorrectionProofCreateData,
  TimeEntriesCorrectionProofCreateError,
  TimeEntriesCorrectionProofCreatePayload,
  TimeEntriesDetailData,
  TimeEntriesDetailError,
  TimeEntriesExportListData,
  TimeEntriesExportListParams,
  TimeEntriesManualCreateData,
  TimeEntriesManualCreateError,
  TimeEntriesManualCreatePayload,
  TimeEntriesMyListData,
  TimeEntriesMyListParams,
  TimeEntriesTeamDetailData,
  TimeEntriesTeamDetailParams,
  TimeEntriesUpdateData,
  TimeEntriesUpdateError,
  TimeEntriesUpdatePayload,
  UncancelBookingRequestData,
  UncancelBookingRequestError,
  UncancelRequestData,
  UncancelRequestError,
  UndoEquipmentMovementData,
  UndoEquipmentMovementError,
  UndoPickupData,
  UndoPickupError,
  UnreturnBookingData,
  UnreturnBookingError,
  UnreturnBookingPayload,
  UpdateAreaData,
  UpdateAreaError,
  UpdateAreaPayload,
  UpdateBookingData,
  UpdateBookingError,
  UpdateBookingPayload,
  UpdateBookingRequestData,
  UpdateBookingRequestError,
  UpdateBookingRequestPayload,
  UpdateCompanyContactData,
  UpdateCompanyContactPayload,
  UpdateCompanyData,
  UpdateCompanyPayload,
  UpdateCompanyPaymentProfileData,
  UpdateCompanyPaymentProfilePayload,
  UpdateCurrentUserData,
  UpdateCurrentUserError,
  UpdateCurrentUserPayload,
  UpdateCustomerAgreementData,
  UpdateCustomerAgreementPayload,
  UpdateEquipmentCompensationData,
  UpdateEquipmentCompensationError,
  UpdateEquipmentCompensationPayload,
  UpdateEquipmentData,
  UpdateEquipmentError,
  UpdateEquipmentPayload,
  UpdateEquipmentRentalData,
  UpdateEquipmentRentalPayload,
  UpdateEquipmentTypeData,
  UpdateEquipmentTypeError,
  UpdateEquipmentTypePayload,
  UpdateEquipmentTypePricingData,
  UpdateEquipmentTypePricingError,
  UpdateEquipmentTypePricingPayload,
  UpdateLocationData,
  UpdateLocationError,
  UpdateLocationPayload,
  UpdatePartnerAdminLocationData,
  UpdatePartnerAdminLocationError,
  UpdatePartnerAdminLocationPayload,
  UpdatePartnerAdminUserData,
  UpdatePartnerAdminUserError,
  UpdatePartnerAdminUserPayload,
  UpdatePartnerData,
  UpdatePartnerError,
  UpdatePartnerPayload,
  UpdateRentalData,
  UpdateRentalEquipmentTypeData,
  UpdateRentalEquipmentTypePayload,
  UpdateRentalPayload,
  UpdateRequestData,
  UpdateRequestError,
  UpdateRequestPayload,
  UpdateUserData,
  UpdateUserError,
  UpdateUserPayload,
  UploadEmailTemplateImageData,
  UploadEmailTemplateImageError,
  UploadEmailTemplateImagePayload,
  UploadImageData,
  UploadImageError,
  UploadImagePayload,
  UploadLocationEquipmentFileData,
  UploadLocationEquipmentFilePayload,
  UploadLocationImageData,
  UploadLocationImageError,
  UploadLocationImagePayload,
  UploadMappedLocationEquipmentFileData,
  UploadMappedLocationEquipmentFileError,
  UploadMappedLocationEquipmentFilePayload,
  UploadProductImageData,
  UploadProductImageError,
  UploadProductImagePayload,
  UploadRecordGoFileData,
  UploadRecordGoFilePayload,
  UploadSixtReservationsFileData,
  UploadSixtReservationsFilePayload,
  VoidBookingPaymentLinkData,
  VoidBookingPaymentLinkError,
  WebhooksStripeCreateData,
  WebhooksStripeCreateError,
  WebhooksStripeEventsListData,
  WebhooksStripeHealthListData,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Accessories
   * @name AccessoriesList
   * @summary Returns all accessory types with their pricing tiers, deposit settings, and item counts.
   * @request GET:/api/accessories
   * @secure
   */
  accessoriesList = (params: RequestParams = {}) =>
    this.request<AccessoriesListData, any>({
      path: `/api/accessories`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Accessories
   * @name AccessoriesCreate
   * @summary Creates a new accessory type with name, pricing tiers, deposit settings, and customer visibility flag (Admin only).
   * @request POST:/api/accessories
   * @secure
   */
  accessoriesCreate = (
    data: AccessoriesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AccessoriesCreateData, AccessoriesCreateError>({
      path: `/api/accessories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Accessories
   * @name AccessoriesDetail
   * @summary Returns a single accessory type by ID with full pricing and deposit details.
   * @request GET:/api/accessories/{id}
   * @secure
   */
  accessoriesDetail = (id: string, params: RequestParams = {}) =>
    this.request<AccessoriesDetailData, AccessoriesDetailError>({
      path: `/api/accessories/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Accessories
   * @name AccessoriesUpdate
   * @summary Updates an existing accessory type's name, pricing tiers, deposit settings, and visibility (Admin only).
   * @request PUT:/api/accessories/{id}
   * @secure
   */
  accessoriesUpdate = (
    id: string,
    data: AccessoriesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AccessoriesUpdateData, AccessoriesUpdateError>({
      path: `/api/accessories/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Accessories
   * @name AccessoriesDelete
   * @summary Permanently deletes an accessory type by ID (Admin only).
   * @request DELETE:/api/accessories/{id}
   * @secure
   */
  accessoriesDelete = (id: string, params: RequestParams = {}) =>
    this.request<AccessoriesDeleteData, any>({
      path: `/api/accessories/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsNextSerialNumberList
   * @summary Previews the next serial number for an accessory at a location without reserving it; actual creation will consume the next available number.
   * @request GET:/api/accessory-items/next-serial-number
   * @secure
   */
  accessoryItemsNextSerialNumberList = (
    query: AccessoryItemsNextSerialNumberListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsNextSerialNumberListData,
      AccessoryItemsNextSerialNumberListError
    >({
      path: `/api/accessory-items/next-serial-number`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsList
   * @summary Returns a paginated list of accessory items filterable by accessory type, location, equipment assignment, status, serial number, and stock flag.
   * @request GET:/api/accessory-items
   * @secure
   */
  accessoryItemsList = (
    query: AccessoryItemsListParams,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsListData, any>({
      path: `/api/accessory-items`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsCreate
   * @summary Creates a new physical accessory item with serial number, location assignment, optional equipment assignment, purchase info, and pricing overrides.
   * @request POST:/api/accessory-items
   * @secure
   */
  accessoryItemsCreate = (
    data: AccessoryItemsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsCreateData, AccessoryItemsCreateError>({
      path: `/api/accessory-items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsDetail
   * @summary Returns a single accessory item by ID with status, location, equipment assignment, pricing overrides, and audit timestamps.
   * @request GET:/api/accessory-items/{id}
   * @secure
   */
  accessoryItemsDetail = (id: string, params: RequestParams = {}) =>
    this.request<AccessoryItemsDetailData, AccessoryItemsDetailError>({
      path: `/api/accessory-items/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsUpdate
   * @summary Updates an accessory item's serial number, location, equipment assignment, status, stock flag, purchase info, or pricing overrides.
   * @request PUT:/api/accessory-items/{id}
   * @secure
   */
  accessoryItemsUpdate = (
    id: string,
    data: AccessoryItemsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsUpdateData, AccessoryItemsUpdateError>({
      path: `/api/accessory-items/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsDelete
   * @summary Soft-deletes an accessory item (Admin only); the item is removed from standard queries and booking assignments.
   * @request DELETE:/api/accessory-items/{id}
   * @secure
   */
  accessoryItemsDelete = (id: string, params: RequestParams = {}) =>
    this.request<AccessoryItemsDeleteData, any>({
      path: `/api/accessory-items/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsBySerialDetail
   * @summary Returns a single accessory item by its serial number; useful for scanner-based lookup.
   * @request GET:/api/accessory-items/by-serial/{serialNumber}
   * @secure
   */
  accessoryItemsBySerialDetail = (
    serialNumber: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsBySerialDetailData,
      AccessoryItemsBySerialDetailError
    >({
      path: `/api/accessory-items/by-serial/${serialNumber}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsByEquipmentDetail
   * @summary Returns all accessory items permanently assigned to a specific equipment item (e.g., included accessories that always ship with the equipment).
   * @request GET:/api/accessory-items/by-equipment/{equipmentId}
   * @secure
   */
  accessoryItemsByEquipmentDetail = (
    equipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsByEquipmentDetailData, any>({
      path: `/api/accessory-items/by-equipment/${equipmentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsAssignToEquipmentCreate
   * @summary Permanently assigns an accessory item to an equipment item, so it is always included when that equipment is rented.
   * @request POST:/api/accessory-items/{id}/assign-to-equipment/{equipmentId}
   * @secure
   */
  accessoryItemsAssignToEquipmentCreate = (
    id: string,
    equipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsAssignToEquipmentCreateData,
      AccessoryItemsAssignToEquipmentCreateError
    >({
      path: `/api/accessory-items/${id}/assign-to-equipment/${equipmentId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsUnassignFromEquipmentCreate
   * @summary Removes the permanent equipment assignment from an accessory item, making it available for independent assignment to any booking.
   * @request POST:/api/accessory-items/{id}/unassign-from-equipment
   * @secure
   */
  accessoryItemsUnassignFromEquipmentCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsUnassignFromEquipmentCreateData,
      AccessoryItemsUnassignFromEquipmentCreateError
    >({
      path: `/api/accessory-items/${id}/unassign-from-equipment`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsBulkAssignToEquipmentCreate
   * @summary Assigns multiple accessory items to an equipment item in a single operation, replacing any existing assignments for those items.
   * @request POST:/api/accessory-items/bulk-assign-to-equipment
   * @secure
   */
  accessoryItemsBulkAssignToEquipmentCreate = (
    data: AccessoryItemsBulkAssignToEquipmentCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsBulkAssignToEquipmentCreateData, any>({
      path: `/api/accessory-items/bulk-assign-to-equipment`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsByLocationDetail
   * @summary Returns all accessory items currently stocked at a specified rental location.
   * @request GET:/api/accessory-items/by-location/{rentalId}
   * @secure
   */
  accessoryItemsByLocationDetail = (
    rentalId: string,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsByLocationDetailData, any>({
      path: `/api/accessory-items/by-location/${rentalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsMoveCreate
   * @summary Moves one or more accessory items to a different rental location, recording the movement with the current user as actor.
   * @request POST:/api/accessory-items/move
   * @secure
   */
  accessoryItemsMoveCreate = (
    data: AccessoryItemsMoveCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsMoveCreateData, any>({
      path: `/api/accessory-items/move`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsSuggestedForEquipmentDetail
   * @summary Returns suggested accessory items to give out with a specific equipment item for a booking, based on permanent assignments and type defaults, optionally scoped to a rental location.
   * @request GET:/api/accessory-items/suggested-for-equipment/{equipmentId}
   * @secure
   */
  accessoryItemsSuggestedForEquipmentDetail = (
    { equipmentId, ...query }: AccessoryItemsSuggestedForEquipmentDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsSuggestedForEquipmentDetailData, any>({
      path: `/api/accessory-items/suggested-for-equipment/${equipmentId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsAssignToBookingCreate
   * @summary Assigns an accessory item to a specific booking (and optionally a booking equipment record), optionally marking it as immediately given out.
   * @request POST:/api/accessory-items/assign-to-booking
   * @secure
   */
  accessoryItemsAssignToBookingCreate = (
    data: AccessoryItemsAssignToBookingCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsAssignToBookingCreateData,
      AccessoryItemsAssignToBookingCreateError
    >({
      path: `/api/accessory-items/assign-to-booking`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsReturnFromBookingCreate
   * @summary Processes return of an accessory item from a booking, optionally marking it as missing if not physically returned.
   * @request POST:/api/accessory-items/return-from-booking
   * @secure
   */
  accessoryItemsReturnFromBookingCreate = (
    data: AccessoryItemsReturnFromBookingCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsReturnFromBookingCreateData,
      AccessoryItemsReturnFromBookingCreateError
    >({
      path: `/api/accessory-items/return-from-booking`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsByBookingDetail
   * @summary Returns all accessory items assigned to a booking, with given-out, returned, and missing status for each item.
   * @request GET:/api/accessory-items/by-booking/{bookingId}
   * @secure
   */
  accessoryItemsByBookingDetail = (
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsByBookingDetailData, any>({
      path: `/api/accessory-items/by-booking/${bookingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsByBookingEquipmentDetail
   * @summary Returns all accessory items assigned to a specific booking equipment record (a single equipment item within a booking).
   * @request GET:/api/accessory-items/by-booking-equipment/{bookingEquipmentId}
   * @secure
   */
  accessoryItemsByBookingEquipmentDetail = (
    bookingEquipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsByBookingEquipmentDetailData, any>({
      path: `/api/accessory-items/by-booking-equipment/${bookingEquipmentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsAutoAssignToBookingCreate
   * @summary Auto-assigns accessories to a booking equipment record based on permanent equipment assignments and equipment type defaults, optionally including type-level accessories.
   * @request POST:/api/accessory-items/auto-assign-to-booking
   * @secure
   */
  accessoryItemsAutoAssignToBookingCreate = (
    data: AccessoryItemsAutoAssignToBookingCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AccessoryItemsAutoAssignToBookingCreateData, any>({
      path: `/api/accessory-items/auto-assign-to-booking`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsStatusUpdate
   * @summary Updates the status of an accessory item to any valid status ID (e.g., Available, Missing, Damaged).
   * @request PUT:/api/accessory-items/{id}/status/{statusId}
   * @secure
   */
  accessoryItemsStatusUpdate = (
    id: string,
    statusId: number,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsStatusUpdateData,
      AccessoryItemsStatusUpdateError
    >({
      path: `/api/accessory-items/${id}/status/${statusId}`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsMarkAvailableCreate
   * @summary Sets an accessory item's status to Available, returning it to the general pool at its current location.
   * @request POST:/api/accessory-items/{id}/mark-available
   * @secure
   */
  accessoryItemsMarkAvailableCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AccessoryItemsMarkAvailableCreateData,
      AccessoryItemsMarkAvailableCreateError
    >({
      path: `/api/accessory-items/${id}/mark-available`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsMarkMissingCreate
   * @summary Sets an accessory item's status to Missing, flagging it for follow-up and removing it from available inventory.
   * @request POST:/api/accessory-items/{id}/mark-missing
   * @secure
   */
  accessoryItemsMarkMissingCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      AccessoryItemsMarkMissingCreateData,
      AccessoryItemsMarkMissingCreateError
    >({
      path: `/api/accessory-items/${id}/mark-missing`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessoryItems
   * @name AccessoryItemsMarkDamagedCreate
   * @summary Sets an accessory item's status to Damaged, removing it from available inventory and flagging it for inspection or repair.
   * @request POST:/api/accessory-items/{id}/mark-damaged
   * @secure
   */
  accessoryItemsMarkDamagedCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      AccessoryItemsMarkDamagedCreateData,
      AccessoryItemsMarkDamagedCreateError
    >({
      path: `/api/accessory-items/${id}/mark-damaged`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Activities
   * @name GetNext
   * @summary Returns the next upcoming activities (scheduled pickups and returns) for the current user's accessible locations, filterable by date or location.
   * @request GET:/api/activities/getNext
   * @secure
   */
  getNext = (query: GetNextParams, params: RequestParams = {}) =>
    this.request<GetNextData, any>({
      path: `/api/activities/getNext`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Activities
   * @name GetStats
   * @summary Returns aggregate activity statistics (total, upcoming, overdue counts) for the current user's accessible locations, filterable by date or location.
   * @request GET:/api/activities/getStats
   * @secure
   */
  getStats = (query: GetStatsParams, params: RequestParams = {}) =>
    this.request<GetStatsData, any>({
      path: `/api/activities/getStats`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesList
   * @summary Gets all partner-app releases with optional filtering.
   * @request GET:/api/admin/app-releases
   * @secure
   */
  adminAppReleasesList = (
    query: AdminAppReleasesListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminAppReleasesListData, any>({
      path: `/api/admin/app-releases`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesDetail
   * @summary Gets a specific partner-app release by ID.
   * @request GET:/api/admin/app-releases/{id}
   * @secure
   */
  adminAppReleasesDetail = (id: string, params: RequestParams = {}) =>
    this.request<AdminAppReleasesDetailData, AdminAppReleasesDetailError>({
      path: `/api/admin/app-releases/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesUpdate
   * @request PUT:/api/admin/app-releases/{id}
   * @secure
   */
  adminAppReleasesUpdate = (
    id: string,
    data: AdminAppReleasesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AdminAppReleasesUpdateData, AdminAppReleasesUpdateError>({
      path: `/api/admin/app-releases/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesDelete
   * @request DELETE:/api/admin/app-releases/{id}
   * @secure
   */
  adminAppReleasesDelete = (id: string, params: RequestParams = {}) =>
    this.request<AdminAppReleasesDeleteData, AdminAppReleasesDeleteError>({
      path: `/api/admin/app-releases/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesDownloadUrlList
   * @request GET:/api/admin/app-releases/{id}/download-url
   * @secure
   */
  adminAppReleasesDownloadUrlList = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminAppReleasesDownloadUrlListData,
      AdminAppReleasesDownloadUrlListError
    >({
      path: `/api/admin/app-releases/${id}/download-url`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesUploadCreate
   * @request POST:/api/admin/app-releases/upload
   * @secure
   */
  adminAppReleasesUploadCreate = (
    data: AdminAppReleasesUploadCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminAppReleasesUploadCreateData,
      AdminAppReleasesUploadCreateError
    >({
      path: `/api/admin/app-releases/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesExternalCreate
   * @request POST:/api/admin/app-releases/external
   * @secure
   */
  adminAppReleasesExternalCreate = (
    data: AdminAppReleasesExternalCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminAppReleasesExternalCreateData,
      AdminAppReleasesExternalCreateError
    >({
      path: `/api/admin/app-releases/external`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesPublishCreate
   * @request POST:/api/admin/app-releases/{id}/publish
   * @secure
   */
  adminAppReleasesPublishCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminAppReleasesPublishCreateData,
      AdminAppReleasesPublishCreateError
    >({
      path: `/api/admin/app-releases/${id}/publish`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesDeprecateCreate
   * @request POST:/api/admin/app-releases/{id}/deprecate
   * @secure
   */
  adminAppReleasesDeprecateCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminAppReleasesDeprecateCreateData,
      AdminAppReleasesDeprecateCreateError
    >({
      path: `/api/admin/app-releases/${id}/deprecate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesRollbackCreate
   * @request POST:/api/admin/app-releases/{id}/rollback
   * @secure
   */
  adminAppReleasesRollbackCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminAppReleasesRollbackCreateData,
      AdminAppReleasesRollbackCreateError
    >({
      path: `/api/admin/app-releases/${id}/rollback`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesMinimumVersionPartialUpdate
   * @request PATCH:/api/admin/app-releases/{id}/minimum-version
   * @secure
   */
  adminAppReleasesMinimumVersionPartialUpdate = (
    id: string,
    data: AdminAppReleasesMinimumVersionPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminAppReleasesMinimumVersionPartialUpdateData,
      AdminAppReleasesMinimumVersionPartialUpdateError
    >({
      path: `/api/admin/app-releases/${id}/minimum-version`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAppReleases
   * @name AdminAppReleasesCleanupCreate
   * @request POST:/api/admin/app-releases/cleanup
   * @secure
   */
  adminAppReleasesCleanupCreate = (
    query: AdminAppReleasesCleanupCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminAppReleasesCleanupCreateData,
      AdminAppReleasesCleanupCreateError
    >({
      path: `/api/admin/app-releases/cleanup`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobEmailItems
   * @name AdminBackgroundJobsEmailDeliveryItemsList
   * @request GET:/api/admin/background-jobs/email-delivery/items
   * @secure
   */
  adminBackgroundJobsEmailDeliveryItemsList = (params: RequestParams = {}) =>
    this.request<AdminBackgroundJobsEmailDeliveryItemsListData, any>({
      path: `/api/admin/background-jobs/email-delivery/items`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobEmailItems
   * @name AdminBackgroundJobsEmailDeliveryItemsRetryCreate
   * @request POST:/api/admin/background-jobs/email-delivery/items/{emailLogId}/retry
   * @secure
   */
  adminBackgroundJobsEmailDeliveryItemsRetryCreate = (
    emailLogId: string,
    params: RequestParams = {},
  ) =>
    this.request<AdminBackgroundJobsEmailDeliveryItemsRetryCreateData, any>({
      path: `/api/admin/background-jobs/email-delivery/items/${emailLogId}/retry`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobPaymentFailures
   * @name AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsList
   * @request GET:/api/admin/background-jobs/monthly-rental-payment-follow-up/items
   * @secure
   */
  adminBackgroundJobsMonthlyRentalPaymentFollowUpItemsList = (
    params: RequestParams = {},
  ) =>
    this.request<
      AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsListData,
      any
    >({
      path: `/api/admin/background-jobs/monthly-rental-payment-follow-up/items`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobPaymentFailures
   * @name AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsRetryCreate
   * @request POST:/api/admin/background-jobs/monthly-rental-payment-follow-up/items/{followUpId}/retry
   * @secure
   */
  adminBackgroundJobsMonthlyRentalPaymentFollowUpItemsRetryCreate = (
    followUpId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsRetryCreateData,
      AdminBackgroundJobsMonthlyRentalPaymentFollowUpItemsRetryCreateError
    >({
      path: `/api/admin/background-jobs/monthly-rental-payment-follow-up/items/${followUpId}/retry`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobs
   * @name AdminBackgroundJobsList
   * @request GET:/api/admin/background-jobs
   * @secure
   */
  adminBackgroundJobsList = (params: RequestParams = {}) =>
    this.request<AdminBackgroundJobsListData, any>({
      path: `/api/admin/background-jobs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobs
   * @name AdminBackgroundJobsDetail
   * @request GET:/api/admin/background-jobs/{jobKey}
   * @secure
   */
  adminBackgroundJobsDetail = (jobKey: string, params: RequestParams = {}) =>
    this.request<AdminBackgroundJobsDetailData, AdminBackgroundJobsDetailError>(
      {
        path: `/api/admin/background-jobs/${jobKey}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags AdminBackgroundJobs
   * @name AdminBackgroundJobsRunsList
   * @request GET:/api/admin/background-jobs/{jobKey}/runs
   * @secure
   */
  adminBackgroundJobsRunsList = (jobKey: string, params: RequestParams = {}) =>
    this.request<
      AdminBackgroundJobsRunsListData,
      AdminBackgroundJobsRunsListError
    >({
      path: `/api/admin/background-jobs/${jobKey}/runs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobs
   * @name AdminBackgroundJobsItemsList
   * @request GET:/api/admin/background-jobs/{jobKey}/items
   * @secure
   */
  adminBackgroundJobsItemsList = (jobKey: string, params: RequestParams = {}) =>
    this.request<
      AdminBackgroundJobsItemsListData,
      AdminBackgroundJobsItemsListError
    >({
      path: `/api/admin/background-jobs/${jobKey}/items`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobs
   * @name AdminBackgroundJobsPauseCreate
   * @request POST:/api/admin/background-jobs/{jobKey}/pause
   * @secure
   */
  adminBackgroundJobsPauseCreate = (
    jobKey: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminBackgroundJobsPauseCreateData,
      AdminBackgroundJobsPauseCreateError
    >({
      path: `/api/admin/background-jobs/${jobKey}/pause`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobs
   * @name AdminBackgroundJobsResumeCreate
   * @request POST:/api/admin/background-jobs/{jobKey}/resume
   * @secure
   */
  adminBackgroundJobsResumeCreate = (
    jobKey: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminBackgroundJobsResumeCreateData,
      AdminBackgroundJobsResumeCreateError
    >({
      path: `/api/admin/background-jobs/${jobKey}/resume`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBackgroundJobs
   * @name AdminBackgroundJobsRunNowCreate
   * @request POST:/api/admin/background-jobs/{jobKey}/run-now
   * @secure
   */
  adminBackgroundJobsRunNowCreate = (
    jobKey: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminBackgroundJobsRunNowCreateData,
      AdminBackgroundJobsRunNowCreateError
    >({
      path: `/api/admin/background-jobs/${jobKey}/run-now`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCategories
   * @name CategoriesList
   * @summary Returns a flat list of all equipment categories with display and deposit configuration.
   * @request GET:/api/categories
   * @secure
   */
  categoriesList = (params: RequestParams = {}) =>
    this.request<CategoriesListData, any>({
      path: `/api/categories`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCategories
   * @name CategoriesCreate
   * @summary Creates a new equipment category with hierarchy, visibility, and deposit settings.
   * @request POST:/api/categories
   * @secure
   */
  categoriesCreate = (
    data: CategoriesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CategoriesCreateData, any>({
      path: `/api/categories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCategories
   * @name CategoriesDetail
   * @summary Returns details for a single equipment category by ID.
   * @request GET:/api/categories/{id}
   * @secure
   */
  categoriesDetail = (id: string, params: RequestParams = {}) =>
    this.request<CategoriesDetailData, any>({
      path: `/api/categories/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCategories
   * @name CategoriesUpdate
   * @summary Updates an equipment category's details, hierarchy, and visibility settings.
   * @request PUT:/api/categories/{id}
   * @secure
   */
  categoriesUpdate = (
    id: string,
    data: CategoriesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CategoriesUpdateData, any>({
      path: `/api/categories/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCategories
   * @name CategoriesDelete
   * @summary Deletes an equipment category by ID.
   * @request DELETE:/api/categories/{id}
   * @secure
   */
  categoriesDelete = (id: string, params: RequestParams = {}) =>
    this.request<CategoriesDeleteData, any>({
      path: `/api/categories/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCategories
   * @name CategoriesTreeList
   * @summary Returns equipment categories as a nested tree structure, optionally rooted at a specific category.
   * @request GET:/api/categories/tree
   * @secure
   */
  categoriesTreeList = (
    query: CategoriesTreeListParams,
    params: RequestParams = {},
  ) =>
    this.request<CategoriesTreeListData, any>({
      path: `/api/categories/tree`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminCustomerReservations
 * @name AdminCustomerReservationsList
 * @summary DEPRECATED (UI-1, #494): the unified Reservations browser reads GET api/bookingRequests
with lifecycle-stage filters instead; this list action is losing its last first-party
consumer and will be removed in a later cleanup release. Do not add new consumers.
All other actions on this controller (pending-refunds, cancel, complete-inspection,
process-deposit-refund, process-return) are unaffected.
 * @request GET:/api/admin/customer-reservations
 * @deprecated
 * @secure
 */
  adminCustomerReservationsList = (
    query: AdminCustomerReservationsListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminCustomerReservationsListData, any>({
      path: `/api/admin/customer-reservations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCustomerReservations
   * @name AdminCustomerReservationsPendingRefundsList
   * @request GET:/api/admin/customer-reservations/pending-refunds
   * @secure
   */
  adminCustomerReservationsPendingRefundsList = (
    query: AdminCustomerReservationsPendingRefundsListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminCustomerReservationsPendingRefundsListData, any>({
      path: `/api/admin/customer-reservations/pending-refunds`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCustomerReservations
   * @name AdminCustomerReservationsCancelCreate
   * @request POST:/api/admin/customer-reservations/{id}/cancel
   * @secure
   */
  adminCustomerReservationsCancelCreate = (
    id: string,
    data: AdminCustomerReservationsCancelCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminCustomerReservationsCancelCreateData,
      AdminCustomerReservationsCancelCreateError
    >({
      path: `/api/admin/customer-reservations/${id}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCustomerReservations
   * @name AdminCustomerReservationsProcessReturnCreate
   * @request POST:/api/admin/customer-reservations/{id}/process-return
   * @secure
   */
  adminCustomerReservationsProcessReturnCreate = (
    id: string,
    data: AdminCustomerReservationsProcessReturnCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminCustomerReservationsProcessReturnCreateData,
      AdminCustomerReservationsProcessReturnCreateError
    >({
      path: `/api/admin/customer-reservations/${id}/process-return`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCustomerReservations
   * @name AdminCustomerReservationsCompleteInspectionCreate
   * @request POST:/api/admin/customer-reservations/{id}/complete-inspection
   * @secure
   */
  adminCustomerReservationsCompleteInspectionCreate = (
    id: string,
    data: AdminCustomerReservationsCompleteInspectionCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminCustomerReservationsCompleteInspectionCreateData,
      AdminCustomerReservationsCompleteInspectionCreateError
    >({
      path: `/api/admin/customer-reservations/${id}/complete-inspection`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminCustomerReservations
   * @name AdminCustomerReservationsProcessDepositRefundCreate
   * @request POST:/api/admin/customer-reservations/{id}/process-deposit-refund
   * @secure
   */
  adminCustomerReservationsProcessDepositRefundCreate = (
    id: string,
    data: AdminCustomerReservationsProcessDepositRefundCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminCustomerReservationsProcessDepositRefundCreateData,
      AdminCustomerReservationsProcessDepositRefundCreateError
    >({
      path: `/api/admin/customer-reservations/${id}/process-deposit-refund`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminExtensionRequests
   * @name AdminExtensionRequestsList
   * @summary Get all pending extension requests awaiting admin approval.
   * @request GET:/api/admin/extension-requests
   * @secure
   */
  adminExtensionRequestsList = (
    query: AdminExtensionRequestsListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminExtensionRequestsListData, any>({
      path: `/api/admin/extension-requests`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminExtensionRequests
   * @name AdminExtensionRequestsDetail
   * @summary Get extension request by ID.
   * @request GET:/api/admin/extension-requests/{id}
   * @secure
   */
  adminExtensionRequestsDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminExtensionRequestsDetailData,
      AdminExtensionRequestsDetailError
    >({
      path: `/api/admin/extension-requests/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminExtensionRequests
 * @name AdminExtensionRequestsApproveCreate
 * @summary Approve an extension request.
This captures the payment hold and extends the booking end date.
 * @request POST:/api/admin/extension-requests/{id}/approve
 * @secure
 */
  adminExtensionRequestsApproveCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminExtensionRequestsApproveCreateData,
      AdminExtensionRequestsApproveCreateError
    >({
      path: `/api/admin/extension-requests/${id}/approve`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminExtensionRequests
 * @name AdminExtensionRequestsRejectCreate
 * @summary Reject an extension request.
This releases the payment hold and notifies the customer.
 * @request POST:/api/admin/extension-requests/{id}/reject
 * @secure
 */
  adminExtensionRequestsRejectCreate = (
    id: string,
    data: AdminExtensionRequestsRejectCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminExtensionRequestsRejectCreateData,
      AdminExtensionRequestsRejectCreateError
    >({
      path: `/api/admin/extension-requests/${id}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMonthlyRentals
   * @name AdminMonthlyRentalsList
   * @summary Get all monthly rentals with optional filtering.
   * @request GET:/api/admin/monthly-rentals
   * @secure
   */
  adminMonthlyRentalsList = (
    query: AdminMonthlyRentalsListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminMonthlyRentalsListData, any>({
      path: `/api/admin/monthly-rentals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMonthlyRentals
   * @name AdminMonthlyRentalsActionLogsList
   * @summary Get monthly rental action logs for a booking.
   * @request GET:/api/admin/monthly-rentals/{bookingId}/action-logs
   * @secure
   */
  adminMonthlyRentalsActionLogsList = (
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<AdminMonthlyRentalsActionLogsListData, any>({
      path: `/api/admin/monthly-rentals/${bookingId}/action-logs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminMonthlyRentals
 * @name AdminMonthlyRentalsInspectionFailedWorklistList
 * @summary MR-G3 (#514): the open damaged-return work queue. Lists every monthly rental parked at the
InspectionFailed dead-end with its age and SLA-breach flag (plus aggregate counts for the staff
alert badge) so a damaged return is never silently stranded. Read-only; resolve via
the resolve-damage action.
 * @request GET:/api/admin/monthly-rentals/inspection-failed-worklist
 * @secure
 */
  adminMonthlyRentalsInspectionFailedWorklistList = (
    params: RequestParams = {},
  ) =>
    this.request<AdminMonthlyRentalsInspectionFailedWorklistListData, any>({
      path: `/api/admin/monthly-rentals/inspection-failed-worklist`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMonthlyRentals
   * @name AdminMonthlyRentalsPreviewCancellationList
   * @summary Preview cancellation charges before actually cancelling.
   * @request GET:/api/admin/monthly-rentals/{bookingId}/preview-cancellation
   * @secure
   */
  adminMonthlyRentalsPreviewCancellationList = (
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminMonthlyRentalsPreviewCancellationListData,
      AdminMonthlyRentalsPreviewCancellationListError
    >({
      path: `/api/admin/monthly-rentals/${bookingId}/preview-cancellation`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMonthlyRentals
   * @name AdminMonthlyRentalsCancelCreate
   * @summary Cancel a monthly rental with configurable immediate/end-of-period timing.
   * @request POST:/api/admin/monthly-rentals/{bookingId}/cancel
   * @secure
   */
  adminMonthlyRentalsCancelCreate = (
    bookingId: string,
    data: AdminMonthlyRentalsCancelCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminMonthlyRentalsCancelCreateData,
      AdminMonthlyRentalsCancelCreateError
    >({
      path: `/api/admin/monthly-rentals/${bookingId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminMonthlyRentals
 * @name AdminMonthlyRentalsProcessReturnCreate
 * @summary Process equipment return for a cancelled monthly rental.
Starts the inspection process.
 * @request POST:/api/admin/monthly-rentals/{bookingId}/process-return
 * @secure
 */
  adminMonthlyRentalsProcessReturnCreate = (
    bookingId: string,
    data: AdminMonthlyRentalsProcessReturnCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminMonthlyRentalsProcessReturnCreateData,
      AdminMonthlyRentalsProcessReturnCreateError
    >({
      path: `/api/admin/monthly-rentals/${bookingId}/process-return`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminMonthlyRentals
 * @name AdminMonthlyRentalsCompleteInspectionCreate
 * @summary Complete equipment inspection after return.
Records condition and damage assessment.
 * @request POST:/api/admin/monthly-rentals/{bookingId}/complete-inspection
 * @secure
 */
  adminMonthlyRentalsCompleteInspectionCreate = (
    bookingId: string,
    data: AdminMonthlyRentalsCompleteInspectionCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminMonthlyRentalsCompleteInspectionCreateData,
      AdminMonthlyRentalsCompleteInspectionCreateError
    >({
      path: `/api/admin/monthly-rentals/${bookingId}/complete-inspection`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMonthlyRentals
   * @name AdminMonthlyRentalsProcessDepositRefundCreate
   * @summary Process deposit refund after inspection is complete.
   * @request POST:/api/admin/monthly-rentals/{bookingId}/process-deposit-refund
   * @secure
   */
  adminMonthlyRentalsProcessDepositRefundCreate = (
    bookingId: string,
    data: AdminMonthlyRentalsProcessDepositRefundCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminMonthlyRentalsProcessDepositRefundCreateData,
      AdminMonthlyRentalsProcessDepositRefundCreateError
    >({
      path: `/api/admin/monthly-rentals/${bookingId}/process-deposit-refund`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminMonthlyRentals
 * @name AdminMonthlyRentalsResolveDamageCreate
 * @summary C67: resolve the deposit for a damaged return parked at InspectionFailed. The admin returns
part (or none) of the deposit to the customer; the withheld remainder covers the damage.
Distinct from process-deposit-refund (the no-damage InspectionPassed full deposit refund).
 * @request POST:/api/admin/monthly-rentals/{bookingId}/resolve-damage
 * @secure
 */
  adminMonthlyRentalsResolveDamageCreate = (
    bookingId: string,
    data: AdminMonthlyRentalsResolveDamageCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminMonthlyRentalsResolveDamageCreateData,
      AdminMonthlyRentalsResolveDamageCreateError
    >({
      path: `/api/admin/monthly-rentals/${bookingId}/resolve-damage`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminMonthlyRentals
 * @name AdminMonthlyRentalsScheduledCancellationsList
 * @summary Dry-run: lists commitment subscriptions still carrying a Stripe-side scheduled
cancellation (cancel_at) from the retired commitment-end auto-cancel, including
subscriptions that cancellation already terminated (flagged — not repairable here).
 * @request GET:/api/admin/monthly-rentals/scheduled-cancellations
 * @secure
 */
  adminMonthlyRentalsScheduledCancellationsList = (
    params: RequestParams = {},
  ) =>
    this.request<AdminMonthlyRentalsScheduledCancellationsListData, any>({
      path: `/api/admin/monthly-rentals/scheduled-cancellations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminMonthlyRentals
 * @name AdminMonthlyRentalsScheduledCancellationsClearCreate
 * @summary Clears the scheduled Stripe cancellation on every subscription the preview reports.
After clearing, billing continues monthly until the item is returned; the commitment
minimum stays enforced by the early-return penalty. Idempotent.
 * @request POST:/api/admin/monthly-rentals/scheduled-cancellations/clear
 * @secure
 */
  adminMonthlyRentalsScheduledCancellationsClearCreate = (
    params: RequestParams = {},
  ) =>
    this.request<AdminMonthlyRentalsScheduledCancellationsClearCreateData, any>(
      {
        path: `/api/admin/monthly-rentals/scheduled-cancellations/clear`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
 * @description Query: IsAdvanceBooking = true AND PendingCaptureAmount > 0 AND StartDate <= Now + 30 days For each booking: - Creates off-session PaymentIntent using saved payment method - On success: clears pending amount, updates payment status - On failure: returns error details for admin review
 *
 * @tags AdminPayments
 * @name AdminPaymentsCaptureAdvanceBookingsCreate
 * @summary Processes advance bookings that need rental capture (30 days before start date).
This endpoint should be called by a CRON job or scheduled task.
 * @request POST:/api/admin/payments/capture-advance-bookings
 * @secure
 */
  adminPaymentsCaptureAdvanceBookingsCreate = (params: RequestParams = {}) =>
    this.request<AdminPaymentsCaptureAdvanceBookingsCreateData, void>({
      path: `/api/admin/payments/capture-advance-bookings`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesOptionsList
   * @request GET:/api/admin/promo-codes/options
   * @secure
   */
  adminPromoCodesOptionsList = (params: RequestParams = {}) =>
    this.request<AdminPromoCodesOptionsListData, any>({
      path: `/api/admin/promo-codes/options`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesOrdersList
   * @request GET:/api/admin/promo-codes/{id}/orders
   * @secure
   */
  adminPromoCodesOrdersList = (
    { id, ...query }: AdminPromoCodesOrdersListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminPromoCodesOrdersListData, AdminPromoCodesOrdersListError>(
      {
        path: `/api/admin/promo-codes/${id}/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesList
   * @request GET:/api/admin/promo-codes
   * @secure
   */
  adminPromoCodesList = (
    query: AdminPromoCodesListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminPromoCodesListData, any>({
      path: `/api/admin/promo-codes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesCreate
   * @request POST:/api/admin/promo-codes
   * @secure
   */
  adminPromoCodesCreate = (
    data: AdminPromoCodesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AdminPromoCodesCreateData, AdminPromoCodesCreateError>({
      path: `/api/admin/promo-codes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesDetail
   * @request GET:/api/admin/promo-codes/{id}
   * @secure
   */
  adminPromoCodesDetail = (id: string, params: RequestParams = {}) =>
    this.request<AdminPromoCodesDetailData, AdminPromoCodesDetailError>({
      path: `/api/admin/promo-codes/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesPartialUpdate
   * @request PATCH:/api/admin/promo-codes/{id}
   * @secure
   */
  adminPromoCodesPartialUpdate = (
    id: string,
    data: AdminPromoCodesPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminPromoCodesPartialUpdateData,
      AdminPromoCodesPartialUpdateError
    >({
      path: `/api/admin/promo-codes/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesActivateCreate
   * @request POST:/api/admin/promo-codes/{id}/activate
   * @secure
   */
  adminPromoCodesActivateCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminPromoCodesActivateCreateData,
      AdminPromoCodesActivateCreateError
    >({
      path: `/api/admin/promo-codes/${id}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminPromoCodes
   * @name AdminPromoCodesDeactivateCreate
   * @request POST:/api/admin/promo-codes/{id}/deactivate
   * @secure
   */
  adminPromoCodesDeactivateCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminPromoCodesDeactivateCreateData,
      AdminPromoCodesDeactivateCreateError
    >({
      path: `/api/admin/promo-codes/${id}/deactivate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsPreviewCreate
 * @summary Previews pricing and availability for a prospective admin reservation
without persisting anything.
 * @request POST:/api/booking-requests/admin-reservations/preview
 * @secure
 */
  bookingRequestsAdminReservationsPreviewCreate = (
    data: BookingRequestsAdminReservationsPreviewCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsPreviewCreateData,
      BookingRequestsAdminReservationsPreviewCreateError
    >({
      path: `/api/booking-requests/admin-reservations/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsCreate
 * @summary Creates a new admin-initiated reservation: persists a BookingRequest + locked
CustomerBooking and returns the resume token and URL.
 * @request POST:/api/booking-requests/admin-reservations
 * @secure
 */
  bookingRequestsAdminReservationsCreate = (
    data: BookingRequestsAdminReservationsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsCreateData,
      BookingRequestsAdminReservationsCreateError
    >({
      path: `/api/booking-requests/admin-reservations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsUpdate
 * @summary Updates an existing unpaid admin reservation (re-prices, re-checks availability,
cancels any stale Stripe PaymentIntent).
 * @request PUT:/api/booking-requests/admin-reservations/{id}
 * @secure
 */
  bookingRequestsAdminReservationsUpdate = (
    id: string,
    data: BookingRequestsAdminReservationsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsUpdateData,
      BookingRequestsAdminReservationsUpdateError
    >({
      path: `/api/booking-requests/admin-reservations/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsCancelCreate
 * @summary Cancels an unpaid admin reservation, invalidates the resume token,
and releases the inventory hold. Paid reservations must use the refund flow.
 * @request POST:/api/booking-requests/admin-reservations/{id}/cancel
 * @secure
 */
  bookingRequestsAdminReservationsCancelCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsCancelCreateData,
      BookingRequestsAdminReservationsCancelCreateError
    >({
      path: `/api/booking-requests/admin-reservations/${id}/cancel`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsResendEmailCreate
 * @summary Re-sends the awaiting-payment email to the customer.
Returns 400 if no customer email is on record.
 * @request POST:/api/booking-requests/admin-reservations/{id}/resend-email
 * @secure
 */
  bookingRequestsAdminReservationsResendEmailCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsResendEmailCreateData,
      BookingRequestsAdminReservationsResendEmailCreateError
    >({
      path: `/api/booking-requests/admin-reservations/${id}/resend-email`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsRotateTokenCreate
 * @summary Re-issues the resume link for an unpaid reservation: generates a new token with a
fresh expiry window (default 72h, override via body), invalidates the old one, and
clears the reminder-sent flag so the reminder job can re-fire. If the reservation
was auto-cancelled by the expiry sweep, it is revived (admin-cancelled ones are not).
 * @request POST:/api/booking-requests/admin-reservations/{id}/rotate-token
 * @secure
 */
  bookingRequestsAdminReservationsRotateTokenCreate = (
    id: string,
    data: BookingRequestsAdminReservationsRotateTokenCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsRotateTokenCreateData,
      BookingRequestsAdminReservationsRotateTokenCreateError
    >({
      path: `/api/booking-requests/admin-reservations/${id}/rotate-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsDetailList
 * @summary Returns the full admin-reservation detail for the given BookingRequest ID,
including resume URL, snapshot pricing, and payment timeline data.
 * @request GET:/api/booking-requests/admin-reservations/{id}/detail
 * @secure
 */
  bookingRequestsAdminReservationsDetailList = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsDetailListData,
      BookingRequestsAdminReservationsDetailListError
    >({
      path: `/api/booking-requests/admin-reservations/${id}/detail`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AdminReservations
 * @name BookingRequestsAdminReservationsSyncFromStripeCreate
 * @summary Manually triggers a Stripe reconciliation for the linked PaymentIntent of this
admin reservation. Use when a payment was captured in Stripe but the local
status is still AwaitingPayment (missed-webhook scenario).
 * @request POST:/api/booking-requests/admin-reservations/{id}/sync-from-stripe
 * @secure
 */
  bookingRequestsAdminReservationsSyncFromStripeCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      BookingRequestsAdminReservationsSyncFromStripeCreateData,
      BookingRequestsAdminReservationsSyncFromStripeCreateError
    >({
      path: `/api/booking-requests/admin-reservations/${id}/sync-from-stripe`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminReviews
   * @name AdminReviewsList
   * @request GET:/api/admin/reviews
   * @secure
   */
  adminReviewsList = (
    query: AdminReviewsListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminReviewsListData, AdminReviewsListError>({
      path: `/api/admin/reviews`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminReviews
   * @name AdminReviewsApproveCreate
   * @request POST:/api/admin/reviews/{reviewId}/approve
   * @secure
   */
  adminReviewsApproveCreate = (reviewId: string, params: RequestParams = {}) =>
    this.request<AdminReviewsApproveCreateData, AdminReviewsApproveCreateError>(
      {
        path: `/api/admin/reviews/${reviewId}/approve`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags AdminReviews
   * @name AdminReviewsRejectCreate
   * @request POST:/api/admin/reviews/{reviewId}/reject
   * @secure
   */
  adminReviewsRejectCreate = (
    reviewId: string,
    data: AdminReviewsRejectCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AdminReviewsRejectCreateData, AdminReviewsRejectCreateError>({
      path: `/api/admin/reviews/${reviewId}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesList
   * @summary Gets all staff-app releases with optional filtering.
   * @request GET:/api/admin/staff-app-releases
   * @secure
   */
  adminStaffAppReleasesList = (
    query: AdminStaffAppReleasesListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminStaffAppReleasesListData, any>({
      path: `/api/admin/staff-app-releases`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesDetail
   * @summary Gets a specific staff-app release by ID.
   * @request GET:/api/admin/staff-app-releases/{id}
   * @secure
   */
  adminStaffAppReleasesDetail = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminStaffAppReleasesDetailData,
      AdminStaffAppReleasesDetailError
    >({
      path: `/api/admin/staff-app-releases/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesUpdate
   * @request PUT:/api/admin/staff-app-releases/{id}
   * @secure
   */
  adminStaffAppReleasesUpdate = (
    id: string,
    data: AdminStaffAppReleasesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesUpdateData,
      AdminStaffAppReleasesUpdateError
    >({
      path: `/api/admin/staff-app-releases/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesDelete
   * @request DELETE:/api/admin/staff-app-releases/{id}
   * @secure
   */
  adminStaffAppReleasesDelete = (id: string, params: RequestParams = {}) =>
    this.request<
      AdminStaffAppReleasesDeleteData,
      AdminStaffAppReleasesDeleteError
    >({
      path: `/api/admin/staff-app-releases/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesDownloadUrlList
   * @request GET:/api/admin/staff-app-releases/{id}/download-url
   * @secure
   */
  adminStaffAppReleasesDownloadUrlList = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesDownloadUrlListData,
      AdminStaffAppReleasesDownloadUrlListError
    >({
      path: `/api/admin/staff-app-releases/${id}/download-url`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesUploadCreate
   * @request POST:/api/admin/staff-app-releases/upload
   * @secure
   */
  adminStaffAppReleasesUploadCreate = (
    data: AdminStaffAppReleasesUploadCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesUploadCreateData,
      AdminStaffAppReleasesUploadCreateError
    >({
      path: `/api/admin/staff-app-releases/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesPublishCreate
   * @request POST:/api/admin/staff-app-releases/{id}/publish
   * @secure
   */
  adminStaffAppReleasesPublishCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesPublishCreateData,
      AdminStaffAppReleasesPublishCreateError
    >({
      path: `/api/admin/staff-app-releases/${id}/publish`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesDeprecateCreate
   * @request POST:/api/admin/staff-app-releases/{id}/deprecate
   * @secure
   */
  adminStaffAppReleasesDeprecateCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesDeprecateCreateData,
      AdminStaffAppReleasesDeprecateCreateError
    >({
      path: `/api/admin/staff-app-releases/${id}/deprecate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesRollbackCreate
   * @request POST:/api/admin/staff-app-releases/{id}/rollback
   * @secure
   */
  adminStaffAppReleasesRollbackCreate = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesRollbackCreateData,
      AdminStaffAppReleasesRollbackCreateError
    >({
      path: `/api/admin/staff-app-releases/${id}/rollback`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesMinimumVersionPartialUpdate
   * @request PATCH:/api/admin/staff-app-releases/{id}/minimum-version
   * @secure
   */
  adminStaffAppReleasesMinimumVersionPartialUpdate = (
    id: string,
    data: AdminStaffAppReleasesMinimumVersionPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesMinimumVersionPartialUpdateData,
      AdminStaffAppReleasesMinimumVersionPartialUpdateError
    >({
      path: `/api/admin/staff-app-releases/${id}/minimum-version`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminStaffAppReleases
   * @name AdminStaffAppReleasesCleanupCreate
   * @request POST:/api/admin/staff-app-releases/cleanup
   * @secure
   */
  adminStaffAppReleasesCleanupCreate = (
    query: AdminStaffAppReleasesCleanupCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminStaffAppReleasesCleanupCreateData,
      AdminStaffAppReleasesCleanupCreateError
    >({
      path: `/api/admin/staff-app-releases/cleanup`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTickets
   * @name AdminTicketsList
   * @request GET:/api/admin/tickets
   * @secure
   */
  adminTicketsList = (
    query: AdminTicketsListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminTicketsListData, any>({
      path: `/api/admin/tickets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTickets
   * @name AdminTicketsDetail
   * @request GET:/api/admin/tickets/{ticketId}
   * @secure
   */
  adminTicketsDetail = (ticketId: string, params: RequestParams = {}) =>
    this.request<AdminTicketsDetailData, AdminTicketsDetailError>({
      path: `/api/admin/tickets/${ticketId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTickets
   * @name AdminTicketsMessagesCreate
   * @request POST:/api/admin/tickets/{ticketId}/messages
   * @secure
   */
  adminTicketsMessagesCreate = (
    ticketId: string,
    data: AdminTicketsMessagesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminTicketsMessagesCreateData,
      AdminTicketsMessagesCreateError
    >({
      path: `/api/admin/tickets/${ticketId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTickets
   * @name AdminTicketsStatusPartialUpdate
   * @request PATCH:/api/admin/tickets/{ticketId}/status
   * @secure
   */
  adminTicketsStatusPartialUpdate = (
    ticketId: string,
    data: AdminTicketsStatusPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminTicketsStatusPartialUpdateData,
      AdminTicketsStatusPartialUpdateError
    >({
      path: `/api/admin/tickets/${ticketId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AppReleases
 * @name CicdAppReleasesVersionInfoList
 * @summary Gets version information for CI/CD pipelines.
Returns latest version, suggested next version, and minimum supported version.
 * @request GET:/api/cicd/app-releases/version-info
 * @secure
 */
  cicdAppReleasesVersionInfoList = (
    query: CicdAppReleasesVersionInfoListParams,
    params: RequestParams = {},
  ) =>
    this.request<CicdAppReleasesVersionInfoListData, any>({
      path: `/api/cicd/app-releases/version-info`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AppReleases
 * @name CicdAppReleasesUploadCreate
 * @summary Uploads a new app release from CI/CD pipeline.
Creates a draft release that must be published manually by an admin.
 * @request POST:/api/cicd/app-releases/upload
 * @secure
 */
  cicdAppReleasesUploadCreate = (
    data: CicdAppReleasesUploadCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CicdAppReleasesUploadCreateData,
      CicdAppReleasesUploadCreateError
    >({
      path: `/api/cicd/app-releases/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags AppReleases
 * @name CicdAppReleasesExistsDetail
 * @summary Checks if a version already exists.
Useful for CI/CD to skip uploads if version exists.
 * @request GET:/api/cicd/app-releases/exists/{version}
 * @secure
 */
  cicdAppReleasesExistsDetail = (
    { version, ...query }: CicdAppReleasesExistsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<CicdAppReleasesExistsDetailData, any>({
      path: `/api/cicd/app-releases/exists/${version}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Areas
   * @name CreateArea
   * @summary Creates a new operational area used to group locations and assign managers.
   * @request POST:/api/areas
   * @secure
   */
  createArea = (data: CreateAreaPayload, params: RequestParams = {}) =>
    this.request<CreateAreaData, CreateAreaError>({
      path: `/api/areas`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Areas
   * @name GetAreas
   * @summary Returns a paginated list of all operational areas.
   * @request GET:/api/areas
   * @secure
   */
  getAreas = (query: GetAreasParams, params: RequestParams = {}) =>
    this.request<GetAreasData, any>({
      path: `/api/areas`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Areas
   * @name GetArea
   * @summary Returns details for a single operational area by ID.
   * @request GET:/api/areas/{Id}
   * @secure
   */
  getArea = (id: string, params: RequestParams = {}) =>
    this.request<GetAreaData, GetAreaError>({
      path: `/api/areas/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Areas
   * @name UpdateArea
   * @summary Updates an existing area's name or configuration.
   * @request PUT:/api/areas/{Id}
   * @secure
   */
  updateArea = (
    id: string,
    data: UpdateAreaPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateAreaData, UpdateAreaError>({
      path: `/api/areas/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Areas
   * @name GetAccessibleAreas
   * @summary Returns areas accessible to the authenticated user based on their role and area assignments.
   * @request GET:/api/areas/accessibleAreas
   * @secure
   */
  getAccessibleAreas = (
    query: GetAccessibleAreasParams,
    params: RequestParams = {},
  ) =>
    this.request<GetAccessibleAreasData, any>({
      path: `/api/areas/accessibleAreas`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name RefreshToken
   * @summary Refreshes an admin user's Cognito session token using the current access and refresh token cookies.
   * @request POST:/api/auth/refresh
   * @secure
   */
  refreshToken = (params: RequestParams = {}) =>
    this.request<RefreshTokenData, any>({
      path: `/api/auth/refresh`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name Login
   * @summary Authenticates an admin user via AWS Cognito and returns a session token with associated cookies.
   * @request POST:/api/auth/login
   * @secure
   */
  login = (data: LoginPayload, params: RequestParams = {}) =>
    this.request<LoginData, any>({
      path: `/api/auth/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Auth
 * @name ForgotPassword
 * @summary Initiates a password reset for a staff/admin/partner user. Always returns 200 with a
generic success message — never reveals whether the username exists, to prevent
account enumeration. If the user exists and has an email on file, a reset link
pointing to the backoffice app is sent.
 * @request POST:/api/auth/forgot-password
 * @secure
 */
  forgotPassword = (data: ForgotPasswordPayload, params: RequestParams = {}) =>
    this.request<ForgotPasswordData, any>({
      path: `/api/auth/forgot-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags Auth
 * @name ResetPassword
 * @summary Completes a password reset for a staff/admin/partner user using the token from the
email link. Returns 400 if the token is invalid/expired or the username is unknown.
 * @request POST:/api/auth/reset-password
 * @secure
 */
  resetPassword = (data: ResetPasswordPayload, params: RequestParams = {}) =>
    this.request<ResetPasswordData, ResetPasswordError>({
      path: `/api/auth/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name GetRequests
   * @summary Returns a paginated list of booking requests (the unified Reservations browser), supporting lifecycle-stage (stages, repeatable, OR-ed), linked-reservation payment-status, status and date filters. Every row carries a server-derived lifecycle summary.
   * @request GET:/api/bookingRequests
   * @secure
   */
  getRequests = (query: GetRequestsParams, params: RequestParams = {}) =>
    this.request<GetRequestsData, any>({
      path: `/api/bookingRequests`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name CreateRequest
   * @summary Creates a new booking request with equipment type requirements, customer details, and pickup/return dates for a specified rental location.
   * @request POST:/api/bookingRequests
   * @secure
   */
  createRequest = (data: CreateRequestPayload, params: RequestParams = {}) =>
    this.request<CreateRequestData, CreateRequestError>({
      path: `/api/bookingRequests`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name GetRequest
   * @summary Returns the full details of a single booking request by its ID, including requested equipment types, quantities, customer info, and current status.
   * @request GET:/api/bookingRequests/{bookingRequestId}
   * @secure
   */
  getRequest = (bookingRequestId: string, params: RequestParams = {}) =>
    this.request<GetRequestData, GetRequestError>({
      path: `/api/bookingRequests/${bookingRequestId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name UpdateRequest
   * @summary Updates an existing booking request's equipment types, quantities, dates, customer info, or rental location; returns the updated request.
   * @request PUT:/api/bookingRequests/{bookingRequestId}
   * @secure
   */
  updateRequest = (
    bookingRequestId: string,
    data: UpdateRequestPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateRequestData, UpdateRequestError>({
      path: `/api/bookingRequests/${bookingRequestId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name GetRequestModifications
   * @summary Returns the staff modification history (audit trail) for a booking request, newest first: who changed it, when, whether it was an in-window manager override, and a JSON before→after change summary (BR-G1).
   * @request GET:/api/bookingRequests/{bookingRequestId}/modifications
   * @secure
   */
  getRequestModifications = (
    bookingRequestId: string,
    params: RequestParams = {},
  ) =>
    this.request<GetRequestModificationsData, GetRequestModificationsError>({
      path: `/api/bookingRequests/${bookingRequestId}/modifications`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name CancelRequest
   * @summary Cancels a pending booking request by ID, preventing it from being converted to an active booking (Admin, RentalManager, AreaManager, Manager, Employee only).
   * @request DELETE:/api/bookingRequests/{bookingRequestId}/cancel
   * @secure
   */
  cancelRequest = (
    bookingRequestId: string,
    data: CancelRequestPayload,
    params: RequestParams = {},
  ) =>
    this.request<CancelRequestData, CancelRequestError>({
      path: `/api/bookingRequests/${bookingRequestId}/cancel`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name UncancelRequest
   * @summary Restores a cancelled booking request by ID, reactivating it (Admin, RentalManager, AreaManager, Manager, Employee only).
   * @request POST:/api/bookingRequests/{bookingRequestId}/uncancel
   * @secure
   */
  uncancelRequest = (bookingRequestId: string, params: RequestParams = {}) =>
    this.request<UncancelRequestData, UncancelRequestError>({
      path: `/api/bookingRequests/${bookingRequestId}/uncancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name PreviewBulkCancelStale
   * @summary Admin-only dry-run of the stale-reservation bulk cancel: candidate counts + paid rows that will need manual refund review. No writes.
   * @request POST:/api/bookingRequests/bulk-cancel/preview
   * @secure
   */
  previewBulkCancelStale = (
    data: PreviewBulkCancelStalePayload,
    params: RequestParams = {},
  ) =>
    this.request<PreviewBulkCancelStaleData, PreviewBulkCancelStaleError>({
      path: `/api/bookingRequests/bulk-cancel/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BookingRequests
   * @name ExecuteBulkCancelStale
   * @summary Admin-only bulk cancel of stale never-picked-up reservations (silent: no emails, no Stripe). Paid rows are flagged in the response for manual refund review.
   * @request POST:/api/bookingRequests/bulk-cancel
   * @secure
   */
  executeBulkCancelStale = (
    data: ExecuteBulkCancelStalePayload,
    params: RequestParams = {},
  ) =>
    this.request<ExecuteBulkCancelStaleData, ExecuteBulkCancelStaleError>({
      path: `/api/bookingRequests/bulk-cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetWebsiteOrders
   * @summary Payment-linked rentals across reservations, subscriptions and walk-ins, including returned and cancelled orders.
   * @request GET:/api/bookings/website-orders
   * @secure
   */
  getWebsiteOrders = (
    query: GetWebsiteOrdersParams,
    params: RequestParams = {},
  ) =>
    this.request<GetWebsiteOrdersData, any>({
      path: `/api/bookings/website-orders`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetWebsiteOrderDetail
   * @request GET:/api/bookings/website-orders/{orderId}
   * @secure
   */
  getWebsiteOrderDetail = (orderId: string, params: RequestParams = {}) =>
    this.request<GetWebsiteOrderDetailData, any>({
      path: `/api/bookings/website-orders/${orderId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBooking
   * @summary Returns the full details of a single booking by its ID, including assigned equipment, customer info, pickup/return dates, and status.
   * @request GET:/api/bookings/{bookingId}
   * @secure
   */
  getBooking = (bookingId: string, params: RequestParams = {}) =>
    this.request<GetBookingData, any>({
      path: `/api/bookings/${bookingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name UpdateBooking
   * @summary Updates an existing booking's equipment, dates, customer info, or location details; returns the updated booking.
   * @request PUT:/api/bookings/{bookingId}
   * @secure
   */
  updateBooking = (
    bookingId: string,
    data: UpdateBookingPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateBookingData, UpdateBookingError>({
      path: `/api/bookings/${bookingId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookingModifications
   * @summary Returns the booking's history timeline (audit trail), newest first: pickup, return, walk-in payment and deposit events, with actor, description and any money moved. A booking converted from a reservation returns that reservation's unified timeline; a walk-in returns its own (#499 / BK-G1).
   * @request GET:/api/bookings/{bookingId}/modifications
   * @secure
   */
  getBookingModifications = (bookingId: string, params: RequestParams = {}) =>
    this.request<GetBookingModificationsData, GetBookingModificationsError>({
      path: `/api/bookings/${bookingId}/modifications`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name SearchBooking
   * @summary Looks up a booking by its booking reference string, useful for staff searching by customer-facing reference codes.
   * @request GET:/api/bookings/search/{BookingReference}
   * @secure
   */
  searchBooking = (bookingReference: string, params: RequestParams = {}) =>
    this.request<SearchBookingData, any>({
      path: `/api/bookings/search/${bookingReference}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookingsForRental
   * @summary Returns a paginated list of all bookings for a specific rental location, including active and historical bookings.
   * @request GET:/api/bookings/rental/{locationId}
   * @secure
   */
  getBookingsForRental = (
    { locationId, ...query }: GetBookingsForRentalParams,
    params: RequestParams = {},
  ) =>
    this.request<GetBookingsForRentalData, any>({
      path: `/api/bookings/rental/${locationId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookings
   * @summary Returns a paginated list of all bookings across accessible locations, supporting filters for status, date range, and customer search.
   * @request GET:/api/bookings
   * @secure
   */
  getBookings = (query: GetBookingsParams, params: RequestParams = {}) =>
    this.request<GetBookingsData, any>({
      path: `/api/bookings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name CreateBooking
   * @summary Creates a new booking with specific equipment item assignments, customer details, pickup/return locations, and optional conversion from a booking request.
   * @request POST:/api/bookings
   * @secure
   */
  createBooking = (data: CreateBookingPayload, params: RequestParams = {}) =>
    this.request<CreateBookingData, CreateBookingError>({
      path: `/api/bookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetReturnedBookings
   * @summary Returns a paginated list of bookings where equipment has already been returned to the rental location.
   * @request GET:/api/bookings/Returned
   * @secure
   */
  getReturnedBookings = (
    query: GetReturnedBookingsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetReturnedBookingsData, any>({
      path: `/api/bookings/Returned`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetPendingPickupBookings
   * @summary Returns a paginated list of bookings awaiting customer equipment pickup, optionally filtered by rental location.
   * @request GET:/api/bookings/PendingPickup
   * @secure
   */
  getPendingPickupBookings = (
    query: GetPendingPickupBookingsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetPendingPickupBookingsData, any>({
      path: `/api/bookings/PendingPickup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetPendingReturnBookings
   * @summary Returns a paginated list of active bookings awaiting equipment return from customers, optionally filtered by rental location.
   * @request GET:/api/bookings/PendingReturn
   * @secure
   */
  getPendingReturnBookings = (
    query: GetPendingReturnBookingsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetPendingReturnBookingsData, any>({
      path: `/api/bookings/PendingReturn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name PreviewBookingPickup
   * @request POST:/api/bookings/pickup-preview
   * @secure
   */
  previewBookingPickup = (
    data: PreviewBookingPickupPayload,
    params: RequestParams = {},
  ) =>
    this.request<PreviewBookingPickupData, any>({
      path: `/api/bookings/pickup-preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookingRequests
   * @summary Returns a paginated list of unconfirmed booking requests (customer reservations not yet assigned specific equipment), supporting status and date filters.
   * @request GET:/api/bookings/request
   * @secure
   */
  getBookingRequests = (
    query: GetBookingRequestsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetBookingRequestsData, any>({
      path: `/api/bookings/request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name CreateBookingRequest
   * @summary Creates a new booking request from an external or staff-initiated reservation, converting local dates to UTC and associating equipment type requirements with a rental location.
   * @request POST:/api/bookings/request
   * @secure
   */
  createBookingRequest = (
    data: CreateBookingRequestPayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateBookingRequestData, CreateBookingRequestError>({
      path: `/api/bookings/request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookingRequest
   * @summary Returns the full details of a single booking request by its ID, including requested equipment types and quantities, customer info, and status.
   * @request GET:/api/bookings/request/{bookingRequestId}
   * @secure
   */
  getBookingRequest = (bookingRequestId: string, params: RequestParams = {}) =>
    this.request<GetBookingRequestData, any>({
      path: `/api/bookings/request/${bookingRequestId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name UpdateBookingRequest
   * @summary Updates an existing booking request's equipment type requirements, dates, customer info, or rental location; returns the updated request.
   * @request PUT:/api/bookings/request/{bookingRequestId}
   * @secure
   */
  updateBookingRequest = (
    bookingRequestId: string,
    data: UpdateBookingRequestPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateBookingRequestData, UpdateBookingRequestError>({
      path: `/api/bookings/request/${bookingRequestId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name CancelBookingRequest
   * @summary Cancels a pending booking request, preventing it from being converted into an active booking (Admin, RentalManager, AreaManager, Manager, Employee only).
   * @request DELETE:/api/bookings/request/{bookingId}/cancel
   * @secure
   */
  cancelBookingRequest = (bookingId: string, params: RequestParams = {}) =>
    this.request<CancelBookingRequestData, any>({
      path: `/api/bookings/request/${bookingId}/cancel`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name UncancelBookingRequest
   * @summary Restores a cancelled booking request, reactivating it (Admin, RentalManager, AreaManager, Manager, Employee only).
   * @request POST:/api/bookings/request/{bookingId}/uncancel
   * @secure
   */
  uncancelBookingRequest = (bookingId: string, params: RequestParams = {}) =>
    this.request<UncancelBookingRequestData, UncancelBookingRequestError>({
      path: `/api/bookings/request/${bookingId}/uncancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name ReturnBooking
   * @summary Processes equipment return for a booking, recording return date, condition per item, missing/damaged accessories, and optional return location if different from pickup.
   * @request POST:/api/bookings/return/{bookingId}
   * @secure
   */
  returnBooking = (
    bookingId: string,
    data: ReturnBookingPayload,
    params: RequestParams = {},
  ) =>
    this.request<ReturnBookingData, any>({
      path: `/api/bookings/return/${bookingId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Bookings
 * @name UnreturnBooking
 * @summary Reverts a mistaken equipment return for the selected booking items (managers and above only).
Reopens the booking, puts the units back in rented-out state at their pre-return location,
clears their needs-cleaning flag and unwinds the linked website-reservation return sync.
Items returned as damaged and bookings with an already-refunded deposit are rejected.
 * @request POST:/api/bookings/unreturn/{bookingId}
 * @secure
 */
  unreturnBooking = (
    bookingId: string,
    data: UnreturnBookingPayload,
    params: RequestParams = {},
  ) =>
    this.request<UnreturnBookingData, UnreturnBookingError>({
      path: `/api/bookings/unreturn/${bookingId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name PickUpBooking
   * @summary Confirms equipment pickup for a booking, marking items as rented and starting the active rental period, optionally overriding the pickup location.
   * @request POST:/api/bookings/pickUp/{bookingId}
   * @secure
   */
  pickUpBooking = (
    { bookingId, ...query }: PickUpBookingParams,
    params: RequestParams = {},
  ) =>
    this.request<PickUpBookingData, any>({
      path: `/api/bookings/pickUp/${bookingId}`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Bookings
 * @name UndoPickup
 * @summary Undoes a mistaken pickup by reverting the booking back to a pending booking request.
Use this when equipment was marked as picked up by mistake but wasn't actually taken.
The booking is deleted, equipment status is reset to Available, and the booking request becomes pending again.
 * @request POST:/api/bookings/undo-pickup/{bookingId}
 * @secure
 */
  undoPickup = (bookingId: string, params: RequestParams = {}) =>
    this.request<UndoPickupData, UndoPickupError>({
      path: `/api/bookings/undo-pickup/${bookingId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookingByEquipment
   * @summary Finds an active booking by the equipment item's reference code (e.g., QR/barcode), useful for scanner-based workflows.
   * @request GET:/api/bookings/booking/equipment/{itemReference}
   * @secure
   */
  getBookingByEquipment = (itemReference: string, params: RequestParams = {}) =>
    this.request<GetBookingByEquipmentData, any>({
      path: `/api/bookings/booking/equipment/${itemReference}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetPendingRefunds
   * @summary Returns a paginated list of returned bookings awaiting deposit refund processing, including SLA status and cancellation requests.
   * @request GET:/api/bookings/pending-refunds
   * @secure
   */
  getPendingRefunds = (
    query: GetPendingRefundsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetPendingRefundsData, any>({
      path: `/api/bookings/pending-refunds`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name ProcessRefund
   * @summary Processes a deposit refund for a returned booking, recording refund amount, notes, and Stripe payment intent ID.
   * @request POST:/api/bookings/{bookingId}/process-refund
   * @secure
   */
  processRefund = (
    bookingId: string,
    data: ProcessRefundPayload,
    params: RequestParams = {},
  ) =>
    this.request<ProcessRefundData, any>({
      path: `/api/bookings/${bookingId}/process-refund`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name RecordDepositDeduction
   * @summary Records a deposit deduction against a booking for damage, missing parts, or other charges, reducing the refundable deposit amount.
   * @request POST:/api/bookings/{bookingId}/deposit-deduction
   * @secure
   */
  recordDepositDeduction = (
    bookingId: string,
    data: RecordDepositDeductionPayload,
    params: RequestParams = {},
  ) =>
    this.request<RecordDepositDeductionData, any>({
      path: `/api/bookings/${bookingId}/deposit-deduction`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetNextContractReference
   * @summary Returns the next available DOR{NNN} correlative contract reference for a new booking.
   * @request GET:/api/bookings/next-reference
   * @secure
   */
  getNextContractReference = (params: RequestParams = {}) =>
    this.request<GetNextContractReferenceData, any>({
      path: `/api/bookings/next-reference`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookingPaymentQuote
   * @summary Auto-calculates the rental and deposit amounts for a booking's equipment over its rental window, used to pre-fill the walk-in payment panel.
   * @request GET:/api/bookings/{bookingId}/payment/quote
   * @secure
   */
  getBookingPaymentQuote = (bookingId: string, params: RequestParams = {}) =>
    this.request<GetBookingPaymentQuoteData, any>({
      path: `/api/bookings/${bookingId}/payment/quote`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GenerateBookingPaymentLink
   * @summary Generates a Stripe Checkout payment link/QR for a walk-in booking, returning the active payment with its checkout URL.
   * @request POST:/api/bookings/{bookingId}/payment-link
   * @secure
   */
  generateBookingPaymentLink = (
    bookingId: string,
    data: GenerateBookingPaymentLinkPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      GenerateBookingPaymentLinkData,
      GenerateBookingPaymentLinkError
    >({
      path: `/api/bookings/${bookingId}/payment-link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name GetBookingPayment
   * @summary Returns the active walk-in payment for a booking, polling Stripe live for completion. Returns 204 when no payment exists.
   * @request GET:/api/bookings/{bookingId}/payment
   * @secure
   */
  getBookingPayment = (bookingId: string, params: RequestParams = {}) =>
    this.request<GetBookingPaymentData, any>({
      path: `/api/bookings/${bookingId}/payment`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bookings
   * @name VoidBookingPaymentLink
   * @summary Voids (expires) a pending walk-in payment link so a new one can be generated.
   * @request POST:/api/bookings/{bookingId}/payment/void
   * @secure
   */
  voidBookingPaymentLink = (bookingId: string, params: RequestParams = {}) =>
    this.request<VoidBookingPaymentLinkData, VoidBookingPaymentLinkError>({
      path: `/api/bookings/${bookingId}/payment/void`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartnerCategories
   * @name BusinessPartnerCategoriesList
   * @summary Returns all business partner categories, optionally including inactive ones.
   * @request GET:/api/BusinessPartnerCategories
   * @secure
   */
  businessPartnerCategoriesList = (
    query: BusinessPartnerCategoriesListParams,
    params: RequestParams = {},
  ) =>
    this.request<BusinessPartnerCategoriesListData, any>({
      path: `/api/BusinessPartnerCategories`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartnerCategories
   * @name BusinessPartnerCategoriesCreate
   * @summary Creates a new category for grouping business partners.
   * @request POST:/api/BusinessPartnerCategories
   * @secure
   */
  businessPartnerCategoriesCreate = (
    data: BusinessPartnerCategoriesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<BusinessPartnerCategoriesCreateData, any>({
      path: `/api/BusinessPartnerCategories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartnerCategories
   * @name BusinessPartnerCategoriesDetail
   * @summary Returns a specific business partner category by ID.
   * @request GET:/api/BusinessPartnerCategories/{id}
   * @secure
   */
  businessPartnerCategoriesDetail = (id: number, params: RequestParams = {}) =>
    this.request<BusinessPartnerCategoriesDetailData, any>({
      path: `/api/BusinessPartnerCategories/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartnerCategories
   * @name BusinessPartnerCategoriesUpdate
   * @summary Updates the name, icon, description, or display order of a business partner category.
   * @request PUT:/api/BusinessPartnerCategories/{id}
   * @secure
   */
  businessPartnerCategoriesUpdate = (
    id: number,
    data: BusinessPartnerCategoriesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<BusinessPartnerCategoriesUpdateData, any>({
      path: `/api/BusinessPartnerCategories/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartnerCategories
   * @name BusinessPartnerCategoriesDelete
   * @summary Deletes a business partner category by ID.
   * @request DELETE:/api/BusinessPartnerCategories/{id}
   * @secure
   */
  businessPartnerCategoriesDelete = (id: number, params: RequestParams = {}) =>
    this.request<BusinessPartnerCategoriesDeleteData, any>({
      path: `/api/BusinessPartnerCategories/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartnerCategories
   * @name BusinessPartnerCategoriesReorderCreate
   * @summary Reorders business partner categories according to the supplied list of IDs.
   * @request POST:/api/BusinessPartnerCategories/reorder
   * @secure
   */
  businessPartnerCategoriesReorderCreate = (
    data: BusinessPartnerCategoriesReorderCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<BusinessPartnerCategoriesReorderCreateData, any>({
      path: `/api/BusinessPartnerCategories/reorder`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersList
   * @summary Returns all business partner records with optional filtering by category, featured status, or active state.
   * @request GET:/api/businesspartners
   * @secure
   */
  businesspartnersList = (
    query: BusinesspartnersListParams,
    params: RequestParams = {},
  ) =>
    this.request<BusinesspartnersListData, any>({
      path: `/api/businesspartners`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersCreate
   * @summary Creates a new business partner record.
   * @request POST:/api/businesspartners
   * @secure
   */
  businesspartnersCreate = (
    data: BusinesspartnersCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<BusinesspartnersCreateData, any>({
      path: `/api/businesspartners`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersDetail
   * @summary Returns a specific business partner record by ID.
   * @request GET:/api/businesspartners/{id}
   * @secure
   */
  businesspartnersDetail = (id: string, params: RequestParams = {}) =>
    this.request<BusinesspartnersDetailData, any>({
      path: `/api/businesspartners/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersUpdate
   * @summary Updates the details, category, and visibility settings for a business partner record.
   * @request PUT:/api/businesspartners/{id}
   * @secure
   */
  businesspartnersUpdate = (
    id: string,
    data: BusinesspartnersUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<BusinesspartnersUpdateData, any>({
      path: `/api/businesspartners/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersDelete
   * @summary Removes business partner status from a company record.
   * @request DELETE:/api/businesspartners/{id}
   * @secure
   */
  businesspartnersDelete = (id: string, params: RequestParams = {}) =>
    this.request<BusinesspartnersDeleteData, any>({
      path: `/api/businesspartners/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersLogoCreate
   * @summary Uploads a logo image for a business partner record and returns the storage URL.
   * @request POST:/api/businesspartners/{id}/logo
   * @secure
   */
  businesspartnersLogoCreate = (
    id: string,
    data: BusinesspartnersLogoCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<BusinesspartnersLogoCreateData, any>({
      path: `/api/businesspartners/${id}/logo`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersLogoDelete
   * @summary Removes the logo image from a business partner record.
   * @request DELETE:/api/businesspartners/{id}/logo
   * @secure
   */
  businesspartnersLogoDelete = (id: string, params: RequestParams = {}) =>
    this.request<BusinesspartnersLogoDeleteData, any>({
      path: `/api/businesspartners/${id}/logo`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags BusinessPartners
   * @name BusinesspartnersReorderCreate
   * @summary Reorders business partner records according to the supplied list of IDs.
   * @request POST:/api/businesspartners/reorder
   * @secure
   */
  businesspartnersReorderCreate = (
    data: BusinesspartnersReorderCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<BusinesspartnersReorderCreateData, any>({
      path: `/api/businesspartners/reorder`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name CreateCompany
   * @summary Creates a new company record used for the business partner and public partner directory.
   * @request POST:/api/companies
   * @secure
   */
  createCompany = (data: CreateCompanyPayload, params: RequestParams = {}) =>
    this.request<CreateCompanyData, any>({
      path: `/api/companies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name GetCompanies
   * @summary Returns all companies in the system.
   * @request GET:/api/companies
   * @secure
   */
  getCompanies = (params: RequestParams = {}) =>
    this.request<GetCompaniesData, any>({
      path: `/api/companies`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name GetCompany
   * @summary Returns details for a single company by ID.
   * @request GET:/api/companies/{id}
   * @secure
   */
  getCompany = (id: string, params: RequestParams = {}) =>
    this.request<GetCompanyData, any>({
      path: `/api/companies/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name UpdateCompany
   * @summary Updates a company's details, visibility, and featured status.
   * @request PUT:/api/companies/{id}
   * @secure
   */
  updateCompany = (
    id: string,
    data: UpdateCompanyPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCompanyData, any>({
      path: `/api/companies/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name DeleteCompany
   * @request DELETE:/api/companies/{id}
   * @secure
   */
  deleteCompany = (id: string, params: RequestParams = {}) =>
    this.request<DeleteCompanyData, any>({
      path: `/api/companies/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name GetCompanyBillingReadiness
   * @summary Returns whether the company is invoice-ready and which required legal fields are still missing.
   * @request GET:/api/companies/{id}/billing-readiness
   * @secure
   */
  getCompanyBillingReadiness = (id: string, params: RequestParams = {}) =>
    this.request<GetCompanyBillingReadinessData, any>({
      path: `/api/companies/${id}/billing-readiness`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name CreateCompanyPaymentProfile
   * @summary Creates a masked Stripe payment profile under the specified company.
   * @request POST:/api/companies/{id}/payment-profiles
   * @secure
   */
  createCompanyPaymentProfile = (
    id: string,
    data: CreateCompanyPaymentProfilePayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateCompanyPaymentProfileData, any>({
      path: `/api/companies/${id}/payment-profiles`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name UpdateCompanyPaymentProfile
   * @summary Updates or disables an existing company payment profile without ever returning plaintext secrets.
   * @request PUT:/api/companies/{id}/payment-profiles/{paymentProfileId}
   * @secure
   */
  updateCompanyPaymentProfile = (
    id: string,
    paymentProfileId: string,
    data: UpdateCompanyPaymentProfilePayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCompanyPaymentProfileData, any>({
      path: `/api/companies/${id}/payment-profiles/${paymentProfileId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name DeleteCompanyPaymentProfile
   * @summary Permanently deletes a company payment profile. Fails if any location still references it.
   * @request DELETE:/api/companies/{id}/payment-profiles/{paymentProfileId}
   * @secure
   */
  deleteCompanyPaymentProfile = (
    id: string,
    paymentProfileId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      DeleteCompanyPaymentProfileData,
      DeleteCompanyPaymentProfileError
    >({
      path: `/api/companies/${id}/payment-profiles/${paymentProfileId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name CreateCompanyContact
   * @summary Adds a new contact person to the specified company.
   * @request POST:/api/companies/{id}/contact
   * @secure
   */
  createCompanyContact = (
    id: string,
    data: CreateCompanyContactPayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateCompanyContactData, any>({
      path: `/api/companies/${id}/contact`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name GetCompanyContacts
   * @summary Returns a paginated list of contacts for the specified company.
   * @request GET:/api/companies/{id}/contacts
   * @secure
   */
  getCompanyContacts = (
    { id, ...query }: GetCompanyContactsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetCompanyContactsData, any>({
      path: `/api/companies/${id}/contacts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name GetCompanyContactById
   * @summary Returns a specific contact for a company by their contact ID.
   * @request GET:/api/companies/{id}/contact/{contactId}
   * @secure
   */
  getCompanyContactById = (
    id: string,
    contactId: string,
    params: RequestParams = {},
  ) =>
    this.request<GetCompanyContactByIdData, any>({
      path: `/api/companies/${id}/contact/${contactId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name UpdateCompanyContact
   * @summary Updates a company contact's name, email, or phone number.
   * @request PUT:/api/companies/{id}/contact/{contactId}
   * @secure
   */
  updateCompanyContact = (
    id: string,
    contactId: string,
    data: UpdateCompanyContactPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCompanyContactData, any>({
      path: `/api/companies/${id}/contact/${contactId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerAccessories
 * @name CustomerAccessoriesList
 * @summary Get accessories catalog for customers.
Only returns accessories with IsVisibleToCustomers = true.
 * @request GET:/api/customer/accessories
 * @secure
 */
  customerAccessoriesList = (
    query: CustomerAccessoriesListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAccessoriesListData, any>({
      path: `/api/customer/accessories`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAccessories
   * @name CustomerAccessoriesDetail
   * @summary Get accessory details by ID
   * @request GET:/api/customer/accessories/{id}
   * @secure
   */
  customerAccessoriesDetail = (
    { id, ...query }: CustomerAccessoriesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAccessoriesDetailData, CustomerAccessoriesDetailError>(
      {
        path: `/api/customer/accessories/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
 * No description
 *
 * @tags CustomerAccessories
 * @name CustomerAccessoriesForEquipmentTypeDetail
 * @summary Get suggested accessories for an equipment type.
This enables cross-selling accessories on the product detail page.
            
FIXED: Now correctly queries accessories linked to the equipment type
via the AccessoriesIncluded many-to-many relationship.
 * @request GET:/api/customer/accessories/for-equipment-type/{equipmentTypeId}
 * @secure
 */
  customerAccessoriesForEquipmentTypeDetail = (
    {
      equipmentTypeId,
      ...query
    }: CustomerAccessoriesForEquipmentTypeDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAccessoriesForEquipmentTypeDetailData, any>({
      path: `/api/customer/accessories/for-equipment-type/${equipmentTypeId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerAccessories
 * @name CustomerAccessoriesCheckAvailabilityCreate
 * @summary Check availability and get pricing for an accessory.
Uses the same tiered pricing logic as equipment types.
 * @request POST:/api/customer/accessories/{id}/check-availability
 * @secure
 */
  customerAccessoriesCheckAvailabilityCreate = (
    id: string,
    data: CustomerAccessoriesCheckAvailabilityCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerAccessoriesCheckAvailabilityCreateData,
      CustomerAccessoriesCheckAvailabilityCreateError
    >({
      path: `/api/customer/accessories/${id}/check-availability`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAgreements
   * @name CreateCustomerAgreement
   * @summary Creates a rental agreement record for a booking equipment item including customer signature.
   * @request POST:/api/customer-agreements
   * @secure
   */
  createCustomerAgreement = (
    data: CreateCustomerAgreementPayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateCustomerAgreementData, any>({
      path: `/api/customer-agreements`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAgreements
   * @name GetCustomerAgreementByBookingEquipmentId
   * @summary Returns the rental agreement associated with a specific booking equipment record.
   * @request GET:/api/customer-agreements/booking-equipment/{bookingEquipmentId}
   * @secure
   */
  getCustomerAgreementByBookingEquipmentId = (
    bookingEquipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<GetCustomerAgreementByBookingEquipmentIdData, any>({
      path: `/api/customer-agreements/booking-equipment/${bookingEquipmentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAgreements
   * @name UpdateCustomerAgreement
   * @summary Updates the signature, condition photos, or notes on an existing rental agreement.
   * @request PUT:/api/customer-agreements/{id}
   * @secure
   */
  updateCustomerAgreement = (
    id: string,
    data: UpdateCustomerAgreementPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCustomerAgreementData, any>({
      path: `/api/customer-agreements/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAgreements
   * @name DeleteCustomerAgreement
   * @summary Deletes a rental agreement record by ID.
   * @request DELETE:/api/customer-agreements/{id}
   * @secure
   */
  deleteCustomerAgreement = (id: string, params: RequestParams = {}) =>
    this.request<DeleteCustomerAgreementData, any>({
      path: `/api/customer-agreements/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAgreements
   * @name GetCustomerAgreementsByBookingId
   * @summary Returns all rental agreements associated with a specific booking.
   * @request GET:/api/customer-agreements/booking/{bookingId}
   * @secure
   */
  getCustomerAgreementsByBookingId = (
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<GetCustomerAgreementsByBookingIdData, any>({
      path: `/api/customer-agreements/booking/${bookingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAgreements
   * @name CustomerAgreementsUploadPhotosCreate
   * @summary Uploads condition photos for a rental agreement and returns their storage URLs.
   * @request POST:/api/customer-agreements/upload-photos
   * @secure
   */
  customerAgreementsUploadPhotosCreate = (
    data: CustomerAgreementsUploadPhotosCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAgreementsUploadPhotosCreateData, any>({
      path: `/api/customer-agreements/upload-photos`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthRegisterCreate
   * @summary Customer registration
   * @request POST:/api/customer/auth/register
   * @secure
   */
  customerAuthRegisterCreate = (
    data: CustomerAuthRegisterCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerAuthRegisterCreateData,
      CustomerAuthRegisterCreateError
    >({
      path: `/api/customer/auth/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthLoginCreate
   * @summary Customer login
   * @request POST:/api/customer/auth/login
   * @secure
   */
  customerAuthLoginCreate = (
    data: CustomerAuthLoginCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAuthLoginCreateData, CustomerAuthLoginCreateError>({
      path: `/api/customer/auth/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthRefreshCreate
   * @summary Refresh customer access token
   * @request POST:/api/customer/auth/refresh
   * @secure
   */
  customerAuthRefreshCreate = (
    data: CustomerAuthRefreshCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAuthRefreshCreateData, CustomerAuthRefreshCreateError>(
      {
        path: `/api/customer/auth/refresh`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthProfileList
   * @summary Get current customer profile
   * @request GET:/api/customer/auth/profile
   * @secure
   */
  customerAuthProfileList = (params: RequestParams = {}) =>
    this.request<CustomerAuthProfileListData, CustomerAuthProfileListError>({
      path: `/api/customer/auth/profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthProfileUpdate
   * @summary Update customer profile
   * @request PUT:/api/customer/auth/profile
   * @secure
   */
  customerAuthProfileUpdate = (
    data: CustomerAuthProfileUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAuthProfileUpdateData, CustomerAuthProfileUpdateError>(
      {
        path: `/api/customer/auth/profile`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthForgotPasswordCreate
   * @summary Request password reset
   * @request POST:/api/customer/auth/forgot-password
   * @secure
   */
  customerAuthForgotPasswordCreate = (
    data: CustomerAuthForgotPasswordCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAuthForgotPasswordCreateData, any>({
      path: `/api/customer/auth/forgot-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthResetPasswordCreate
   * @summary Reset password with token
   * @request POST:/api/customer/auth/reset-password
   * @secure
   */
  customerAuthResetPasswordCreate = (
    data: CustomerAuthResetPasswordCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerAuthResetPasswordCreateData,
      CustomerAuthResetPasswordCreateError
    >({
      path: `/api/customer/auth/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerAuth
 * @name CustomerAuthVerifyEmailCreate
 * @summary Confirm the customer's email with the token from the verification link.
Reservations matched only by email become visible once the email is verified.
 * @request POST:/api/customer/auth/verify-email
 * @secure
 */
  customerAuthVerifyEmailCreate = (
    data: CustomerAuthVerifyEmailCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerAuthVerifyEmailCreateData,
      CustomerAuthVerifyEmailCreateError
    >({
      path: `/api/customer/auth/verify-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthResendVerificationCreate
   * @summary Re-send the email verification link. Always 200, whether or not the email exists.
   * @request POST:/api/customer/auth/resend-verification
   * @secure
   */
  customerAuthResendVerificationCreate = (
    data: CustomerAuthResendVerificationCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerAuthResendVerificationCreateData, any>({
      path: `/api/customer/auth/resend-verification`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerAuth
   * @name CustomerAuthPasswordRequirementsList
   * @summary Returns the active password policy (used by frontends to drive client-side validation)
   * @request GET:/api/customer/auth/password-requirements
   * @secure
   */
  customerAuthPasswordRequirementsList = (params: RequestParams = {}) =>
    this.request<CustomerAuthPasswordRequirementsListData, any>({
      path: `/api/customer/auth/password-requirements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartList
   * @summary Get current cart contents
   * @request GET:/api/customer/cart
   * @secure
   */
  customerCartList = (params: RequestParams = {}) =>
    this.request<CustomerCartListData, any>({
      path: `/api/customer/cart`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartDelete
   * @summary Clear the entire cart
   * @request DELETE:/api/customer/cart
   * @secure
   */
  customerCartDelete = (params: RequestParams = {}) =>
    this.request<CustomerCartDeleteData, CustomerCartDeleteError>({
      path: `/api/customer/cart`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartItemsCreate
   * @summary Add item to cart
   * @request POST:/api/customer/cart/items
   * @secure
   */
  customerCartItemsCreate = (
    data: CustomerCartItemsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerCartItemsCreateData, CustomerCartItemsCreateError>({
      path: `/api/customer/cart/items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartPricingCreate
   * @summary Calculate pricing for cart contents
   * @request POST:/api/customer/cart/pricing
   * @secure
   */
  customerCartPricingCreate = (
    data: CustomerCartPricingCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerCartPricingCreateData, CustomerCartPricingCreateError>(
      {
        path: `/api/customer/cart/pricing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartItemsPricingCreate
   * @summary Calculate pricing for a single item (for PDP)
   * @request POST:/api/customer/cart/items/pricing
   * @secure
   */
  customerCartItemsPricingCreate = (
    data: CustomerCartItemsPricingCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerCartItemsPricingCreateData,
      CustomerCartItemsPricingCreateError
    >({
      path: `/api/customer/cart/items/pricing`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerCart
 * @name CustomerCartValidateCreate
 * @summary Validate cart items for availability at specified dates and location.
Returns detailed validation result for each item including availability status.
 * @request POST:/api/customer/cart/validate
 * @secure
 */
  customerCartValidateCreate = (
    data: CustomerCartValidateCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerCartValidateCreateData,
      CustomerCartValidateCreateError
    >({
      path: `/api/customer/cart/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartItemsUpdate
   * @summary Update cart item quantity
   * @request PUT:/api/customer/cart/items/{itemId}
   * @secure
   */
  customerCartItemsUpdate = (
    itemId: string,
    data: CustomerCartItemsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerCartItemsUpdateData, CustomerCartItemsUpdateError>({
      path: `/api/customer/cart/items/${itemId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartItemsDelete
   * @summary Remove item from cart
   * @request DELETE:/api/customer/cart/items/{itemId}
   * @secure
   */
  customerCartItemsDelete = (itemId: string, params: RequestParams = {}) =>
    this.request<CustomerCartItemsDeleteData, CustomerCartItemsDeleteError>({
      path: `/api/customer/cart/items/${itemId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartAccessoriesCreate
   * @summary Add accessory item to cart
   * @request POST:/api/customer/cart/accessories
   * @secure
   */
  customerCartAccessoriesCreate = (
    data: CustomerCartAccessoriesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerCartAccessoriesCreateData,
      CustomerCartAccessoriesCreateError
    >({
      path: `/api/customer/cart/accessories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartAccessoriesUpdate
   * @summary Update accessory item quantity in cart
   * @request PUT:/api/customer/cart/accessories/{accessoryItemId}
   * @secure
   */
  customerCartAccessoriesUpdate = (
    accessoryItemId: string,
    data: CustomerCartAccessoriesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerCartAccessoriesUpdateData,
      CustomerCartAccessoriesUpdateError
    >({
      path: `/api/customer/cart/accessories/${accessoryItemId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCart
   * @name CustomerCartAccessoriesDelete
   * @summary Remove accessory item from cart
   * @request DELETE:/api/customer/cart/accessories/{accessoryItemId}
   * @secure
   */
  customerCartAccessoriesDelete = (
    accessoryItemId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerCartAccessoriesDeleteData,
      CustomerCartAccessoriesDeleteError
    >({
      path: `/api/customer/cart/accessories/${accessoryItemId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerCart
 * @name CustomerCartTransferCreate
 * @summary Transfer a session-based cart to the authenticated user.
Deactivates any previous user carts — the session cart becomes the active cart.
Called when an anonymous user logs in.
 * @request POST:/api/customer/cart/transfer
 * @secure
 */
  customerCartTransferCreate = (
    data: CustomerCartTransferCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerCartTransferCreateData,
      CustomerCartTransferCreateError
    >({
      path: `/api/customer/cart/transfer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCategories
   * @name CustomerCategoriesList
   * @summary Returns equipment categories visible to customers for browsing the rental catalog.
   * @request GET:/api/customer/categories
   * @secure
   */
  customerCategoriesList = (
    query: CustomerCategoriesListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerCategoriesListData, any>({
      path: `/api/customer/categories`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCategories
   * @name CustomerCategoriesTreeList
   * @summary Returns customer-visible equipment categories as a nested tree for catalog navigation.
   * @request GET:/api/customer/categories/tree
   * @secure
   */
  customerCategoriesTreeList = (
    query: CustomerCategoriesTreeListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerCategoriesTreeListData, any>({
      path: `/api/customer/categories/tree`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCategories
   * @name CustomerCategoriesFeaturedList
   * @summary Returns featured equipment categories for display on the customer homepage.
   * @request GET:/api/customer/categories/featured
   * @secure
   */
  customerCategoriesFeaturedList = (
    query: CustomerCategoriesFeaturedListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerCategoriesFeaturedListData, any>({
      path: `/api/customer/categories/featured`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCategories
   * @name CustomerCategoriesBySlugDetail
   * @summary Returns details for a customer-visible equipment category by URL slug.
   * @request GET:/api/customer/categories/by-slug/{slug}
   * @secure
   */
  customerCategoriesBySlugDetail = (
    { slug, ...query }: CustomerCategoriesBySlugDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerCategoriesBySlugDetailData,
      CustomerCategoriesBySlugDetailError
    >({
      path: `/api/customer/categories/by-slug/${slug}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerCategories
   * @name CustomerCategoriesRelatedList
   * @summary Returns equipment categories related to the given category for cross-sell navigation.
   * @request GET:/api/customer/categories/{id}/related
   * @secure
   */
  customerCategoriesRelatedList = (
    { id, ...query }: CustomerCategoriesRelatedListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerCategoriesRelatedListData, any>({
      path: `/api/customer/categories/${id}/related`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesList
   * @summary Get equipment types catalog for customers with search and filtering
   * @request GET:/api/customer/equipment-types
   * @secure
   */
  customerEquipmentTypesList = (
    query: CustomerEquipmentTypesListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerEquipmentTypesListData, any>({
      path: `/api/customer/equipment-types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesDetail
   * @summary Get equipment type details by ID
   * @request GET:/api/customer/equipment-types/{id}
   * @secure
   */
  customerEquipmentTypesDetail = (
    { id, ...query }: CustomerEquipmentTypesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerEquipmentTypesDetailData,
      CustomerEquipmentTypesDetailError
    >({
      path: `/api/customer/equipment-types/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesBySlugDetail
   * @summary Get equipment type details by URL-friendly slug
   * @request GET:/api/customer/equipment-types/by-slug/{slug}
   * @secure
   */
  customerEquipmentTypesBySlugDetail = (
    { slug, ...query }: CustomerEquipmentTypesBySlugDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerEquipmentTypesBySlugDetailData,
      CustomerEquipmentTypesBySlugDetailError
    >({
      path: `/api/customer/equipment-types/by-slug/${slug}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesRelatedList
   * @summary Get related equipment types for a given equipment type
   * @request GET:/api/customer/equipment-types/{id}/related
   * @secure
   */
  customerEquipmentTypesRelatedList = (
    { id, ...query }: CustomerEquipmentTypesRelatedListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerEquipmentTypesRelatedListData, any>({
      path: `/api/customer/equipment-types/${id}/related`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesCategoriesList
   * @summary Get available categories for filtering
   * @request GET:/api/customer/equipment-types/categories
   * @secure
   */
  customerEquipmentTypesCategoriesList = (params: RequestParams = {}) =>
    this.request<CustomerEquipmentTypesCategoriesListData, any>({
      path: `/api/customer/equipment-types/categories`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesReviewsList
   * @summary Get approved public reviews for an equipment type.
   * @request GET:/api/customer/equipment-types/{id}/reviews
   * @secure
   */
  customerEquipmentTypesReviewsList = (
    { id, ...query }: CustomerEquipmentTypesReviewsListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerEquipmentTypesReviewsListData,
      CustomerEquipmentTypesReviewsListError
    >({
      path: `/api/customer/equipment-types/${id}/reviews`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesReviewSummaryList
   * @summary Get approved review summary (average rating and approved count) for an equipment type.
   * @request GET:/api/customer/equipment-types/{id}/review-summary
   * @secure
   */
  customerEquipmentTypesReviewSummaryList = (
    id: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerEquipmentTypesReviewSummaryListData,
      CustomerEquipmentTypesReviewSummaryListError
    >({
      path: `/api/customer/equipment-types/${id}/review-summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesCheckAvailabilityCreate
   * @summary Check availability for specific equipment type and date range
   * @request POST:/api/customer/equipment-types/{id}/check-availability
   * @secure
   */
  customerEquipmentTypesCheckAvailabilityCreate = (
    id: string,
    data: CustomerEquipmentTypesCheckAvailabilityCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerEquipmentTypesCheckAvailabilityCreateData,
      CustomerEquipmentTypesCheckAvailabilityCreateError
    >({
      path: `/api/customer/equipment-types/${id}/check-availability`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerEquipmentTypes
 * @name CustomerEquipmentTypesAvailableLocationsList
 * @summary Get locations where a specific equipment type has available stock.
Optionally filtered by date range and minimum quantity.
 * @request GET:/api/customer/equipment-types/{id}/available-locations
 * @secure
 */
  customerEquipmentTypesAvailableLocationsList = (
    { id, ...query }: CustomerEquipmentTypesAvailableLocationsListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerEquipmentTypesAvailableLocationsListData,
      CustomerEquipmentTypesAvailableLocationsListError
    >({
      path: `/api/customer/equipment-types/${id}/available-locations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerEquipmentTypes
   * @name CustomerEquipmentTypesFiltersList
   * @summary Returns available filter options (brands, age ranges, categories) for the equipment catalog.
   * @request GET:/api/customer/equipment-types/filters
   * @secure
   */
  customerEquipmentTypesFiltersList = (
    query: CustomerEquipmentTypesFiltersListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerEquipmentTypesFiltersListData, any>({
      path: `/api/customer/equipment-types/filters`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerEvents
 * @name CustomerEventsCreate
 * @summary Receive batched customer events from the website.
Public endpoint - no authentication required.
Rate limited to prevent abuse.
 * @request POST:/api/customer/events
 * @secure
 */
  customerEventsCreate = (
    data: CustomerEventsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerEventsCreateData, CustomerEventsCreateError>({
      path: `/api/customer/events`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerEvents
 * @name CustomerEventsBatchCreate
 * @summary Receive a batch of customer events from the frontend eventTracker.
This is the main endpoint used by the customer-facing website.
 * @request POST:/api/customer/events/batch
 * @secure
 */
  customerEventsBatchCreate = (
    data: CustomerEventsBatchCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerEventsBatchCreateData, CustomerEventsBatchCreateError>(
      {
        path: `/api/customer/events/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags CustomerEvents
   * @name CustomerEventsHealthList
   * @summary Health check endpoint for analytics service
   * @request GET:/api/customer/events/health
   * @secure
   */
  customerEventsHealthList = (params: RequestParams = {}) =>
    this.request<CustomerEventsHealthListData, any>({
      path: `/api/customer/events/health`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerFlights
   * @name CustomerFlightsArrivalsList
   * @summary Search cached airport arrivals by local arrival date and flight number, airline or origin.
   * @request GET:/api/customer/flights/arrivals
   * @secure
   */
  customerFlightsArrivalsList = (
    query: CustomerFlightsArrivalsListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerFlightsArrivalsListData, any>({
      path: `/api/customer/flights/arrivals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerFlights
   * @name CustomerFlightsDeparturesList
   * @summary Search cached airport departures by local departure date and flight number, airline or destination.
   * @request GET:/api/customer/flights/departures
   * @secure
   */
  customerFlightsDeparturesList = (
    query: CustomerFlightsDeparturesListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerFlightsDeparturesListData, any>({
      path: `/api/customer/flights/departures`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerLocations
   * @name CustomerLocationsList
   * @summary Get all customer-facing locations
   * @request GET:/api/customer/locations
   * @secure
   */
  customerLocationsList = (
    query: CustomerLocationsListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerLocationsListData, any>({
      path: `/api/customer/locations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerLocations
   * @name CustomerLocationsDetail
   * @summary Get a specific customer location by ID
   * @request GET:/api/customer/locations/{id}
   * @secure
   */
  customerLocationsDetail = (
    { id, ...query }: CustomerLocationsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerLocationsDetailData, CustomerLocationsDetailError>({
      path: `/api/customer/locations/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerLocations
   * @name CustomerLocationsBySlugDetail
   * @summary Get a specific customer location by URL slug
   * @request GET:/api/customer/locations/by-slug/{slug}
   * @secure
   */
  customerLocationsBySlugDetail = (
    { slug, ...query }: CustomerLocationsBySlugDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerLocationsBySlugDetailData,
      CustomerLocationsBySlugDetailError
    >({
      path: `/api/customer/locations/by-slug/${slug}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerLocations
   * @name CustomerLocationsFeaturedList
   * @summary Get featured locations for homepage display
   * @request GET:/api/customer/locations/featured
   * @secure
   */
  customerLocationsFeaturedList = (
    query: CustomerLocationsFeaturedListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerLocationsFeaturedListData, any>({
      path: `/api/customer/locations/featured`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerLocations
   * @name CustomerLocationsCurrencyDetail
   * @summary Get locations by supported currency
   * @request GET:/api/customer/locations/currency/{currency}
   * @secure
   */
  customerLocationsCurrencyDetail = (
    currency: string,
    params: RequestParams = {},
  ) =>
    this.request<CustomerLocationsCurrencyDetailData, any>({
      path: `/api/customer/locations/currency/${currency}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerLocations
   * @name CustomerLocationsDeliverySearchCreate
   * @summary Get locations that can deliver to a specific address
   * @request POST:/api/customer/locations/delivery-search
   * @secure
   */
  customerLocationsDeliverySearchCreate = (
    data: CustomerLocationsDeliverySearchCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerLocationsDeliverySearchCreateData,
      CustomerLocationsDeliverySearchCreateError
    >({
      path: `/api/customer/locations/delivery-search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerLocations
   * @name CustomerLocationsDeliveryQuoteCreate
   * @summary Get delivery quote for a specific location and address
   * @request POST:/api/customer/locations/{locationId}/delivery-quote
   * @secure
   */
  customerLocationsDeliveryQuoteCreate = (
    locationId: string,
    data: CustomerLocationsDeliveryQuoteCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerLocationsDeliveryQuoteCreateData,
      CustomerLocationsDeliveryQuoteCreateError
    >({
      path: `/api/customer/locations/${locationId}/delivery-quote`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerManagement
   * @name GetCustomers
   * @summary Get paginated list of customers with statistics
   * @request GET:/api/customers
   * @secure
   */
  getCustomers = (query: GetCustomersParams, params: RequestParams = {}) =>
    this.request<GetCustomersData, any>({
      path: `/api/customers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerManagement
   * @name GetCustomerDetail
   * @summary Get detailed customer information including addresses and recent reservations
   * @request GET:/api/customers/{id}
   * @secure
   */
  getCustomerDetail = (id: string, params: RequestParams = {}) =>
    this.request<GetCustomerDetailData, GetCustomerDetailError>({
      path: `/api/customers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerManagement
   * @name DeactivateCustomer
   * @summary Deactivate a customer account (prevents customer login)
   * @request PUT:/api/customers/{id}/deactivate
   * @secure
   */
  deactivateCustomer = (id: string, params: RequestParams = {}) =>
    this.request<DeactivateCustomerData, DeactivateCustomerError>({
      path: `/api/customers/${id}/deactivate`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerManagement
   * @name ActivateCustomer
   * @summary Reactivate a previously deactivated customer account
   * @request PUT:/api/customers/{id}/activate
   * @secure
   */
  activateCustomer = (id: string, params: RequestParams = {}) =>
    this.request<ActivateCustomerData, ActivateCustomerError>({
      path: `/api/customers/${id}/activate`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerManagement
 * @name MigrateCustomerRoles
 * @summary Migrate existing customers to have the Customer role assigned.
This is a one-time operation to fix customers created before role assignment was implemented.
Admin only.
 * @request POST:/api/customers/migrate-roles
 * @secure
 */
  migrateCustomerRoles = (params: RequestParams = {}) =>
    this.request<MigrateCustomerRolesData, void>({
      path: `/api/customers/migrate-roles`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerMonthlyRentals
   * @name CustomerMonthlyRentalsList
   * @request GET:/api/customer/monthly-rentals
   * @secure
   */
  customerMonthlyRentalsList = (params: RequestParams = {}) =>
    this.request<
      CustomerMonthlyRentalsListData,
      CustomerMonthlyRentalsListError
    >({
      path: `/api/customer/monthly-rentals`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerMonthlyRentals
   * @name CustomerMonthlyRentalsDetail
   * @request GET:/api/customer/monthly-rentals/{bookingId}
   * @secure
   */
  customerMonthlyRentalsDetail = (
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerMonthlyRentalsDetailData,
      CustomerMonthlyRentalsDetailError
    >({
      path: `/api/customer/monthly-rentals/${bookingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerMonthlyRentals
   * @name CustomerMonthlyRentalsPreviewCancellationList
   * @request GET:/api/customer/monthly-rentals/{bookingId}/preview-cancellation
   * @secure
   */
  customerMonthlyRentalsPreviewCancellationList = (
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerMonthlyRentalsPreviewCancellationListData,
      CustomerMonthlyRentalsPreviewCancellationListError
    >({
      path: `/api/customer/monthly-rentals/${bookingId}/preview-cancellation`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerMonthlyRentals
   * @name CustomerMonthlyRentalsCancelCreate
   * @request POST:/api/customer/monthly-rentals/{bookingId}/cancel
   * @secure
   */
  customerMonthlyRentalsCancelCreate = (
    bookingId: string,
    data: CustomerMonthlyRentalsCancelCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerMonthlyRentalsCancelCreateData,
      CustomerMonthlyRentalsCancelCreateError
    >({
      path: `/api/customer/monthly-rentals/${bookingId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerMonthlyRentals
   * @name CustomerMonthlyRentalsReconcilePenaltyCreate
   * @request POST:/api/customer/monthly-rentals/{bookingId}/reconcile-penalty
   * @secure
   */
  customerMonthlyRentalsReconcilePenaltyCreate = (
    bookingId: string,
    data: CustomerMonthlyRentalsReconcilePenaltyCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerMonthlyRentalsReconcilePenaltyCreateData,
      CustomerMonthlyRentalsReconcilePenaltyCreateError
    >({
      path: `/api/customer/monthly-rentals/${bookingId}/reconcile-penalty`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerMonthlyRentals
   * @name CustomerMonthlyRentalsUpdatePaymentMethodCreate
   * @request POST:/api/customer/monthly-rentals/{bookingId}/update-payment-method
   * @secure
   */
  customerMonthlyRentalsUpdatePaymentMethodCreate = (
    bookingId: string,
    data: CustomerMonthlyRentalsUpdatePaymentMethodCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerMonthlyRentalsUpdatePaymentMethodCreateData,
      CustomerMonthlyRentalsUpdatePaymentMethodCreateError
    >({
      path: `/api/customer/monthly-rentals/${bookingId}/update-payment-method`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerOrders
 * @name CustomerOrdersViewDetail
 * @summary Read-only order state for a guest's login-free order-view token.
200 with the order payload when the token is valid.
404 if the token is unknown. 410 if the link has expired.
 * @request GET:/api/customer/orders/view/{token}
 * @secure
 */
  customerOrdersViewDetail = (token: string, params: RequestParams = {}) =>
    this.request<CustomerOrdersViewDetailData, CustomerOrdersViewDetailError>({
      path: `/api/customer/orders/view/${token}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * @description Request format: ```json { "items": [ { "equipmentTypeId": "guid", "quantity": 1, "isSubscription": false, "startDate": "2025-01-15", "endDate": "2025-01-22" }, { "equipmentTypeId": "guid", "quantity": 1, "isSubscription": true, "startDate": "2025-01-15", "subscriptionMonths": 6 } ], "locationId": "optional-guid" } ``` Response includes: - Per-item pricing with tier breakdown - Subtotal (sum of line totals) - Total deposit (sum of item deposits) - Grand total (subtotal + delivery fee)
 *
 * @tags CustomerPricing
 * @name CustomerPricingCalculateCartCreate
 * @summary Calculate pricing for all items in a cart using tiered pricing.
The backend fetches all equipment type pricing from the database.
Supports both rental items (with date ranges) and subscription items (with pickup date).
 * @request POST:/api/customer/pricing/calculate-cart
 * @secure
 */
  customerPricingCalculateCartCreate = (
    data: CustomerPricingCalculateCartCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPricingCalculateCartCreateData,
      CustomerPricingCalculateCartCreateError
    >({
      path: `/api/customer/pricing/calculate-cart`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerPricing
 * @name CustomerPricingCalculateItemCreate
 * @summary Calculate pricing for a single equipment type rental.
Useful for product detail pages.
 * @request POST:/api/customer/pricing/calculate-item
 * @secure
 */
  customerPricingCalculateItemCreate = (
    data: CustomerPricingCalculateItemCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPricingCalculateItemCreateData,
      CustomerPricingCalculateItemCreateError
    >({
      path: `/api/customer/pricing/calculate-item`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * @description Request format: ```json { "items": [ { "equipmentTypeId": "guid", "quantity": 1, "isSubscription": false, "startDate": "2025-01-15", "endDate": "2025-01-22", "expectedLineTotal": 150.00, "expectedDeposit": 50.00 } ], "expectedSubtotal": 150.00, "expectedDeposit": 50.00 } ``` Response includes: - isValid: true if all prices match within tolerance (0.01) - Per-item comparison of old vs new prices - Total differences for user display
 *
 * @tags CustomerPricing
 * @name CustomerPricingValidateCartCreate
 * @summary Validate cart prices against current pricing before payment.
Used at checkout to detect stale pricing due to price changes
or time-sensitive calculations (e.g., rental days crossing midnight).
 * @request POST:/api/customer/pricing/validate-cart
 * @secure
 */
  customerPricingValidateCartCreate = (
    data: CustomerPricingValidateCartCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPricingValidateCartCreateData,
      CustomerPricingValidateCartCreateError
    >({
      path: `/api/customer/pricing/validate-cart`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerPromoCodes
   * @name CustomerPromoCodesValidateCreate
   * @request POST:/api/customer/promo-codes/validate
   * @secure
   */
  customerPromoCodesValidateCreate = (
    data: CustomerPromoCodesValidateCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerPromoCodesValidateCreateData, any>({
      path: `/api/customer/promo-codes/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReservations
   * @name CustomerReservationsList
   * @summary Get customer's reservations
   * @request GET:/api/customer/reservations
   * @secure
   */
  customerReservationsList = (
    query: CustomerReservationsListParams,
    params: RequestParams = {},
  ) =>
    this.request<CustomerReservationsListData, CustomerReservationsListError>({
      path: `/api/customer/reservations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReservations
   * @name CustomerReservationsDetail
   * @summary Get reservation details by ID
   * @request GET:/api/customer/reservations/{reservationId}
   * @secure
   */
  customerReservationsDetail = (
    reservationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsDetailData,
      CustomerReservationsDetailError
    >({
      path: `/api/customer/reservations/${reservationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReservations
   * @name CustomerReservationsCancelCreate
   * @summary Cancel reservation
   * @request POST:/api/customer/reservations/{reservationId}/cancel
   * @secure
   */
  customerReservationsCancelCreate = (
    reservationId: string,
    data: CustomerReservationsCancelCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsCancelCreateData,
      CustomerReservationsCancelCreateError
    >({
      path: `/api/customer/reservations/${reservationId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReservations
   * @name CustomerReservationsExtendCreate
   * @summary Request extension for a reservation
   * @request POST:/api/customer/reservations/{reservationId}/extend
   * @secure
   */
  customerReservationsExtendCreate = (
    reservationId: string,
    data: CustomerReservationsExtendCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsExtendCreateData,
      CustomerReservationsExtendCreateError
    >({
      path: `/api/customer/reservations/${reservationId}/extend`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReservations
   * @name CustomerReservationsInvoiceList
   * @summary Get reservation invoice metadata
   * @request GET:/api/customer/reservations/{reservationId}/invoice
   * @secure
   */
  customerReservationsInvoiceList = (
    reservationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsInvoiceListData,
      CustomerReservationsInvoiceListError
    >({
      path: `/api/customer/reservations/${reservationId}/invoice`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReservations
   * @name CustomerReservationsInvoicePdfList
   * @summary Get reservation invoice/receipt PDF
   * @request GET:/api/customer/reservations/{reservationId}/invoice/pdf
   * @secure
   */
  customerReservationsInvoicePdfList = (
    reservationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsInvoicePdfListData,
      CustomerReservationsInvoicePdfListError
    >({
      path: `/api/customer/reservations/${reservationId}/invoice/pdf`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReservations
   * @name CustomerReservationsAgreementList
   * @summary Get reservation rental agreement PDF
   * @request GET:/api/customer/reservations/{reservationId}/agreement
   * @secure
   */
  customerReservationsAgreementList = (
    reservationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsAgreementListData,
      CustomerReservationsAgreementListError
    >({
      path: `/api/customer/reservations/${reservationId}/agreement`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerReservations
 * @name CustomerReservationsSchedulePartialUpdate
 * @summary Update the pickup time and/or return datetime for a reservation.
Only allowed for reservations that have not yet started (Pending/Confirmed).
 * @request PATCH:/api/customer/reservations/{reservationId}/schedule
 * @secure
 */
  customerReservationsSchedulePartialUpdate = (
    reservationId: string,
    data: CustomerReservationsSchedulePartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsSchedulePartialUpdateData,
      CustomerReservationsSchedulePartialUpdateError
    >({
      path: `/api/customer/reservations/${reservationId}/schedule`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerReservationsResume
 * @name CustomerReservationsResumeDetail
 * @summary Hydrates a customer-facing cart from an admin-initiated reservation.
Returns 200 with the full cart payload when the token is valid.
Returns 404 if the token is unknown.
Returns 410 if the reservation is expired, cancelled, or already paid.
 * @request GET:/api/customer/reservations/resume/{token}
 * @secure
 */
  customerReservationsResumeDetail = (
    token: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReservationsResumeDetailData,
      CustomerReservationsResumeDetailError
    >({
      path: `/api/customer/reservations/resume/${token}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReviews
   * @name CustomerReviewsCreate
   * @request POST:/api/customer/reviews
   * @secure
   */
  customerReviewsCreate = (
    data: CustomerReviewsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerReviewsCreateData, CustomerReviewsCreateError>({
      path: `/api/customer/reviews`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReviews
   * @name CustomerReviewsUpdate
   * @request PUT:/api/customer/reviews/{reservationId}
   * @secure
   */
  customerReviewsUpdate = (
    reservationId: string,
    data: CustomerReviewsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerReviewsUpdateData, CustomerReviewsUpdateError>({
      path: `/api/customer/reviews/${reservationId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerReviews
   * @name CustomerReviewsReservationDetail
   * @request GET:/api/customer/reviews/reservation/{reservationId}
   * @secure
   */
  customerReviewsReservationDetail = (
    reservationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerReviewsReservationDetailData,
      CustomerReviewsReservationDetailError
    >({
      path: `/api/customer/reviews/reservation/${reservationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags CustomerSession
 * @name CustomerSessionInitCreate
 * @summary Initialises a server-minted guest session cookie (stork_sid).
            
HARD-011: Session ID is now generated server-side and delivered via an
HttpOnly, SameSite=Lax cookie so it cannot be read or spoofed by
JavaScript running in the page. The Secure flag tracks the request scheme
(Request.IsHttps) so the cookie is Secure on HTTPS (staging/prod) but is
still stored over plain-HTTP localhost in dev — Firefox drops Secure
cookies set over http, which previously broke guest checkout locally.
            
If the cookie is already present, the endpoint is a no-op (204) so it is
safe to call on every page load without re-minting a session.
 * @request POST:/api/customer/session/init
 * @secure
 */
  customerSessionInitCreate = (params: RequestParams = {}) =>
    this.request<CustomerSessionInitCreateData, any>({
      path: `/api/customer/session/init`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerTickets
   * @name CustomerTicketsCreate
   * @request POST:/api/customer/tickets
   * @secure
   */
  customerTicketsCreate = (
    data: CustomerTicketsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<CustomerTicketsCreateData, CustomerTicketsCreateError>({
      path: `/api/customer/tickets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerTickets
   * @name CustomerTicketsReservationDetail
   * @request GET:/api/customer/tickets/reservation/{reservationId}
   * @secure
   */
  customerTicketsReservationDetail = (
    reservationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerTicketsReservationDetailData,
      CustomerTicketsReservationDetailError
    >({
      path: `/api/customer/tickets/reservation/${reservationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerTickets
   * @name CustomerTicketsDetail
   * @request GET:/api/customer/tickets/{ticketId}
   * @secure
   */
  customerTicketsDetail = (ticketId: string, params: RequestParams = {}) =>
    this.request<CustomerTicketsDetailData, CustomerTicketsDetailError>({
      path: `/api/customer/tickets/${ticketId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomerTickets
   * @name CustomerTicketsMessagesCreate
   * @request POST:/api/customer/tickets/{ticketId}/messages
   * @secure
   */
  customerTicketsMessagesCreate = (
    ticketId: string,
    data: CustomerTicketsMessagesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerTicketsMessagesCreateData,
      CustomerTicketsMessagesCreateError
    >({
      path: `/api/customer/tickets/${ticketId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DamageReports
   * @name DamageReportsActiveList
   * @summary Returns active damage reports (reports with at least one unresolved damaged item) for the current user's accessible locations, paginated newest-first with optional location/area/equipment-type/source/search filters.
   * @request GET:/api/damage-reports/active
   * @secure
   */
  damageReportsActiveList = (
    query: DamageReportsActiveListParams,
    params: RequestParams = {},
  ) =>
    this.request<DamageReportsActiveListData, any>({
      path: `/api/damage-reports/active`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DamageReports
   * @name DamageReportsResolveCreate
   * @summary Resolves a damaged item as Repaired (back to Available + needs cleaning, optionally moved to a warehouse) or WrittenOff (stays Damaged).
   * @request POST:/api/damage-reports/resolve/{damageReportItemId}
   * @secure
   */
  damageReportsResolveCreate = (
    damageReportItemId: string,
    data: DamageReportsResolveCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<DamageReportsResolveCreateData, any>({
      path: `/api/damage-reports/resolve/${damageReportItemId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DamageReports
   * @name DamageReportsEquipmentCreate
   * @summary Standalone damage capture for a unit with no open booking or rental: sets the unit Damaged, pulls it from the cleaning queue, and opens a Manual-source damage report with an optional booking OR rental link (investigation reference only).
   * @request POST:/api/damage-reports/equipment/{equipmentId}
   * @secure
   */
  damageReportsEquipmentCreate = (
    equipmentId: string,
    data: DamageReportsEquipmentCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<DamageReportsEquipmentCreateData, any>({
      path: `/api/damage-reports/equipment/${equipmentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetRentedEquipment
   * @summary Returns currently rented equipment with customer name, serial number, pickup date, expected return date, and overdue status for the dashboard tracking view.
   * @request GET:/api/dashboard/equipment/rented
   * @secure
   */
  getRentedEquipment = (
    query: GetRentedEquipmentParams,
    params: RequestParams = {},
  ) =>
    this.request<GetRentedEquipmentData, any>({
      path: `/api/dashboard/equipment/rented`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetLoanedEquipment
   * @summary Returns equipment currently on inter-location loan, showing source and destination rental locations for inventory tracking.
   * @request GET:/api/dashboard/equipment/loaned
   * @secure
   */
  getLoanedEquipment = (
    query: GetLoanedEquipmentParams,
    params: RequestParams = {},
  ) =>
    this.request<GetLoanedEquipmentData, any>({
      path: `/api/dashboard/equipment/loaned`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetRentalEquipmentStats
   * @summary Returns equipment count breakdown by status (Available, Rented, Damaged, InRepair, Missing, WaitingForParts, Cleaning) and by equipment type for the dashboard overview.
   * @request GET:/api/dashboard/equipment/stats
   * @secure
   */
  getRentalEquipmentStats = (
    query: GetRentalEquipmentStatsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetRentalEquipmentStatsData, any>({
      path: `/api/dashboard/equipment/stats`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetNextEquipmentReturns
   * @summary Returns upcoming equipment returns within a configurable day range (default 7), sorted by return date, including overdue flag for proactive follow-up. Excludes returns older than OverdueDaysCutoff (default 7) — those surface in the Potentially Missing Returns endpoint.
   * @request GET:/api/dashboard/equipment/returns
   * @secure
   */
  getNextEquipmentReturns = (
    query: GetNextEquipmentReturnsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetNextEquipmentReturnsData, any>({
      path: `/api/dashboard/equipment/returns`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetPotentiallyMissingReturns
   * @summary Returns bookings whose expected return is older than OverdueDaysCutoff (default 7) and still not closed, sorted most-recent-first. Complement of the Next Returns list — these are candidates for being marked missing.
   * @request GET:/api/dashboard/equipment/missing-returns
   * @secure
   */
  getPotentiallyMissingReturns = (
    query: GetPotentiallyMissingReturnsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetPotentiallyMissingReturnsData, any>({
      path: `/api/dashboard/equipment/missing-returns`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetReturnsToDiffRental
   * @summary Returns equipment returned to a different location than where it was picked up, enabling admins to identify and resolve cross-location inventory movements (Admin only).
   * @request GET:/api/dashboard/equipment/returnsToDiffRental
   * @secure
   */
  getReturnsToDiffRental = (
    query: GetReturnsToDiffRentalParams,
    params: RequestParams = {},
  ) =>
    this.request<GetReturnsToDiffRentalData, any>({
      path: `/api/dashboard/equipment/returnsToDiffRental`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetBookingsStatistics
   * @summary Returns booking statistics for today, last 7 days, and last 30 days including pickup counts (morning/afternoon split) and return counts (completed, expected, overdue).
   * @request GET:/api/dashboard/bookings/stats
   * @secure
   */
  getBookingsStatistics = (
    query: GetBookingsStatisticsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetBookingsStatisticsData, any>({
      path: `/api/dashboard/bookings/stats`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name GetRentalStockStats
   * @summary Returns a day-by-day stock availability forecast by equipment type over a configurable period (default 7 days), showing scheduled pickups, returns, and projected availability to identify shortages in advance.
   * @request GET:/api/dashboard/bookings/stock/stats
   * @secure
   */
  getRentalStockStats = (
    query: GetRentalStockStatsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetRentalStockStatsData, any>({
      path: `/api/dashboard/bookings/stock/stats`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DayOffs
   * @name DayOffsCreate
   * @summary Create a day off entry for a team member. Requires manager permissions.
   * @request POST:/api/day-offs
   * @secure
   */
  dayOffsCreate = (data: DayOffsCreatePayload, params: RequestParams = {}) =>
    this.request<DayOffsCreateData, DayOffsCreateError>({
      path: `/api/day-offs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DayOffs
   * @name DayOffsBulkCreate
   * @summary Bulk create multiple day offs. Validates each row individually and returns per-row results.
   * @request POST:/api/day-offs/bulk
   * @secure
   */
  dayOffsBulkCreate = (
    data: DayOffsBulkCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<DayOffsBulkCreateData, DayOffsBulkCreateError>({
      path: `/api/day-offs/bulk`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DayOffs
   * @name DayOffsTeamDetail
   * @summary Get day-offs for a specific team. Requires manager permissions.
   * @request GET:/api/day-offs/team/{teamId}
   * @secure
   */
  dayOffsTeamDetail = (
    { teamId, ...query }: DayOffsTeamDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<DayOffsTeamDetailData, any>({
      path: `/api/day-offs/team/${teamId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DayOffs
   * @name DayOffsMyList
   * @summary Get day-offs for the current user.
   * @request GET:/api/day-offs/my
   * @secure
   */
  dayOffsMyList = (query: DayOffsMyListParams, params: RequestParams = {}) =>
    this.request<DayOffsMyListData, any>({
      path: `/api/day-offs/my`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DayOffs
   * @name DayOffsDelete
   * @summary Delete a day off entry. Requires manager permissions.
   * @request DELETE:/api/day-offs/{id}
   * @secure
   */
  dayOffsDelete = (id: string, params: RequestParams = {}) =>
    this.request<DayOffsDeleteData, DayOffsDeleteError>({
      path: `/api/day-offs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documentation
   * @name GetDocumentationIndex
   * @summary Index of guides (all staff) + spec modules (Admin only).
   * @request GET:/api/documentation/index
   * @secure
   */
  getDocumentationIndex = (params: RequestParams = {}) =>
    this.request<GetDocumentationIndexData, any>({
      path: `/api/documentation/index`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documentation
   * @name GetDocumentationGuide
   * @summary Full guide markdown + presigned screenshot URLs.
   * @request GET:/api/documentation/guides/{id}
   * @secure
   */
  getDocumentationGuide = (id: string, params: RequestParams = {}) =>
    this.request<GetDocumentationGuideData, GetDocumentationGuideError>({
      path: `/api/documentation/guides/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Documentation
   * @name GetDocumentationSpec
   * @summary Full spec-module markdown layers + presigned screenshot URLs. Admin only.
   * @request GET:/api/documentation/specs/{module}
   * @secure
   */
  getDocumentationSpec = (module: string, params: RequestParams = {}) =>
    this.request<GetDocumentationSpecData, GetDocumentationSpecError>({
      path: `/api/documentation/specs/${module}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesList
   * @summary Lists all templates, optionally filtered by notification flow.
   * @request GET:/api/email-templates
   * @secure
   */
  emailTemplatesList = (
    query: EmailTemplatesListParams,
    params: RequestParams = {},
  ) =>
    this.request<EmailTemplatesListData, any>({
      path: `/api/email-templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesCreate
   * @summary Creates a new email template.
   * @request POST:/api/email-templates
   * @secure
   */
  emailTemplatesCreate = (
    data: EmailTemplatesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<EmailTemplatesCreateData, EmailTemplatesCreateError>({
      path: `/api/email-templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesDetail
   * @summary Gets a template by ID.
   * @request GET:/api/email-templates/{id}
   * @secure
   */
  emailTemplatesDetail = (id: string, params: RequestParams = {}) =>
    this.request<EmailTemplatesDetailData, EmailTemplatesDetailError>({
      path: `/api/email-templates/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesUpdate
   * @summary Updates a template's name, subject, and HTML body.
   * @request PUT:/api/email-templates/{id}
   * @secure
   */
  emailTemplatesUpdate = (
    id: string,
    data: EmailTemplatesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<EmailTemplatesUpdateData, EmailTemplatesUpdateError>({
      path: `/api/email-templates/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags EmailTemplates
 * @name EmailTemplatesDelete
 * @summary Deletes a template. If the template was active, the previous version for that flow
is automatically re-activated.
 * @request DELETE:/api/email-templates/{id}
 * @secure
 */
  emailTemplatesDelete = (id: string, params: RequestParams = {}) =>
    this.request<EmailTemplatesDeleteData, EmailTemplatesDeleteError>({
      path: `/api/email-templates/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesActivateCreate
   * @summary Activates a template for its notification flow, deactivating any other active template for that flow.
   * @request POST:/api/email-templates/{id}/activate
   * @secure
   */
  emailTemplatesActivateCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      EmailTemplatesActivateCreateData,
      EmailTemplatesActivateCreateError
    >({
      path: `/api/email-templates/${id}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesDeactivateCreate
   * @summary Deactivates a template (no active template remains for its flow).
   * @request POST:/api/email-templates/{id}/deactivate
   * @secure
   */
  emailTemplatesDeactivateCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      EmailTemplatesDeactivateCreateData,
      EmailTemplatesDeactivateCreateError
    >({
      path: `/api/email-templates/${id}/deactivate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesFlowsList
   * @summary Lists all available notification flows with their placeholder definitions.
   * @request GET:/api/email-templates/flows
   * @secure
   */
  emailTemplatesFlowsList = (params: RequestParams = {}) =>
    this.request<EmailTemplatesFlowsListData, any>({
      path: `/api/email-templates/flows`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesRenderPreviewCreate
   * @summary Renders HTML preview directly from builder payload using sample placeholders for the selected flow.
   * @request POST:/api/email-templates/render-preview
   * @secure
   */
  emailTemplatesRenderPreviewCreate = (
    data: EmailTemplatesRenderPreviewCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      EmailTemplatesRenderPreviewCreateData,
      EmailTemplatesRenderPreviewCreateError
    >({
      path: `/api/email-templates/render-preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesStarterTemplatesList
   * @summary Returns starter builder templates for each notification flow.
   * @request GET:/api/email-templates/starter-templates
   * @secure
   */
  emailTemplatesStarterTemplatesList = (params: RequestParams = {}) =>
    this.request<EmailTemplatesStarterTemplatesListData, any>({
      path: `/api/email-templates/starter-templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesPreviewList
   * @summary Returns the rendered HTML preview of a template using sample placeholder data.
   * @request GET:/api/email-templates/{id}/preview
   * @secure
   */
  emailTemplatesPreviewList = (id: string, params: RequestParams = {}) =>
    this.request<EmailTemplatesPreviewListData, EmailTemplatesPreviewListError>(
      {
        path: `/api/email-templates/${id}/preview`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesTestSendCreate
   * @summary Sends a test email for the given template to the specified address using sample placeholder data.
   * @request POST:/api/email-templates/{id}/test-send
   * @secure
   */
  emailTemplatesTestSendCreate = (
    id: string,
    data: EmailTemplatesTestSendCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      EmailTemplatesTestSendCreateData,
      EmailTemplatesTestSendCreateError
    >({
      path: `/api/email-templates/${id}/test-send`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesHistoryDetail
   * @summary Gets the version history for a notification flow (all templates, ordered by version descending).
   * @request GET:/api/email-templates/history/{flow}
   * @secure
   */
  emailTemplatesHistoryDetail = (flow: number, params: RequestParams = {}) =>
    this.request<EmailTemplatesHistoryDetailData, any>({
      path: `/api/email-templates/history/${flow}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplates
   * @name EmailTemplatesDuplicateCreate
   * @summary Duplicates a template as a new draft version for the same flow.
   * @request POST:/api/email-templates/{id}/duplicate
   * @secure
   */
  emailTemplatesDuplicateCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      EmailTemplatesDuplicateCreateData,
      EmailTemplatesDuplicateCreateError
    >({
      path: `/api/email-templates/${id}/duplicate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmployeeContracts
   * @name EmployeeContractsDetail
   * @request GET:/api/employee-contracts/{userId}
   * @secure
   */
  employeeContractsDetail = (userId: string, params: RequestParams = {}) =>
    this.request<EmployeeContractsDetailData, any>({
      path: `/api/employee-contracts/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmployeeContracts
   * @name EmployeeContractsUpdate
   * @request PUT:/api/employee-contracts/{userId}
   * @secure
   */
  employeeContractsUpdate = (
    userId: string,
    data: EmployeeContractsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<EmployeeContractsUpdateData, any>({
      path: `/api/employee-contracts/${userId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmployeeTeams
   * @name EmployeeTeamsList
   * @summary Returns all teams the current employee is a member of.
   * @request GET:/api/employee/teams
   * @secure
   */
  employeeTeamsList = (params: RequestParams = {}) =>
    this.request<EmployeeTeamsListData, any>({
      path: `/api/employee/teams`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmployeeTeams
   * @name EmployeeTeamsDetail
   * @summary Returns details of a team the current employee is a member of.
   * @request GET:/api/employee/teams/{id}
   * @secure
   */
  employeeTeamsDetail = (id: string, params: RequestParams = {}) =>
    this.request<EmployeeTeamsDetailData, EmployeeTeamsDetailError>({
      path: `/api/employee/teams/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name CreateEquipment
   * @summary Creates a new physical equipment item with serial number, type, and location assignment (Admin, Manager only).
   * @request POST:/api/equipment
   * @secure
   */
  createEquipment = (
    data: CreateEquipmentPayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateEquipmentData, CreateEquipmentError>({
      path: `/api/equipment`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipment
   * @summary Returns a paginated list of equipment items filterable by rental location, status, equipment type, area, and serial number criteria.
   * @request GET:/api/equipment
   * @secure
   */
  getEquipment = (query: GetEquipmentParams, params: RequestParams = {}) =>
    this.request<GetEquipmentData, any>({
      path: `/api/equipment`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetItemsWithWrongLocationOrStatus
   * @summary Returns equipment items whose status or physical location does not match their expected state, grouped as available-with-active-rentals or rented-without-active-rentals.
   * @request GET:/api/equipment/wrongLocationOrStatus
   * @secure
   */
  getItemsWithWrongLocationOrStatus = (
    query: GetItemsWithWrongLocationOrStatusParams,
    params: RequestParams = {},
  ) =>
    this.request<GetItemsWithWrongLocationOrStatusData, any>({
      path: `/api/equipment/wrongLocationOrStatus`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name ExportEquipments
   * @summary Exports equipment items matching the given filters to an Excel (.xlsx) file with all inventory fields.
   * @request GET:/api/equipment/export
   * @secure
   */
  exportEquipments = (
    query: ExportEquipmentsParams,
    params: RequestParams = {},
  ) =>
    this.request<ExportEquipmentsData, ExportEquipmentsError>({
      path: `/api/equipment/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentById
   * @summary Returns the full details of a single equipment item by its ID, including current status, location, and rental history summary.
   * @request GET:/api/equipment/{Id}
   * @secure
   */
  getEquipmentById = (id: string, params: RequestParams = {}) =>
    this.request<GetEquipmentByIdData, GetEquipmentByIdError>({
      path: `/api/equipment/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name UpdateEquipment
   * @summary Updates an equipment item's serial number, type, status, or location assignment; returns the updated item.
   * @request PUT:/api/equipment/{Id}
   * @secure
   */
  updateEquipment = (
    id: string,
    data: UpdateEquipmentPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateEquipmentData, UpdateEquipmentError>({
      path: `/api/equipment/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name DeleteEquipment
   * @summary Soft-deletes an equipment item from the inventory (Admin, Manager only); the item is no longer returned in standard queries.
   * @request DELETE:/api/equipment/{Id}
   * @secure
   */
  deleteEquipment = (id: string, params: RequestParams = {}) =>
    this.request<DeleteEquipmentData, any>({
      path: `/api/equipment/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentGraveyard
   * @summary Returns the equipment graveyard: soft-deleted items (with who deleted them and when) plus items currently marked Missing.
   * @request GET:/api/equipment/graveyard
   * @secure
   */
  getEquipmentGraveyard = (
    query: GetEquipmentGraveyardParams,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentGraveyardData, any>({
      path: `/api/equipment/graveyard`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name RestoreEquipment
   * @summary Restores a soft-deleted equipment item back into active stock (Admin, Manager only); fails when another active item holds the same serial number.
   * @request POST:/api/equipment/{Id}/restore
   * @secure
   */
  restoreEquipment = (id: string, params: RequestParams = {}) =>
    this.request<RestoreEquipmentData, RestoreEquipmentError>({
      path: `/api/equipment/${id}/restore`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name ConsolidateEquipmentSerial
   * @summary Transfers ALL records from every deleted twin of the serial to the active item and marks the twins consolidated (Admin, Manager only). 400 with key "openRecords" when a twin has open records and closeOpenRecords is false.
   * @request POST:/api/equipment/consolidate-serial
   * @secure
   */
  consolidateEquipmentSerial = (
    data: ConsolidateEquipmentSerialPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      ConsolidateEquipmentSerialData,
      ConsolidateEquipmentSerialError
    >({
      path: `/api/equipment/consolidate-serial`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentBookings
   * @summary Returns all bookings (active and historical) associated with a specific equipment item, showing its full rental history.
   * @request GET:/api/equipment/{Id}/bookings
   * @secure
   */
  getEquipmentBookings = (id: string, params: RequestParams = {}) =>
    this.request<GetEquipmentBookingsData, any>({
      path: `/api/equipment/${id}/bookings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentRentalMovements
   * @summary Returns all inter-location movement records for an equipment item, showing which locations it has been transferred between over time.
   * @request GET:/api/equipment/{Id}/movements
   * @secure
   */
  getEquipmentRentalMovements = (id: string, params: RequestParams = {}) =>
    this.request<GetEquipmentRentalMovementsData, any>({
      path: `/api/equipment/${id}/movements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentStatuses
   * @summary Returns the list of all possible equipment statuses (Available, Rented, Damaged, InRepair, Missing, etc.) for use in dropdowns and filters.
   * @request GET:/api/equipment/statuses
   * @secure
   */
  getEquipmentStatuses = (params: RequestParams = {}) =>
    this.request<GetEquipmentStatusesData, any>({
      path: `/api/equipment/statuses`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentByCode
   * @summary Returns an equipment item by its unique code (e.g., QR code value or barcode), used for scanner-based equipment lookup workflows.
   * @request GET:/api/equipment/code/{code}
   * @secure
   */
  getEquipmentByCode = (code: string, params: RequestParams = {}) =>
    this.request<GetEquipmentByCodeData, GetEquipmentByCodeError>({
      path: `/api/equipment/code/${code}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name MarkEquipmentAsCleaned
   * @summary Marks an equipment item as cleaned, records the cleaning result and notes, and places it at the specified rental location as Available.
   * @request PUT:/api/equipment/{Id}/clean
   * @secure
   */
  markEquipmentAsCleaned = (
    id: string,
    data: MarkEquipmentAsCleanedPayload,
    params: RequestParams = {},
  ) =>
    this.request<MarkEquipmentAsCleanedData, MarkEquipmentAsCleanedError>({
      path: `/api/equipment/${id}/clean`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentNeedingCleaning
   * @summary Returns a paginated list of equipment items currently in Cleaning status that are accessible to the current user's locations.
   * @request GET:/api/equipment/needs-cleaning
   * @secure
   */
  getEquipmentNeedingCleaning = (
    query: GetEquipmentNeedingCleaningParams,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentNeedingCleaningData, any>({
      path: `/api/equipment/needs-cleaning`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentCleaningLogs
   * @summary Returns a paginated cleaning history for a specific equipment item, showing who cleaned it, when, and the recorded result.
   * @request GET:/api/equipment/{Id}/cleaning-logs
   * @secure
   */
  getEquipmentCleaningLogs = (
    { id, ...query }: GetEquipmentCleaningLogsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentCleaningLogsData, any>({
      path: `/api/equipment/${id}/cleaning-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentScanEvents
   * @summary Returns the paginated scan/handling history for a specific equipment item — one row per scan event (staff scanner, partner app, and every handling stamp). TotalRecords is the item's lifetime scan count.
   * @request GET:/api/equipment/{Id}/scan-events
   * @secure
   */
  getEquipmentScanEvents = (
    { id, ...query }: GetEquipmentScanEventsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentScanEventsData, any>({
      path: `/api/equipment/${id}/scan-events`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetCleaningLogs
   * @summary Returns a paginated list of cleaning logs across all accessible locations, supporting date and location filters.
   * @request GET:/api/equipment/cleaning-logs
   * @secure
   */
  getCleaningLogs = (
    query: GetCleaningLogsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetCleaningLogsData, any>({
      path: `/api/equipment/cleaning-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name FixEquipmentWrongStatus
   * @summary Fixes an equipment item's status: sets to Available when no active rental exists, or sets to Rented when an active rental does exist.
   * @request PUT:/api/equipment/{Id}/fix/wrong-status
   * @secure
   */
  fixEquipmentWrongStatus = (id: string, params: RequestParams = {}) =>
    this.request<FixEquipmentWrongStatusData, FixEquipmentWrongStatusError>({
      path: `/api/equipment/${id}/fix/wrong-status`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name FixEquipmentWrongLocation
   * @summary Fixes an equipment item's location: when idle and not at a warehouse, moves it to its expected parent warehouse with movement log.
   * @request PUT:/api/equipment/{Id}/fix/wrong-location
   * @secure
   */
  fixEquipmentWrongLocation = (id: string, params: RequestParams = {}) =>
    this.request<FixEquipmentWrongLocationData, FixEquipmentWrongLocationError>(
      {
        path: `/api/equipment/${id}/fix/wrong-location`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Equipment
   * @name CloseEquipmentOpenRecords
   * @summary Closes all open booking and rental records for an equipment item without changing its status or location, resolving stuck data states.
   * @request PUT:/api/equipment/{Id}/fix/close-open-records
   * @secure
   */
  closeEquipmentOpenRecords = (id: string, params: RequestParams = {}) =>
    this.request<CloseEquipmentOpenRecordsData, CloseEquipmentOpenRecordsError>(
      {
        path: `/api/equipment/${id}/fix/close-open-records`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Equipment
   * @name ResetEquipmentToWarehouse
   * @summary Transactionally moves an equipment item to a target warehouse, closes open records, and marks it Available in a single operation.
   * @request POST:/api/equipment/{Id}/reset-to-warehouse
   * @secure
   */
  resetEquipmentToWarehouse = (
    id: string,
    data: ResetEquipmentToWarehousePayload,
    params: RequestParams = {},
  ) =>
    this.request<ResetEquipmentToWarehouseData, ResetEquipmentToWarehouseError>(
      {
        path: `/api/equipment/${id}/reset-to-warehouse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Equipment
   * @name SearchEquipmentItems
   * @summary Searches equipment items by partial serial number with optional location scope, for autocomplete and barcode lookup across accessible locations.
   * @request GET:/api/equipment/searchEquipment
   * @secure
   */
  searchEquipmentItems = (
    query: SearchEquipmentItemsParams,
    params: RequestParams = {},
  ) =>
    this.request<SearchEquipmentItemsData, any>({
      path: `/api/equipment/searchEquipment`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name MoveEquipment
   * @summary Moves one or more equipment items to a target location, recording the movement in the location log with an audit trail of who moved them.
   * @request POST:/api/equipment/moveEquipment
   * @secure
   */
  moveEquipment = (data: MoveEquipmentPayload, params: RequestParams = {}) =>
    this.request<MoveEquipmentData, any>({
      path: `/api/equipment/moveEquipment`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name GetEquipmentLocationLogs
   * @summary Returns a paginated and filterable audit log of all physical equipment location movements, showing from/to locations, moved-by user, and timestamps.
   * @request GET:/api/equipment/location-logs
   * @secure
   */
  getEquipmentLocationLogs = (
    query: GetEquipmentLocationLogsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentLocationLogsData, any>({
      path: `/api/equipment/location-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Equipment
   * @name UndoEquipmentMovement
   * @summary Reverses the last movement recorded in a location log entry, restoring the equipment to its previous location and creating a compensating log entry.
   * @request POST:/api/equipment/location-logs/{logId}/undo
   * @secure
   */
  undoEquipmentMovement = (logId: string, params: RequestParams = {}) =>
    this.request<UndoEquipmentMovementData, UndoEquipmentMovementError>({
      path: `/api/equipment/location-logs/${logId}/undo`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentCatalogueOrder
   * @name GetLocationCatalogueOrder
   * @request GET:/api/equipmentTypes/catalogue/locations/{locationId}
   * @secure
   */
  getLocationCatalogueOrder = (
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<GetLocationCatalogueOrderData, GetLocationCatalogueOrderError>(
      {
        path: `/api/equipmentTypes/catalogue/locations/${locationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags EquipmentCatalogueOrder
   * @name SaveLocationCatalogueOrder
   * @request PUT:/api/equipmentTypes/catalogue/locations/{locationId}
   * @secure
   */
  saveLocationCatalogueOrder = (
    locationId: string,
    data: SaveLocationCatalogueOrderPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      SaveLocationCatalogueOrderData,
      SaveLocationCatalogueOrderError
    >({
      path: `/api/equipmentTypes/catalogue/locations/${locationId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentCatalogueOrder
   * @name ResetLocationCatalogueOrder
   * @request DELETE:/api/equipmentTypes/catalogue/locations/{locationId}
   * @secure
   */
  resetLocationCatalogueOrder = (
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      ResetLocationCatalogueOrderData,
      ResetLocationCatalogueOrderError
    >({
      path: `/api/equipmentTypes/catalogue/locations/${locationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentCompensations
   * @name UpdateEquipmentCompensation
   * @summary Updates a compensation's amount and note (Admin, Manager only). Values replace the stored ones verbatim — null clears.
   * @request PUT:/api/equipment-compensations/{Id}
   * @secure
   */
  updateEquipmentCompensation = (
    id: string,
    data: UpdateEquipmentCompensationPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      UpdateEquipmentCompensationData,
      UpdateEquipmentCompensationError
    >({
      path: `/api/equipment-compensations/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentForecast
   * @name GetEquipmentForecastDemand
   * @summary Returns per-item-type demand forecast buckets across the requested window, with prior-year comparison series. Equipment demand includes partner consignment rentals (drop-off → return) alongside bookings.
   * @request GET:/api/equipment-forecast/demand
   * @secure
   */
  getEquipmentForecastDemand = (
    query: GetEquipmentForecastDemandParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetEquipmentForecastDemandData,
      GetEquipmentForecastDemandError
    >({
      path: `/api/equipment-forecast/demand`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentForecast
   * @name GetEquipmentForecastPartnerRentals
   * @summary Returns partner consignment-ledger rental buckets (dropped/returned/still-out/open-balance) across the window, with prior-year comparison windows.
   * @request GET:/api/equipment-forecast/partner-rentals
   * @secure
   */
  getEquipmentForecastPartnerRentals = (
    query: GetEquipmentForecastPartnerRentalsParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetEquipmentForecastPartnerRentalsData,
      GetEquipmentForecastPartnerRentalsError
    >({
      path: `/api/equipment-forecast/partner-rentals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentForecast
   * @name GetPartnerRentalCompanyBreakdown
   * @summary Returns the partner consignment-ledger breakdown per company for the window (drop/return/still-out/open-balance + a −1y drop comparison). Company-less desks group under "Stork".
   * @request GET:/api/equipment-forecast/partner-rentals/companies
   * @secure
   */
  getPartnerRentalCompanyBreakdown = (
    query: GetPartnerRentalCompanyBreakdownParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetPartnerRentalCompanyBreakdownData,
      GetPartnerRentalCompanyBreakdownError
    >({
      path: `/api/equipment-forecast/partner-rentals/companies`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentForecast
   * @name GetUnaccountedRentedItems
   * @summary Returns rented items that have no open booking or partner-rental record accounting for them (Admin only).
   * @request GET:/api/equipment-forecast/unaccounted-rented
   * @secure
   */
  getUnaccountedRentedItems = (
    query: GetUnaccountedRentedItemsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetUnaccountedRentedItemsData, any>({
      path: `/api/equipment-forecast/unaccounted-rented`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentForecast
   * @name GetOverdueReturns
   * @summary Returns equipment items past their expected return date, still out on an open booking (all page roles).
   * @request GET:/api/equipment-forecast/overdue-returns
   * @secure
   */
  getOverdueReturns = (
    query: GetOverdueReturnsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetOverdueReturnsData, any>({
      path: `/api/equipment-forecast/overdue-returns`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentForecast
   * @name GetEquipmentForecastSummary
   * @summary Returns current fleet-vs-demand summary rows per item type for the requested window. Equipment demand peaks include partner consignment rentals alongside bookings.
   * @request GET:/api/equipment-forecast/summary
   * @secure
   */
  getEquipmentForecastSummary = (
    query: GetEquipmentForecastSummaryParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetEquipmentForecastSummaryData,
      GetEquipmentForecastSummaryError
    >({
      path: `/api/equipment-forecast/summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name GetEquipmentRental
   * @summary Returns the full details of a single inter-location equipment movement/loan record by its ID.
   * @request GET:/api/equipment-rentals/{Id}
   * @secure
   */
  getEquipmentRental = (id: string, params: RequestParams = {}) =>
    this.request<GetEquipmentRentalData, any>({
      path: `/api/equipment-rentals/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name ScanSerialNumber
   * @summary Scans an equipment serial number to retrieve its current open inter-location rental record; returns 404 if no active rental exists for that item.
   * @request GET:/api/equipment-rentals/scan/{serialNumber}
   * @secure
   */
  scanSerialNumber = (serialNumber: string, params: RequestParams = {}) =>
    this.request<ScanSerialNumberData, any>({
      path: `/api/equipment-rentals/scan/${serialNumber}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name GetEquipmentRentals
   * @summary Returns a paginated list of inter-location equipment movement records with optional status and date filters.
   * @request GET:/api/equipment-rentals
   * @secure
   */
  getEquipmentRentals = (
    query: GetEquipmentRentalsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentRentalsData, any>({
      path: `/api/equipment-rentals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name CreateEquipmentRental
   * @summary Creates a new inter-location equipment loan record, tracking movement of equipment from a source rental to a destination rental.
   * @request POST:/api/equipment-rentals
   * @secure
   */
  createEquipmentRental = (
    data: CreateEquipmentRentalPayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateEquipmentRentalData, any>({
      path: `/api/equipment-rentals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name ExportEquipmentRentals
   * @summary Exports inter-location equipment movement records to an Excel (.xlsx) file with optional filters applied.
   * @request GET:/api/equipment-rentals/export
   * @secure
   */
  exportEquipmentRentals = (
    query: ExportEquipmentRentalsParams,
    params: RequestParams = {},
  ) =>
    this.request<ExportEquipmentRentalsData, ExportEquipmentRentalsError>({
      path: `/api/equipment-rentals/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name UpdateEquipmentRental
   * @summary Updates an existing inter-location equipment rental record's details such as expected return date or destination location.
   * @request PUT:/api/equipment-rentals/{EquipmentRentalId}
   * @secure
   */
  updateEquipmentRental = (
    equipmentRentalId: string,
    data: UpdateEquipmentRentalPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateEquipmentRentalData, any>({
      path: `/api/equipment-rentals/${equipmentRentalId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name MarkAsReturned
   * @summary Marks an inter-location equipment rental as returned, recording the actual return date and destination location.
   * @request POST:/api/equipment-rentals/markAsReturned/{equipmentRentalId}
   * @secure
   */
  markAsReturned = (
    equipmentRentalId: string,
    data: MarkAsReturnedPayload,
    params: RequestParams = {},
  ) =>
    this.request<MarkAsReturnedData, any>({
      path: `/api/equipment-rentals/markAsReturned/${equipmentRentalId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name MarkAsPresent
   * @summary Marks an inter-location equipment rental as physically present and confirmed at the destination location.
   * @request POST:/api/equipment-rentals/markAsPresent/{equipmentRentalId}
   * @secure
   */
  markAsPresent = (equipmentRentalId: string, params: RequestParams = {}) =>
    this.request<MarkAsPresentData, any>({
      path: `/api/equipment-rentals/markAsPresent/${equipmentRentalId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name ProcessLocationRentalDrop
   * @summary Processes a batch equipment drop-off at a location, creating rental movement records for all equipment being transferred in a single operation.
   * @request POST:/api/equipment-rentals/processLocationRentalDrop
   * @secure
   */
  processLocationRentalDrop = (
    data: ProcessLocationRentalDropPayload,
    params: RequestParams = {},
  ) =>
    this.request<ProcessLocationRentalDropData, any>({
      path: `/api/equipment-rentals/processLocationRentalDrop`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name ProcessLocationRentalsPresent
   * @summary Batch-confirms presence of equipment at a location by matching provided rental IDs against open records, marking confirmed items as present.
   * @request POST:/api/equipment-rentals/processLocationRentalsPresent
   * @secure
   */
  processLocationRentalsPresent = (
    data: ProcessLocationRentalsPresentPayload,
    params: RequestParams = {},
  ) =>
    this.request<ProcessLocationRentalsPresentData, any>({
      path: `/api/equipment-rentals/processLocationRentalsPresent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name ProcessLocationRentalReturns
   * @summary Processes a batch return of equipment from a location, marking items as returned (clean) or returned-damaged and closing their rental records.
   * @request POST:/api/equipment-rentals/processRentalReturns
   * @secure
   */
  processLocationRentalReturns = (
    data: ProcessLocationRentalReturnsPayload,
    params: RequestParams = {},
  ) =>
    this.request<ProcessLocationRentalReturnsData, any>({
      path: `/api/equipment-rentals/processRentalReturns`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name SubmitScanSession
   * @summary Atomically processes a completed mode-locked scan session (Drop / ShelfScan / Return) and persists it to the visit log. ShelfScan completion runs the absent-to-Rented sweep with the same-visit exemption. Idempotent on ClientSessionId.
   * @request POST:/api/equipment-rentals/scan-sessions
   * @secure
   */
  submitScanSession = (
    data: SubmitScanSessionPayload,
    params: RequestParams = {},
  ) =>
    this.request<SubmitScanSessionData, any>({
      path: `/api/equipment-rentals/scan-sessions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name GetScanSessions
   * @summary Returns the paginated scan-session log (the record of completed mode-locked scan visits), newest first, scoped to the caller's accessible locations.
   * @request GET:/api/equipment-rentals/scan-sessions
   * @secure
   */
  getScanSessions = (
    query: GetScanSessionsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetScanSessionsData, any>({
      path: `/api/equipment-rentals/scan-sessions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name PreviewScanSessionSweep
   * @summary Read-only dry-run of a ShelfScan session's completion sweep: which unscanned open rentals would be marked Rented and which are exempt as handled earlier in the same visit. Nothing is written.
   * @request POST:/api/equipment-rentals/scan-sessions/preview
   * @secure
   */
  previewScanSessionSweep = (
    data: PreviewScanSessionSweepPayload,
    params: RequestParams = {},
  ) =>
    this.request<PreviewScanSessionSweepData, any>({
      path: `/api/equipment-rentals/scan-sessions/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name GetScanSession
   * @summary Returns one scan session with its per-item outcomes (what was scanned, dropped, returned, swept to rented, or exempted).
   * @request GET:/api/equipment-rentals/scan-sessions/{id}
   * @secure
   */
  getScanSession = (id: string, params: RequestParams = {}) =>
    this.request<GetScanSessionData, any>({
      path: `/api/equipment-rentals/scan-sessions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name FixDuplicatedRentals
   * @summary Admin utility that detects and resolves duplicate open rental records for equipment at a location, returning the count of records fixed.
   * @request POST:/api/equipment-rentals/fixDuplicatedRentals
   * @secure
   */
  fixDuplicatedRentals = (
    query: FixDuplicatedRentalsParams,
    params: RequestParams = {},
  ) =>
    this.request<FixDuplicatedRentalsData, any>({
      path: `/api/equipment-rentals/fixDuplicatedRentals`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name GetCompensationCandidates
   * @summary Unreturned rentals at the partner's locations older than the given age — candidates for lost-item compensation (Admin, Manager only). Includes missing-marked rentals.
   * @request GET:/api/equipment-rentals/compensation-candidates
   * @secure
   */
  getCompensationCandidates = (
    query: GetCompensationCandidatesParams,
    params: RequestParams = {},
  ) =>
    this.request<GetCompensationCandidatesData, any>({
      path: `/api/equipment-rentals/compensation-candidates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentRentals
   * @name CompensateEquipmentRentals
   * @summary Marks the selected unreturned rentals as compensated by the partner: closes the rentals, retires the items into the graveyard, and records the audit rows (Admin, Manager only). 400 with key "compensation" listing invalid items; all-or-nothing.
   * @request POST:/api/equipment-rentals/compensate
   * @secure
   */
  compensateEquipmentRentals = (
    data: CompensateEquipmentRentalsPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CompensateEquipmentRentalsData,
      CompensateEquipmentRentalsError
    >({
      path: `/api/equipment-rentals/compensate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentSales
   * @name EquipmentSalesCustomerForSaleList
   * @summary Customer: Get all equipment items available for sale at a specific location
   * @request GET:/api/EquipmentSales/customer/for-sale
   * @secure
   */
  equipmentSalesCustomerForSaleList = (
    query: EquipmentSalesCustomerForSaleListParams,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentSalesCustomerForSaleListData, any>({
      path: `/api/EquipmentSales/customer/for-sale`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentSales
   * @name EquipmentSalesCustomerPriceList
   * @summary Customer: Get the sale price for a specific equipment item
   * @request GET:/api/EquipmentSales/customer/{equipmentId}/price
   * @secure
   */
  equipmentSalesCustomerPriceList = (
    equipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentSalesCustomerPriceListData,
      EquipmentSalesCustomerPriceListError
    >({
      path: `/api/EquipmentSales/customer/${equipmentId}/price`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags EquipmentSales
 * @name EquipmentSalesCustomerPurchaseCreate
 * @summary Customer: Purchase an equipment item (create payment intent)
NOTE: This endpoint creates a payment intent. The actual sale processing
happens via webhook when payment succeeds.
 * @request POST:/api/EquipmentSales/customer/{equipmentId}/purchase
 * @secure
 */
  equipmentSalesCustomerPurchaseCreate = (
    equipmentId: string,
    data: EquipmentSalesCustomerPurchaseCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentSalesCustomerPurchaseCreateData,
      EquipmentSalesCustomerPurchaseCreateError
    >({
      path: `/api/EquipmentSales/customer/${equipmentId}/purchase`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentSales
   * @name EquipmentSalesAdminForSaleList
   * @summary Admin: Get all equipment items for sale (all locations)
   * @request GET:/api/EquipmentSales/admin/for-sale
   * @secure
   */
  equipmentSalesAdminForSaleList = (
    query: EquipmentSalesAdminForSaleListParams,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentSalesAdminForSaleListData, any>({
      path: `/api/EquipmentSales/admin/for-sale`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentSales
   * @name EquipmentSalesAdminMarkForSaleCreate
   * @summary Admin: Mark an equipment item for sale with a condition grade
   * @request POST:/api/EquipmentSales/admin/{equipmentId}/mark-for-sale
   * @secure
   */
  equipmentSalesAdminMarkForSaleCreate = (
    equipmentId: string,
    data: EquipmentSalesAdminMarkForSaleCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentSalesAdminMarkForSaleCreateData,
      EquipmentSalesAdminMarkForSaleCreateError
    >({
      path: `/api/EquipmentSales/admin/${equipmentId}/mark-for-sale`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentSales
   * @name EquipmentSalesAdminMarkForSaleDelete
   * @summary Admin: Remove an equipment item from sale
   * @request DELETE:/api/EquipmentSales/admin/{equipmentId}/mark-for-sale
   * @secure
   */
  equipmentSalesAdminMarkForSaleDelete = (
    equipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentSalesAdminMarkForSaleDeleteData,
      EquipmentSalesAdminMarkForSaleDeleteError
    >({
      path: `/api/EquipmentSales/admin/${equipmentId}/mark-for-sale`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentSales
   * @name EquipmentSalesAdminReleaseSaleCreate
   * @summary Admin: Release (un-sell) a SOLD equipment item after a refunded sale, returning it to inventory.
   * @request POST:/api/EquipmentSales/admin/{equipmentId}/release-sale
   * @secure
   */
  equipmentSalesAdminReleaseSaleCreate = (
    equipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentSalesAdminReleaseSaleCreateData,
      EquipmentSalesAdminReleaseSaleCreateError
    >({
      path: `/api/EquipmentSales/admin/${equipmentId}/release-sale`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name CreateEquipmentType
   * @summary Creates a new equipment type with all product metadata: name, pricing tiers, images, features, age/weight ranges, SEO fields, and accessories (Admin only).
   * @request POST:/api/equipmentTypes
   * @secure
   */
  createEquipmentType = (
    data: CreateEquipmentTypePayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateEquipmentTypeData, CreateEquipmentTypeError>({
      path: `/api/equipmentTypes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name GetEquipmentTypes
   * @summary Returns equipment types with all metadata. Optionally filters to inventory supplying the current user's accessible locations.
   * @request GET:/api/equipmentTypes
   * @secure
   */
  getEquipmentTypes = (
    query: GetEquipmentTypesParams,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentTypesData, any>({
      path: `/api/equipmentTypes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name EquipmentTypesImagesCreate
   * @summary Uploads an image or video file for an equipment type to S3, returning the public URL (Admin only, max 100 MB).
   * @request POST:/api/equipmentTypes/{id}/images
   * @secure
   */
  equipmentTypesImagesCreate = (
    id: string,
    data: EquipmentTypesImagesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentTypesImagesCreateData,
      EquipmentTypesImagesCreateError
    >({
      path: `/api/equipmentTypes/${id}/images`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name EquipmentTypesImagesDelete
   * @summary Removes a specific image URL from an equipment type's image list and deletes it from S3 (Admin only).
   * @request DELETE:/api/equipmentTypes/{id}/images
   * @secure
   */
  equipmentTypesImagesDelete = (
    { id, ...query }: EquipmentTypesImagesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentTypesImagesDeleteData,
      EquipmentTypesImagesDeleteError
    >({
      path: `/api/equipmentTypes/${id}/images`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name GetEquipmentTypesByLocation
   * @summary Returns location inventory types, including unavailable units. Parent-only rows are disabled for exact reservations; partner-held stock is excluded.
   * @request GET:/api/equipmentTypes/by-location/{locationId}
   * @secure
   */
  getEquipmentTypesByLocation = (
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<GetEquipmentTypesByLocationData, any>({
      path: `/api/equipmentTypes/by-location/${locationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name GetEquipmentType
   * @summary Returns a single equipment type by ID with full details including pricing tiers, images, features, and included accessories.
   * @request GET:/api/equipmentTypes/{Id}
   * @secure
   */
  getEquipmentType = (id: string, params: RequestParams = {}) =>
    this.request<GetEquipmentTypeData, GetEquipmentTypeError>({
      path: `/api/equipmentTypes/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name UpdateEquipmentType
   * @summary Updates an equipment type's metadata, images, features, accessories, age/weight ranges, SEO fields, and visibility settings (Admin only).
   * @request PUT:/api/equipmentTypes/{Id}
   * @secure
   */
  updateEquipmentType = (
    id: string,
    data: UpdateEquipmentTypePayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateEquipmentTypeData, UpdateEquipmentTypeError>({
      path: `/api/equipmentTypes/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name DeleteEquipmentType
   * @summary Permanently deletes an equipment type by ID (Admin only); returns 200 OK on success.
   * @request DELETE:/api/equipmentTypes/{Id}
   * @secure
   */
  deleteEquipmentType = (id: string, params: RequestParams = {}) =>
    this.request<DeleteEquipmentTypeData, DeleteEquipmentTypeError>({
      path: `/api/equipmentTypes/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name GetEquipmentTypeStock
   * @summary Returns a stock summary for an equipment type: total counts by status (Available, Rented, Damaged, etc.) across all accessible locations.
   * @request GET:/api/equipmentTypes/{id}/stock
   * @secure
   */
  getEquipmentTypeStock = (id: string, params: RequestParams = {}) =>
    this.request<GetEquipmentTypeStockData, GetEquipmentTypeStockError>({
      path: `/api/equipmentTypes/${id}/stock`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name EquipmentTypesCatalogueReorderUpdate
   * @summary Updates the full customer-visible equipment type catalogue order using zero-based sort indexes (Admin only).
   * @request PUT:/api/equipmentTypes/catalogue/reorder
   * @secure
   */
  equipmentTypesCatalogueReorderUpdate = (
    data: EquipmentTypesCatalogueReorderUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentTypesCatalogueReorderUpdateData,
      EquipmentTypesCatalogueReorderUpdateError
    >({
      path: `/api/equipmentTypes/catalogue/reorder`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name UpdateEquipmentTypePricing
   * @summary Updates only the pricing fields for an equipment type: all rental tier prices, subscription rates, cost tracking, deposit settings, and new-item premium prices (Admin only).
   * @request PUT:/api/equipmentTypes/{Id}/pricing
   * @secure
   */
  updateEquipmentTypePricing = (
    id: string,
    data: UpdateEquipmentTypePricingPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      UpdateEquipmentTypePricingData,
      UpdateEquipmentTypePricingError
    >({
      path: `/api/equipmentTypes/${id}/pricing`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name EquipmentTypesRelatedCreate
   * @summary Adds a cross-sell relationship between two equipment types for the customer-facing "related products" section (Admin only).
   * @request POST:/api/equipmentTypes/{id}/related
   * @secure
   */
  equipmentTypesRelatedCreate = (
    id: string,
    data: EquipmentTypesRelatedCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<any, EquipmentTypesRelatedCreateError>({
      path: `/api/equipmentTypes/${id}/related`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name AdminEquipmentTypesRelatedCreate
   * @summary Adds a cross-sell relationship between two equipment types for the customer-facing "related products" section (Admin only).
   * @request POST:/api/admin/equipment-types/{id}/related
   * @secure
   */
  adminEquipmentTypesRelatedCreate = (
    id: string,
    data: AdminEquipmentTypesRelatedCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<any, AdminEquipmentTypesRelatedCreateError>({
      path: `/api/admin/equipment-types/${id}/related`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name EquipmentTypesRelatedDelete
   * @summary Removes a cross-sell relationship between two equipment types from the customer-facing "related products" section (Admin only).
   * @request DELETE:/api/equipmentTypes/{id}/related/{relatedId}
   * @secure
   */
  equipmentTypesRelatedDelete = (
    id: string,
    relatedId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, EquipmentTypesRelatedDeleteError>({
      path: `/api/equipmentTypes/${id}/related/${relatedId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name AdminEquipmentTypesRelatedDelete
   * @summary Removes a cross-sell relationship between two equipment types from the customer-facing "related products" section (Admin only).
   * @request DELETE:/api/admin/equipment-types/{id}/related/{relatedId}
   * @secure
   */
  adminEquipmentTypesRelatedDelete = (
    id: string,
    relatedId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, AdminEquipmentTypesRelatedDeleteError>({
      path: `/api/admin/equipment-types/${id}/related/${relatedId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name EquipmentTypesRelatedReorderUpdate
   * @summary Updates the sort order of related equipment types for the cross-sell section, accepting an ordered list of related IDs (Admin only).
   * @request PUT:/api/equipmentTypes/{id}/related/reorder
   * @secure
   */
  equipmentTypesRelatedReorderUpdate = (
    id: string,
    data: EquipmentTypesRelatedReorderUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentTypesRelatedReorderUpdateData, any>({
      path: `/api/equipmentTypes/${id}/related/reorder`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EquipmentTypes
   * @name AdminEquipmentTypesRelatedReorderUpdate
   * @summary Updates the sort order of related equipment types for the cross-sell section, accepting an ordered list of related IDs (Admin only).
   * @request PUT:/api/admin/equipment-types/{id}/related/reorder
   * @secure
   */
  adminEquipmentTypesRelatedReorderUpdate = (
    id: string,
    data: AdminEquipmentTypesRelatedReorderUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AdminEquipmentTypesRelatedReorderUpdateData, any>({
      path: `/api/admin/equipment-types/${id}/related/reorder`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags Files
 * @name UploadImage
 * @summary Uploads an image to S3 and returns the public URL.
Used by the TipTap rich-text editor image upload extension.
 * @request POST:/api/files/image
 * @secure
 */
  uploadImage = (data: UploadImagePayload, params: RequestParams = {}) =>
    this.request<UploadImageData, UploadImageError>({
      path: `/api/files/image`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Files
 * @name UploadEmailTemplateImage
 * @summary Uploads an email-template image to S3 and logs metadata for the recent gallery.
Returns the public URL expected by TipTap image upload handlers.
 * @request POST:/api/files/email-template-image
 * @secure
 */
  uploadEmailTemplateImage = (
    data: UploadEmailTemplateImagePayload,
    params: RequestParams = {},
  ) =>
    this.request<UploadEmailTemplateImageData, UploadEmailTemplateImageError>({
      path: `/api/files/email-template-image`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Files
 * @name GetRecentEmailTemplateImages
 * @summary Returns recent email-template image uploads, newest first.
Results are scoped to email-template uploads only.
 * @request GET:/api/files/email-template-images/recent
 * @secure
 */
  getRecentEmailTemplateImages = (
    query: GetRecentEmailTemplateImagesParams,
    params: RequestParams = {},
  ) =>
    this.request<GetRecentEmailTemplateImagesData, any>({
      path: `/api/files/email-template-images/recent`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Files
 * @name UploadProductImage
 * @summary Uploads a product image or video to S3 and returns the public URL.
Supports images (JPEG, PNG, GIF, WebP, SVG, BMP) and videos (MP4, WebM, MOV) up to 100 MB.
No database side-effects — the caller is responsible for persisting the returned URL.
Used by the equipment type form to allow uploads before or after the type is saved.
 * @request POST:/api/files/product-image
 * @secure
 */
  uploadProductImage = (
    data: UploadProductImagePayload,
    params: RequestParams = {},
  ) =>
    this.request<UploadProductImageData, UploadProductImageError>({
      path: `/api/files/product-image`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Files
 * @name UploadLocationImage
 * @summary Uploads a location image to S3 and returns the public URL.
Accepts images only up to 10 MB.
No database side-effects — the caller is responsible for persisting the returned URL.
 * @request POST:/api/files/location-image
 * @secure
 */
  uploadLocationImage = (
    data: UploadLocationImagePayload,
    params: RequestParams = {},
  ) =>
    this.request<UploadLocationImageData, UploadLocationImageError>({
      path: `/api/files/location-image`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name ExtractExcelHeaders
   * @summary Extracts and returns the column headers from an uploaded Excel file.
   * @request POST:/api/files/extract-headers
   * @secure
   */
  extractExcelHeaders = (
    data: ExtractExcelHeadersPayload,
    params: RequestParams = {},
  ) =>
    this.request<ExtractExcelHeadersData, ExtractExcelHeadersError>({
      path: `/api/files/extract-headers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name GetLastRecordGoFileUpload
   * @summary Returns the log entry for the most recent RecordGo reservation file upload.
   * @request GET:/api/files/recordgo
   * @secure
   */
  getLastRecordGoFileUpload = (params: RequestParams = {}) =>
    this.request<GetLastRecordGoFileUploadData, any>({
      path: `/api/files/recordgo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name UploadRecordGoFile
   * @summary Processes and imports a RecordGo reservation file to sync rental data.
   * @request POST:/api/files/recordgo
   * @secure
   */
  uploadRecordGoFile = (
    data: UploadRecordGoFilePayload,
    params: RequestParams = {},
  ) =>
    this.request<UploadRecordGoFileData, any>({
      path: `/api/files/recordgo`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name GetLastSixtFileUpload
   * @summary Returns the log entry for the most recent Sixt reservation file upload.
   * @request GET:/api/files/sixt
   * @secure
   */
  getLastSixtFileUpload = (params: RequestParams = {}) =>
    this.request<GetLastSixtFileUploadData, any>({
      path: `/api/files/sixt`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name UploadSixtReservationsFile
   * @summary Processes and imports a Sixt reservations file to sync rental data.
   * @request POST:/api/files/sixt
   * @secure
   */
  uploadSixtReservationsFile = (
    data: UploadSixtReservationsFilePayload,
    params: RequestParams = {},
  ) =>
    this.request<UploadSixtReservationsFileData, any>({
      path: `/api/files/sixt`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name UploadLocationEquipmentFile
   * @summary Processes an equipment stock file upload for a specific rental location.
   * @request POST:/api/files/equipment/{rentalId}
   * @secure
   */
  uploadLocationEquipmentFile = (
    rentalId: string,
    data: UploadLocationEquipmentFilePayload,
    params: RequestParams = {},
  ) =>
    this.request<UploadLocationEquipmentFileData, any>({
      path: `/api/files/equipment/${rentalId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name UploadMappedLocationEquipmentFile
   * @summary Processes an equipment stock file with custom column mappings for a specific location.
   * @request POST:/api/files/equipment/{locationId}/mapped
   * @secure
   */
  uploadMappedLocationEquipmentFile = (
    locationId: string,
    data: UploadMappedLocationEquipmentFilePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      UploadMappedLocationEquipmentFileData,
      UploadMappedLocationEquipmentFileError
    >({
      path: `/api/files/equipment/${locationId}/mapped`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name GetEquipmentMappableFields
   * @summary Returns the list of equipment fields that can be mapped during a stock file import.
   * @request GET:/api/files/equipment/mappable-fields
   * @secure
   */
  getEquipmentMappableFields = (params: RequestParams = {}) =>
    this.request<GetEquipmentMappableFieldsData, any>({
      path: `/api/files/equipment/mappable-fields`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Haccp
 * @name HaccpSummaryList
 * @summary Returns a snapshot of operational items needing the team's attention plus a
situational-awareness region (rentals breakdown, recent movements, missing reports).
One round-trip, 30s stale time on the client. Optional area / location / company /
upcoming-window filters scope every section that is location-aware.
 * @request GET:/api/haccp/summary
 * @secure
 */
  haccpSummaryList = (
    query: HaccpSummaryListParams,
    params: RequestParams = {},
  ) =>
    this.request<HaccpSummaryListData, any>({
      path: `/api/haccp/summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Layout
   * @name GetFuseNavigation
   * @summary Returns the admin panel navigation menu filtered by the current user's roles.
   * @request GET:/api/menu/navigation
   * @secure
   */
  getFuseNavigation = (params: RequestParams = {}) =>
    this.request<GetFuseNavigationData, any>({
      path: `/api/menu/navigation`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationBundles
   * @name LocalizationBundlesRebuildCreate
   * @request POST:/api/localization/bundles/rebuild
   * @secure
   */
  localizationBundlesRebuildCreate = (params: RequestParams = {}) =>
    this.request<LocalizationBundlesRebuildCreateData, any>({
      path: `/api/localization/bundles/rebuild`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationBundles
   * @name LocalizationBundlesSeedCreate
   * @request POST:/api/localization/bundles/seed
   * @secure
   */
  localizationBundlesSeedCreate = (params: RequestParams = {}) =>
    this.request<LocalizationBundlesSeedCreateData, any>({
      path: `/api/localization/bundles/seed`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationBundles
   * @name LocalizationBundlesStagedList
   * @request GET:/api/localization/bundles/staged
   * @secure
   */
  localizationBundlesStagedList = (params: RequestParams = {}) =>
    this.request<LocalizationBundlesStagedListData, any>({
      path: `/api/localization/bundles/staged`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationBundles
   * @name LocalizationBundlesActivateCreate
   * @request POST:/api/localization/bundles/activate
   * @secure
   */
  localizationBundlesActivateCreate = (
    data: LocalizationBundlesActivateCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationBundlesActivateCreateData, any>({
      path: `/api/localization/bundles/activate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesList
   * @request GET:/api/localization/locales
   * @secure
   */
  localizationLocalesList = (params: RequestParams = {}) =>
    this.request<LocalizationLocalesListData, any>({
      path: `/api/localization/locales`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesCreate
   * @request POST:/api/localization/locales
   * @secure
   */
  localizationLocalesCreate = (
    data: LocalizationLocalesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesCreateData, any>({
      path: `/api/localization/locales`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesReadinessList
   * @request GET:/api/localization/locales/{localeCode}/readiness
   * @secure
   */
  localizationLocalesReadinessList = (
    localeCode: string,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesReadinessListData, any>({
      path: `/api/localization/locales/${localeCode}/readiness`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesDictionaryEntriesList
   * @request GET:/api/localization/locales/{localeCode}/dictionary-entries
   * @secure
   */
  localizationLocalesDictionaryEntriesList = (
    localeCode: string,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesDictionaryEntriesListData, any>({
      path: `/api/localization/locales/${localeCode}/dictionary-entries`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesDictionaryEntriesUpdate
   * @request PUT:/api/localization/locales/{localeCode}/dictionary-entries
   * @secure
   */
  localizationLocalesDictionaryEntriesUpdate = (
    localeCode: string,
    data: LocalizationLocalesDictionaryEntriesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesDictionaryEntriesUpdateData, any>({
      path: `/api/localization/locales/${localeCode}/dictionary-entries`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesDictionaryTranslationsList
   * @request GET:/api/localization/locales/{localeCode}/dictionary-translations
   * @secure
   */
  localizationLocalesDictionaryTranslationsList = (
    localeCode: string,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesDictionaryTranslationsListData, any>({
      path: `/api/localization/locales/${localeCode}/dictionary-translations`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesDictionaryTranslationsImportCreate
   * @request POST:/api/localization/locales/{localeCode}/dictionary-translations/import
   * @secure
   */
  localizationLocalesDictionaryTranslationsImportCreate = (
    localeCode: string,
    data: LocalizationLocalesDictionaryTranslationsImportCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      LocalizationLocalesDictionaryTranslationsImportCreateData,
      any
    >({
      path: `/api/localization/locales/${localeCode}/dictionary-translations/import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesDictionaryEntriesBatchUpdate
   * @request PUT:/api/localization/locales/{localeCode}/dictionary-entries/batch
   * @secure
   */
  localizationLocalesDictionaryEntriesBatchUpdate = (
    localeCode: string,
    data: LocalizationLocalesDictionaryEntriesBatchUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesDictionaryEntriesBatchUpdateData, any>({
      path: `/api/localization/locales/${localeCode}/dictionary-entries/batch`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesTranslationSuggestionsCreate
   * @request POST:/api/localization/locales/{localeCode}/translation-suggestions
   * @secure
   */
  localizationLocalesTranslationSuggestionsCreate = (
    localeCode: string,
    data: LocalizationLocalesTranslationSuggestionsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesTranslationSuggestionsCreateData, any>({
      path: `/api/localization/locales/${localeCode}/translation-suggestions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesEquipmentTypesTranslationList
   * @request GET:/api/localization/locales/{localeCode}/equipment-types/{equipmentTypeId}/translation
   * @secure
   */
  localizationLocalesEquipmentTypesTranslationList = (
    localeCode: string,
    equipmentTypeId: string,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesEquipmentTypesTranslationListData, any>({
      path: `/api/localization/locales/${localeCode}/equipment-types/${equipmentTypeId}/translation`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesEquipmentTypesTranslationUpdate
   * @request PUT:/api/localization/locales/{localeCode}/equipment-types/{equipmentTypeId}/translation
   * @secure
   */
  localizationLocalesEquipmentTypesTranslationUpdate = (
    localeCode: string,
    equipmentTypeId: string,
    data: LocalizationLocalesEquipmentTypesTranslationUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesEquipmentTypesTranslationUpdateData, any>({
      path: `/api/localization/locales/${localeCode}/equipment-types/${equipmentTypeId}/translation`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesCategoriesTranslationList
   * @request GET:/api/localization/locales/{localeCode}/categories/{categoryId}/translation
   * @secure
   */
  localizationLocalesCategoriesTranslationList = (
    localeCode: string,
    categoryId: string,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesCategoriesTranslationListData, any>({
      path: `/api/localization/locales/${localeCode}/categories/${categoryId}/translation`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesCategoriesTranslationUpdate
   * @request PUT:/api/localization/locales/{localeCode}/categories/{categoryId}/translation
   * @secure
   */
  localizationLocalesCategoriesTranslationUpdate = (
    localeCode: string,
    categoryId: string,
    data: LocalizationLocalesCategoriesTranslationUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesCategoriesTranslationUpdateData, any>({
      path: `/api/localization/locales/${localeCode}/categories/${categoryId}/translation`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesLocationsTranslationList
   * @request GET:/api/localization/locales/{localeCode}/locations/{locationId}/translation
   * @secure
   */
  localizationLocalesLocationsTranslationList = (
    localeCode: string,
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesLocationsTranslationListData, any>({
      path: `/api/localization/locales/${localeCode}/locations/${locationId}/translation`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesLocationsTranslationUpdate
   * @request PUT:/api/localization/locales/{localeCode}/locations/{locationId}/translation
   * @secure
   */
  localizationLocalesLocationsTranslationUpdate = (
    localeCode: string,
    locationId: string,
    data: LocalizationLocalesLocationsTranslationUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesLocationsTranslationUpdateData, any>({
      path: `/api/localization/locales/${localeCode}/locations/${locationId}/translation`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocalizationLocales
   * @name LocalizationLocalesPublishCreate
   * @request POST:/api/localization/locales/publish
   * @secure
   */
  localizationLocalesPublishCreate = (
    data: LocalizationLocalesPublishCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<LocalizationLocalesPublishCreateData, any>({
      path: `/api/localization/locales/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocationPricing
   * @name EquipmentTypesLocationPricingList
   * @summary Get all location pricing overrides for an equipment type.
   * @request GET:/api/equipment-types/{equipmentTypeId}/location-pricing
   * @secure
   */
  equipmentTypesLocationPricingList = (
    equipmentTypeId: string,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentTypesLocationPricingListData, any>({
      path: `/api/equipment-types/${equipmentTypeId}/location-pricing`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LocationPricing
   * @name EquipmentTypesLocationPricingDetail
   * @summary Get a specific location pricing override.
   * @request GET:/api/equipment-types/{equipmentTypeId}/location-pricing/{locationId}
   * @secure
   */
  equipmentTypesLocationPricingDetail = (
    equipmentTypeId: string,
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      EquipmentTypesLocationPricingDetailData,
      EquipmentTypesLocationPricingDetailError
    >({
      path: `/api/equipment-types/${equipmentTypeId}/location-pricing/${locationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LocationPricing
   * @name EquipmentTypesLocationPricingUpdate
   * @summary Create or update a location pricing override.
   * @request PUT:/api/equipment-types/{equipmentTypeId}/location-pricing/{locationId}
   * @secure
   */
  equipmentTypesLocationPricingUpdate = (
    equipmentTypeId: string,
    locationId: string,
    data: EquipmentTypesLocationPricingUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentTypesLocationPricingUpdateData, any>({
      path: `/api/equipment-types/${equipmentTypeId}/location-pricing/${locationId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LocationPricing
   * @name EquipmentTypesLocationPricingDelete
   * @summary Delete a location pricing override (reverts to default pricing).
   * @request DELETE:/api/equipment-types/{equipmentTypeId}/location-pricing/{locationId}
   * @secure
   */
  equipmentTypesLocationPricingDelete = (
    equipmentTypeId: string,
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentTypesLocationPricingDeleteData, any>({
      path: `/api/equipment-types/${equipmentTypeId}/location-pricing/${locationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LocationPricing
   * @name EquipmentTypesLocationPricingCopyDefaultsCreate
   * @summary Copy equipment type default pricing as a starting point for a location override.
   * @request POST:/api/equipment-types/{equipmentTypeId}/location-pricing/{locationId}/copy-defaults
   * @secure
   */
  equipmentTypesLocationPricingCopyDefaultsCreate = (
    equipmentTypeId: string,
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentTypesLocationPricingCopyDefaultsCreateData, any>({
      path: `/api/equipment-types/${equipmentTypeId}/location-pricing/${locationId}/copy-defaults`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags LocationPricing
 * @name EquipmentTypesLowestPriceList
 * @summary Get the lowest price for an equipment type across all locations.
Used for "Prices from" display in catalog.
 * @request GET:/api/equipment-types/{equipmentTypeId}/lowest-price
 * @secure
 */
  equipmentTypesLowestPriceList = (
    equipmentTypeId: string,
    params: RequestParams = {},
  ) =>
    this.request<EquipmentTypesLowestPriceListData, any>({
      path: `/api/equipment-types/${equipmentTypeId}/lowest-price`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name GetLocations
   * @summary Returns a paginated list of all rental locations.
   * @request GET:/api/locations
   * @secure
   */
  getLocations = (query: GetLocationsParams, params: RequestParams = {}) =>
    this.request<GetLocationsData, GetLocationsError>({
      path: `/api/locations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name CreateLocation
   * @summary Creates a new rental location.
   * @request POST:/api/locations
   * @secure
   */
  createLocation = (data: CreateLocationPayload, params: RequestParams = {}) =>
    this.request<CreateLocationData, CreateLocationError>({
      path: `/api/locations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Pass `includeInactive=true` to also return locations whose `IsActive=false`. Used by the equipment-rentals Stranded tab so non-stocked locations marked inactive still surface for stranded-item tracking.
   *
   * @tags Locations
   * @name GetAccessibleLocations
   * @summary Returns rental locations accessible to the authenticated user.
   * @request GET:/api/locations/accessibleLocations
   * @secure
   */
  getAccessibleLocations = (
    query: GetAccessibleLocationsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetAccessibleLocationsData, any>({
      path: `/api/locations/accessibleLocations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Management scope (#644): unlike `accessibleLocations`, this list is NOT filtered by the caller's team/area/rental assignments. Operational filters must keep using `accessibleLocations`.
   *
   * @tags Locations
   * @name GetAllLocations
   * @summary Returns every location, for Admin/HR management surfaces (team/user assignment pickers, location administration).
   * @request GET:/api/locations/all
   * @secure
   */
  getAllLocations = (
    query: GetAllLocationsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetAllLocationsData, any>({
      path: `/api/locations/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name GetLocation
   * @summary Returns details for a single rental location by ID.
   * @request GET:/api/locations/{id}
   * @secure
   */
  getLocation = (id: string, params: RequestParams = {}) =>
    this.request<GetLocationData, GetLocationError>({
      path: `/api/locations/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name UpdateLocation
   * @summary Updates an existing rental location's details.
   * @request PUT:/api/locations/{id}
   * @secure
   */
  updateLocation = (
    id: string,
    data: UpdateLocationPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateLocationData, UpdateLocationError>({
      path: `/api/locations/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name DeleteLocation
   * @summary Deletes a rental location by ID.
   * @request DELETE:/api/locations/{id}
   * @secure
   */
  deleteLocation = (id: string, params: RequestParams = {}) =>
    this.request<DeleteLocationData, DeleteLocationError>({
      path: `/api/locations/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name RestoreLocation
   * @summary Restores a soft-deleted rental location by ID.
   * @request POST:/api/locations/{id}/restore
   * @secure
   */
  restoreLocation = (id: string, params: RequestParams = {}) =>
    this.request<RestoreLocationData, RestoreLocationError>({
      path: `/api/locations/${id}/restore`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description The alias is the name the location's CompanyRental uses for this location. Empty or whitespace-only Alias clears the existing alias.
   *
   * @tags Locations
   * @name SetLocationAlias
   * @summary Sets or clears the per-company alias for a rental location.
   * @request PUT:/api/locations/{id}/alias
   * @secure
   */
  setLocationAlias = (
    id: string,
    data: SetLocationAliasPayload,
    params: RequestParams = {},
  ) =>
    this.request<SetLocationAliasData, SetLocationAliasError>({
      path: `/api/locations/${id}/alias`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name GetWarehouses
   * @summary Returns all warehouse-type locations used for equipment storage and staging.
   * @request GET:/api/locations/warehouses
   * @secure
   */
  getWarehouses = (params: RequestParams = {}) =>
    this.request<GetWarehousesData, GetWarehousesError>({
      path: `/api/locations/warehouses`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Locations
   * @name GetSingleAndSublocations
   * @summary Returns a flat list of single-use and sub-locations, optionally scoped to a parent location.
   * @request GET:/api/locations/singleAndSublocations
   * @secure
   */
  getSingleAndSublocations = (
    query: GetSingleAndSublocationsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetSingleAndSublocationsData, GetSingleAndSublocationsError>({
      path: `/api/locations/singleAndSublocations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ManagerTeams
   * @name ManagerTeamsList
   * @summary Returns all teams that the current manager supervises.
   * @request GET:/api/manager/teams
   * @secure
   */
  managerTeamsList = (params: RequestParams = {}) =>
    this.request<ManagerTeamsListData, any>({
      path: `/api/manager/teams`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ManagerTeams
   * @name ManagerTeamsDetail
   * @summary Returns full details of a team managed by the current user.
   * @request GET:/api/manager/teams/{id}
   * @secure
   */
  managerTeamsDetail = (id: string, params: RequestParams = {}) =>
    this.request<ManagerTeamsDetailData, ManagerTeamsDetailError>({
      path: `/api/manager/teams/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ManagerTeams
   * @name ManagerTeamsMembersCreate
   * @summary Adds an employee to a team managed by the current user.
   * @request POST:/api/manager/teams/{id}/members
   * @secure
   */
  managerTeamsMembersCreate = (
    id: string,
    data: ManagerTeamsMembersCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ManagerTeamsMembersCreateData, ManagerTeamsMembersCreateError>(
      {
        path: `/api/manager/teams/${id}/members`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags ManagerTeams
   * @name ManagerTeamsMembersDelete
   * @summary Removes an employee from a team managed by the current user.
   * @request DELETE:/api/manager/teams/{id}/members/{userId}
   * @secure
   */
  managerTeamsMembersDelete = (
    id: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<ManagerTeamsMembersDeleteData, ManagerTeamsMembersDeleteError>(
      {
        path: `/api/manager/teams/${id}/members/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags ManagerUsers
   * @name ManagerUsersList
   * @summary Returns a paginated list of employees visible to the current manager, filtered by team, search, or active status.
   * @request GET:/api/manager/users
   * @secure
   */
  managerUsersList = (
    query: ManagerUsersListParams,
    params: RequestParams = {},
  ) =>
    this.request<ManagerUsersListData, any>({
      path: `/api/manager/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ManagerUsers
   * @name ManagerUsersCreate
   * @summary Creates a new employee account and optionally assigns them to a team.
   * @request POST:/api/manager/users
   * @secure
   */
  managerUsersCreate = (
    data: ManagerUsersCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ManagerUsersCreateData, ManagerUsersCreateError>({
      path: `/api/manager/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ManagerUsers
   * @name ManagerUsersUpdate
   * @summary Updates an employee's profile details within the manager's scope.
   * @request PUT:/api/manager/users/{id}
   * @secure
   */
  managerUsersUpdate = (
    id: string,
    data: ManagerUsersUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ManagerUsersUpdateData, ManagerUsersUpdateError>({
      path: `/api/manager/users/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ManagerUsers
   * @name ManagerUsersResetPasswordCreate
   * @summary Resets an employee's password and returns a new temporary password.
   * @request POST:/api/manager/users/{id}/reset-password
   * @secure
   */
  managerUsersResetPasswordCreate = (id: string, params: RequestParams = {}) =>
    this.request<
      ManagerUsersResetPasswordCreateData,
      ManagerUsersResetPasswordCreateError
    >({
      path: `/api/manager/users/${id}/reset-password`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsBookingCreate
   * @summary Opens a missing report for a booking, marking all (or specified) equipment items as missing and setting their status to Missing.
   * @request POST:/api/missing-items/booking/{bookingId}
   * @secure
   */
  missingItemsBookingCreate = (
    bookingId: string,
    data: MissingItemsBookingCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsBookingCreateData, any>({
      path: `/api/missing-items/booking/${bookingId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsBookingDetail
   * @summary Returns the missing report associated with a specific booking, including all its individual missing item records.
   * @request GET:/api/missing-items/booking/{bookingId}
   * @secure
   */
  missingItemsBookingDetail = (bookingId: string, params: RequestParams = {}) =>
    this.request<MissingItemsBookingDetailData, any>({
      path: `/api/missing-items/booking/${bookingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsEquipmentRentalCreate
   * @summary Opens a missing report for an inter-location equipment rental, marking the loaned equipment as missing with optional notes.
   * @request POST:/api/missing-items/equipment-rental/{equipmentRentalId}
   * @secure
   */
  missingItemsEquipmentRentalCreate = (
    equipmentRentalId: string,
    data: MissingItemsEquipmentRentalCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsEquipmentRentalCreateData, any>({
      path: `/api/missing-items/equipment-rental/${equipmentRentalId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsEquipmentRentalDetail
   * @summary Returns the missing report associated with a specific inter-location equipment rental, showing which loaned items have been reported missing.
   * @request GET:/api/missing-items/equipment-rental/{equipmentRentalId}
   * @secure
   */
  missingItemsEquipmentRentalDetail = (
    equipmentRentalId: string,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsEquipmentRentalDetailData, any>({
      path: `/api/missing-items/equipment-rental/${equipmentRentalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsItemCreate
   * @summary Marks a single booking equipment item as missing, creating a missing report item and updating the equipment status to Missing.
   * @request POST:/api/missing-items/item/{bookingEquipmentId}
   * @secure
   */
  missingItemsItemCreate = (
    bookingEquipmentId: string,
    data: MissingItemsItemCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsItemCreateData, any>({
      path: `/api/missing-items/item/${bookingEquipmentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsRecoverCreate
   * @summary Records recovery of a missing equipment item, closing the missing report item and optionally moving the equipment to a warehouse location.
   * @request POST:/api/missing-items/recover/{missingReportItemId}
   * @secure
   */
  missingItemsRecoverCreate = (
    missingReportItemId: string,
    data: MissingItemsRecoverCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsRecoverCreateData, any>({
      path: `/api/missing-items/recover/${missingReportItemId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsActiveList
   * @summary Returns all active missing item records (individual equipment items not yet recovered) for the current user's accessible locations.
   * @request GET:/api/missing-items/active
   * @secure
   */
  missingItemsActiveList = (params: RequestParams = {}) =>
    this.request<MissingItemsActiveListData, any>({
      path: `/api/missing-items/active`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsReportsActiveList
   * @summary Returns active missing reports (grouped by booking or equipment rental) where not all items have been recovered, for the current user's accessible locations, paginated newest-first with optional location/area/equipment-type/source/search filters.
   * @request GET:/api/missing-items/reports/active
   * @secure
   */
  missingItemsReportsActiveList = (
    query: MissingItemsReportsActiveListParams,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsReportsActiveListData, any>({
      path: `/api/missing-items/reports/active`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsReportsActiveExportList
   * @summary Exports all unresolved missing equipment matching the active-list filters, without pagination.
   * @request GET:/api/missing-items/reports/active/export
   * @secure
   */
  missingItemsReportsActiveExportList = (
    query: MissingItemsReportsActiveExportListParams,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsReportsActiveExportListData, any>({
      path: `/api/missing-items/reports/active/export`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MissingItems
   * @name MissingItemsItemDetail
   * @summary Returns a single missing report item by its ID, showing equipment details, missing context, and recovery status.
   * @request GET:/api/missing-items/item/{missingEquipmentId}
   * @secure
   */
  missingItemsItemDetail = (
    missingEquipmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<MissingItemsItemDetailData, any>({
      path: `/api/missing-items/item/${missingEquipmentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsRetryCreate
   * @summary Retries sending a failed email by its log ID.
   * @request POST:/api/notifications/retry/{emailLogId}
   * @secure
   */
  notificationsRetryCreate = (emailLogId: string, params: RequestParams = {}) =>
    this.request<NotificationsRetryCreateData, NotificationsRetryCreateError>({
      path: `/api/notifications/retry/${emailLogId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name NotificationsFailedList
   * @summary Gets a paginated list of failed emails.
   * @request GET:/api/notifications/failed
   * @secure
   */
  notificationsFailedList = (
    query: NotificationsFailedListParams,
    params: RequestParams = {},
  ) =>
    this.request<NotificationsFailedListData, any>({
      path: `/api/notifications/failed`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags PageContent
 * @name PageContentGetPageSection
 * @summary Returns the parsed JSON content for a page section.
Used by the customer-facing website. Falls back to component defaults when 404.
 * @request GET:/api/page-content/{pageSlug}/{sectionKey}
 * @secure
 */
  pageContentGetPageSection = (
    { pageSlug, sectionKey, ...query }: PageContentGetPageSectionParams,
    params: RequestParams = {},
  ) =>
    this.request<PageContentGetPageSectionData, any>({
      path: `/api/page-content/${pageSlug}/${sectionKey}`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PageContent
   * @name PageContentGetAll
   * @summary Returns all page content entries (backoffice).
   * @request GET:/api/page-content
   * @secure
   */
  pageContentGetAll = (params: RequestParams = {}) =>
    this.request<PageContentGetAllData, any>({
      path: `/api/page-content`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PageContent
   * @name PageContentCreate
   * @summary Creates a new page content entry (backoffice).
   * @request POST:/api/page-content
   * @secure
   */
  pageContentCreate = (
    data: PageContentCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PageContentCreateData, any>({
      path: `/api/page-content`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PageContent
   * @name PageContentGetById
   * @summary Returns a page content entry by ID (backoffice).
   * @request GET:/api/page-content/{id}
   * @secure
   */
  pageContentGetById = (id: string, params: RequestParams = {}) =>
    this.request<PageContentGetByIdData, any>({
      path: `/api/page-content/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PageContent
   * @name PageContentUpdate
   * @summary Updates a page content entry (backoffice).
   * @request PUT:/api/page-content/{id}
   * @secure
   */
  pageContentUpdate = (
    id: string,
    data: PageContentUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PageContentUpdateData, any>({
      path: `/api/page-content/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PageContent
   * @name PageContentDelete
   * @summary Deletes a page content entry (backoffice).
   * @request DELETE:/api/page-content/{id}
   * @secure
   */
  pageContentDelete = (id: string, params: RequestParams = {}) =>
    this.request<PageContentDeleteData, any>({
      path: `/api/page-content/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags Partner
 * @name PartnerLocationList
 * @summary Get the partner's first assigned location and company information.
Kept for backwards compatibility with the legacy single-location mobile flow.
New clients should call `GET /api/partner/locations` and present a picker.
 * @request GET:/api/partner/location
 * @secure
 */
  partnerLocationList = (params: RequestParams = {}) =>
    this.request<PartnerLocationListData, PartnerLocationListError>({
      path: `/api/partner/location`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Partner
 * @name PartnerLocationsList
 * @summary Get every location the partner user can scan at.
- Partner: the locations explicitly assigned via UserRental.
- PartnerAdmin: every location their company operates.
 * @request GET:/api/partner/locations
 * @secure
 */
  partnerLocationsList = (params: RequestParams = {}) =>
    this.request<PartnerLocationsListData, any>({
      path: `/api/partner/locations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Pass `locationId` when the user has access to multiple locations. When omitted, the server picks the user's only accessible location, or returns 400 if the user has more than one.
   *
   * @tags Partner
   * @name PartnerEquipmentList
   * @summary Get the list of equipment at a partner's location.
   * @request GET:/api/partner/equipment
   * @secure
   */
  partnerEquipmentList = (
    query: PartnerEquipmentListParams,
    params: RequestParams = {},
  ) =>
    this.request<PartnerEquipmentListData, PartnerEquipmentListError>({
      path: `/api/partner/equipment`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Partner
   * @name PartnerScanCreate
   * @summary Scan equipment by serial number at a target location.
   * @request POST:/api/partner/scan
   * @secure
   */
  partnerScanCreate = (
    data: PartnerScanCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PartnerScanCreateData, PartnerScanCreateError>({
      path: `/api/partner/scan`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Partner
   * @name PartnerScanHistoryList
   * @summary Get the partner's scan history.
   * @request GET:/api/partner/scan-history
   * @secure
   */
  partnerScanHistoryList = (
    query: PartnerScanHistoryListParams,
    params: RequestParams = {},
  ) =>
    this.request<PartnerScanHistoryListData, any>({
      path: `/api/partner/scan-history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Partner
 * @name PartnerConfirmCreate
 * @summary Confirm equipment presence at partner's location by serial number.
This is the simplified flow for the mobile app that automatically handles all scenarios:
A - Same company + location: Mark equipment as present
B - Same company, different location: Move equipment, mark present
C - Different company: Close old rental, create new rental, mark present
D - Equipment on booking: Create rental from booking, mark present
 * @request POST:/api/partner/confirm
 * @secure
 */
  partnerConfirmCreate = (
    data: PartnerConfirmCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PartnerConfirmCreateData, PartnerConfirmCreateError>({
      path: `/api/partner/confirm`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Partner
 * @name PartnerAppVersionList
 * @summary Get the latest Partner app version information.
Used by the mobile app to check for updates.
This endpoint does not require authentication.
 * @request GET:/api/partner/app-version
 * @secure
 */
  partnerAppVersionList = (
    query: PartnerAppVersionListParams,
    params: RequestParams = {},
  ) =>
    this.request<PartnerAppVersionListData, any>({
      path: `/api/partner/app-version`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Partner
 * @name PartnerAppReleasesDownloadList
 * @summary Downloads the app release file (APK/IPA) by proxying it from S3.
Streaming through the API keeps S3 private (no presigned URLs are
exposed) and serves the download from our own domain. Content-Length
is set explicitly so browsers can show the file size and a download ETA.
This endpoint does not require authentication for easy mobile app downloads.
 * @request GET:/api/partner/app-releases/{id}/download
 * @secure
 */
  partnerAppReleasesDownloadList = (id: string, params: RequestParams = {}) =>
    this.request<
      PartnerAppReleasesDownloadListData,
      PartnerAppReleasesDownloadListError
    >({
      path: `/api/partner/app-releases/${id}/download`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags Partner
 * @name PartnerUpdateLogCreate
 * @summary Receives an update lifecycle event logged by the Partner mobile app.
Used to diagnose in-app update failures on partner devices where we
have no direct access to logs.
This endpoint does not require authentication so it can be called even
before the user logs in (or when tokens have expired during an update).
 * @request POST:/api/partner/update-log
 * @secure
 */
  partnerUpdateLogCreate = (
    data: PartnerUpdateLogCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PartnerUpdateLogCreateData, PartnerUpdateLogCreateError>({
      path: `/api/partner/update-log`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminLocations
   * @name GetPartnerAdminLocations
   * @summary List every location the caller's company operates (own branches + Stork-managed).
   * @request GET:/api/partner-admin/locations
   * @secure
   */
  getPartnerAdminLocations = (params: RequestParams = {}) =>
    this.request<GetPartnerAdminLocationsData, GetPartnerAdminLocationsError>({
      path: `/api/partner-admin/locations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminLocations
   * @name CreatePartnerAdminLocation
   * @summary Create a partner-admin-owned location ("own branch", non-Stork-stocked).
   * @request POST:/api/partner-admin/locations
   * @secure
   */
  createPartnerAdminLocation = (
    data: CreatePartnerAdminLocationPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CreatePartnerAdminLocationData,
      CreatePartnerAdminLocationError
    >({
      path: `/api/partner-admin/locations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminLocations
   * @name UpdatePartnerAdminLocation
   * @summary Update a partner-admin-owned location (name, description, area, active state).
   * @request PATCH:/api/partner-admin/locations/{id}
   * @secure
   */
  updatePartnerAdminLocation = (
    id: string,
    data: UpdatePartnerAdminLocationPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      UpdatePartnerAdminLocationData,
      UpdatePartnerAdminLocationError
    >({
      path: `/api/partner-admin/locations/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminLocations
   * @name SetPartnerAdminLocationAlias
   * @summary Set or clear the company's display alias for a Stork-managed location.
   * @request PUT:/api/partner-admin/locations/{id}/alias
   * @secure
   */
  setPartnerAdminLocationAlias = (
    id: string,
    data: SetPartnerAdminLocationAliasPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      SetPartnerAdminLocationAliasData,
      SetPartnerAdminLocationAliasError
    >({
      path: `/api/partner-admin/locations/${id}/alias`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags PartnerAdminPortal
 * @name GetPartnerAdminEquipmentRentals
 * @summary Paginated equipment rentals where any of pickup / drop-off / return locations
is in the operating company's footprint. Read-only.
 * @request GET:/api/partner-admin/equipment-rentals
 * @secure
 */
  getPartnerAdminEquipmentRentals = (
    query: GetPartnerAdminEquipmentRentalsParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetPartnerAdminEquipmentRentalsData,
      GetPartnerAdminEquipmentRentalsError
    >({
      path: `/api/partner-admin/equipment-rentals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminPortal
   * @name GetPartnerAdminDashboardSummary
   * @summary Aggregate dashboard numbers (locations breakdown, active rentals, stranded queue).
   * @request GET:/api/partner-admin/dashboard/summary
   * @secure
   */
  getPartnerAdminDashboardSummary = (
    query: GetPartnerAdminDashboardSummaryParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetPartnerAdminDashboardSummaryData,
      GetPartnerAdminDashboardSummaryError
    >({
      path: `/api/partner-admin/dashboard/summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags PartnerAdminPortal
 * @name GetPartnerAdminStrandedRentals
 * @summary Paginated stranded equipment-rentals for the operating company. Stranded =
open EquipmentRental whose drop-off location is non-stocked-by-Stork.
 * @request GET:/api/partner-admin/dashboard/stranded-items
 * @secure
 */
  getPartnerAdminStrandedRentals = (
    query: GetPartnerAdminStrandedRentalsParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetPartnerAdminStrandedRentalsData,
      GetPartnerAdminStrandedRentalsError
    >({
      path: `/api/partner-admin/dashboard/stranded-items`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags PartnerAdminPortal
 * @name GetPartnerAdminStrandedCountsByLocation
 * @summary Per-location open + acknowledged stranded counts for the operating company.
Used by the partner-admin location selector and dashboard widgets.
 * @request GET:/api/partner-admin/dashboard/stranded-items/counts-by-location
 * @secure
 */
  getPartnerAdminStrandedCountsByLocation = (
    query: GetPartnerAdminStrandedCountsByLocationParams,
    params: RequestParams = {},
  ) =>
    this.request<
      GetPartnerAdminStrandedCountsByLocationData,
      GetPartnerAdminStrandedCountsByLocationError
    >({
      path: `/api/partner-admin/dashboard/stranded-items/counts-by-location`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags PartnerAdminPortal
 * @name AcknowledgePartnerAdminStrandedRental
 * @summary Acknowledge a stranded equipment rental. Idempotent (re-acknowledging updates note + timestamp).
Returns 404 if the rental belongs to a different company (cross-company existence
is intentionally hidden as not-found rather than forbidden).
 * @request POST:/api/partner-admin/dashboard/stranded-items/acknowledge
 * @secure
 */
  acknowledgePartnerAdminStrandedRental = (
    query: AcknowledgePartnerAdminStrandedRentalParams,
    data: AcknowledgePartnerAdminStrandedRentalPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AcknowledgePartnerAdminStrandedRentalData,
      AcknowledgePartnerAdminStrandedRentalError
    >({
      path: `/api/partner-admin/dashboard/stranded-items/acknowledge`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminUsers
   * @name GetPartnerAdminUsers
   * @summary Get paginated list of users in the PartnerAdmin's company.
   * @request GET:/api/partner-admin/users
   * @secure
   */
  getPartnerAdminUsers = (
    query: GetPartnerAdminUsersParams,
    params: RequestParams = {},
  ) =>
    this.request<GetPartnerAdminUsersData, any>({
      path: `/api/partner-admin/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminUsers
   * @name CreatePartnerAdminUser
   * @summary Create a new partner user (Partner or PartnerAdmin) within the PartnerAdmin's company.
   * @request POST:/api/partner-admin/users
   * @secure
   */
  createPartnerAdminUser = (
    data: CreatePartnerAdminUserPayload,
    params: RequestParams = {},
  ) =>
    this.request<CreatePartnerAdminUserData, CreatePartnerAdminUserError>({
      path: `/api/partner-admin/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminUsers
   * @name GetPartnerAdminUserDetail
   * @summary Get detailed information about a user in the PartnerAdmin's company.
   * @request GET:/api/partner-admin/users/{id}
   * @secure
   */
  getPartnerAdminUserDetail = (id: string, params: RequestParams = {}) =>
    this.request<GetPartnerAdminUserDetailData, GetPartnerAdminUserDetailError>(
      {
        path: `/api/partner-admin/users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags PartnerAdminUsers
   * @name UpdatePartnerAdminUser
   * @summary Update an existing user within the PartnerAdmin's company.
   * @request PUT:/api/partner-admin/users/{id}
   * @secure
   */
  updatePartnerAdminUser = (
    id: string,
    data: UpdatePartnerAdminUserPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdatePartnerAdminUserData, UpdatePartnerAdminUserError>({
      path: `/api/partner-admin/users/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminUsers
   * @name ResetPartnerAdminUserPassword
   * @summary Reset a user's password. Returns a temporary password that must be changed on next login.
   * @request POST:/api/partner-admin/users/{id}/reset-password
   * @secure
   */
  resetPartnerAdminUserPassword = (id: string, params: RequestParams = {}) =>
    this.request<
      ResetPartnerAdminUserPasswordData,
      ResetPartnerAdminUserPasswordError
    >({
      path: `/api/partner-admin/users/${id}/reset-password`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminUsers
   * @name DeactivatePartnerAdminUser
   * @summary Deactivate a user account in the PartnerAdmin's company.
   * @request PUT:/api/partner-admin/users/{id}/deactivate
   * @secure
   */
  deactivatePartnerAdminUser = (id: string, params: RequestParams = {}) =>
    this.request<
      DeactivatePartnerAdminUserData,
      DeactivatePartnerAdminUserError
    >({
      path: `/api/partner-admin/users/${id}/deactivate`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerAdminUsers
   * @name ActivatePartnerAdminUser
   * @summary Reactivate a previously deactivated user account in the PartnerAdmin's company.
   * @request PUT:/api/partner-admin/users/{id}/activate
   * @secure
   */
  activatePartnerAdminUser = (id: string, params: RequestParams = {}) =>
    this.request<ActivatePartnerAdminUserData, ActivatePartnerAdminUserError>({
      path: `/api/partner-admin/users/${id}/activate`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsList
   * @summary Returns all partner portal content sections, optionally filtered to active ones.
   * @request GET:/api/PartnerContentSections
   * @secure
   */
  partnerContentSectionsList = (
    query: PartnerContentSectionsListParams,
    params: RequestParams = {},
  ) =>
    this.request<PartnerContentSectionsListData, any>({
      path: `/api/PartnerContentSections`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsCreate
   * @summary Creates a new CMS content section for display in the partner portal.
   * @request POST:/api/PartnerContentSections
   * @secure
   */
  partnerContentSectionsCreate = (
    data: PartnerContentSectionsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PartnerContentSectionsCreateData, any>({
      path: `/api/PartnerContentSections`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsDetail
   * @summary Returns a partner portal content section by ID.
   * @request GET:/api/PartnerContentSections/{id}
   * @secure
   */
  partnerContentSectionsDetail = (id: number, params: RequestParams = {}) =>
    this.request<PartnerContentSectionsDetailData, any>({
      path: `/api/PartnerContentSections/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsUpdate
   * @summary Updates the content, title, or display order of a partner portal content section.
   * @request PUT:/api/PartnerContentSections/{id}
   * @secure
   */
  partnerContentSectionsUpdate = (
    id: number,
    data: PartnerContentSectionsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PartnerContentSectionsUpdateData, any>({
      path: `/api/PartnerContentSections/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsDelete
   * @summary Deletes a partner portal content section by ID.
   * @request DELETE:/api/PartnerContentSections/{id}
   * @secure
   */
  partnerContentSectionsDelete = (id: number, params: RequestParams = {}) =>
    this.request<PartnerContentSectionsDeleteData, any>({
      path: `/api/PartnerContentSections/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsKeyDetail
   * @summary Returns a partner portal content section by its unique section key.
   * @request GET:/api/PartnerContentSections/key/{key}
   * @secure
   */
  partnerContentSectionsKeyDetail = (key: string, params: RequestParams = {}) =>
    this.request<PartnerContentSectionsKeyDetailData, any>({
      path: `/api/PartnerContentSections/key/${key}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsImageCreate
   * @summary Uploads an image for a partner portal content section and updates its image URL.
   * @request POST:/api/PartnerContentSections/{id}/image
   * @secure
   */
  partnerContentSectionsImageCreate = (
    id: number,
    data: PartnerContentSectionsImageCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PartnerContentSectionsImageCreateData, any>({
      path: `/api/PartnerContentSections/${id}/image`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerContentSections
   * @name PartnerContentSectionsImageDelete
   * @summary Removes the image from a partner portal content section.
   * @request DELETE:/api/PartnerContentSections/{id}/image
   * @secure
   */
  partnerContentSectionsImageDelete = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.request<PartnerContentSectionsImageDeleteData, any>({
      path: `/api/PartnerContentSections/${id}/image`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerInquiries
   * @name AdminPartnerInquiriesList
   * @summary Returns a paginated list of partner business inquiries with optional status and date filtering.
   * @request GET:/api/admin/partner-inquiries
   * @secure
   */
  adminPartnerInquiriesList = (
    query: AdminPartnerInquiriesListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminPartnerInquiriesListData, any>({
      path: `/api/admin/partner-inquiries`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerInquiries
   * @name AdminPartnerInquiriesDetail
   * @summary Returns a specific partner business inquiry by ID.
   * @request GET:/api/admin/partner-inquiries/{id}
   * @secure
   */
  adminPartnerInquiriesDetail = (id: number, params: RequestParams = {}) =>
    this.request<AdminPartnerInquiriesDetailData, any>({
      path: `/api/admin/partner-inquiries/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerInquiries
   * @name AdminPartnerInquiriesDelete
   * @summary Deletes a partner business inquiry by ID.
   * @request DELETE:/api/admin/partner-inquiries/{id}
   * @secure
   */
  adminPartnerInquiriesDelete = (id: number, params: RequestParams = {}) =>
    this.request<AdminPartnerInquiriesDeleteData, any>({
      path: `/api/admin/partner-inquiries/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerInquiries
   * @name AdminPartnerInquiriesStatusUpdate
   * @summary Updates the review status and internal notes of a partner business inquiry.
   * @request PUT:/api/admin/partner-inquiries/{id}/status
   * @secure
   */
  adminPartnerInquiriesStatusUpdate = (
    id: number,
    data: AdminPartnerInquiriesStatusUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<AdminPartnerInquiriesStatusUpdateData, any>({
      path: `/api/admin/partner-inquiries/${id}/status`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerInquiries
   * @name AdminPartnerInquiriesStatsList
   * @summary Returns inquiry counts grouped by status for admin dashboard reporting.
   * @request GET:/api/admin/partner-inquiries/stats
   * @secure
   */
  adminPartnerInquiriesStatsList = (params: RequestParams = {}) =>
    this.request<AdminPartnerInquiriesStatsListData, any>({
      path: `/api/admin/partner-inquiries/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerInquiry
   * @name PartnerInquiryCreate
   * @summary Submits a B2B partner inquiry from the public-facing partners page.
   * @request POST:/api/PartnerInquiry
   * @secure
   */
  partnerInquiryCreate = (
    data: PartnerInquiryCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PartnerInquiryCreateData, any>({
      path: `/api/PartnerInquiry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerManagement
   * @name GetPartners
   * @summary Get paginated list of partners.
   * @request GET:/api/partners
   * @secure
   */
  getPartners = (query: GetPartnersParams, params: RequestParams = {}) =>
    this.request<GetPartnersData, any>({
      path: `/api/partners`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerManagement
   * @name CreatePartner
   * @summary Create a new partner user.
   * @request POST:/api/partners
   * @secure
   */
  createPartner = (data: CreatePartnerPayload, params: RequestParams = {}) =>
    this.request<CreatePartnerData, CreatePartnerError>({
      path: `/api/partners`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerManagement
   * @name GetPartnerDetail
   * @summary Get detailed partner information including assigned locations.
   * @request GET:/api/partners/{id}
   * @secure
   */
  getPartnerDetail = (id: string, params: RequestParams = {}) =>
    this.request<GetPartnerDetailData, GetPartnerDetailError>({
      path: `/api/partners/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerManagement
   * @name UpdatePartner
   * @summary Update an existing partner user.
   * @request PUT:/api/partners/{id}
   * @secure
   */
  updatePartner = (
    id: string,
    data: UpdatePartnerPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdatePartnerData, UpdatePartnerError>({
      path: `/api/partners/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerManagement
   * @name ResetPartnerPassword
   * @summary Reset a partner's password. Returns a temporary password that must be changed on next login.
   * @request POST:/api/partners/{id}/reset-password
   * @secure
   */
  resetPartnerPassword = (id: string, params: RequestParams = {}) =>
    this.request<ResetPartnerPasswordData, ResetPartnerPasswordError>({
      path: `/api/partners/${id}/reset-password`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerManagement
   * @name DeactivatePartner
   * @summary Deactivate a partner account (prevents login).
   * @request PUT:/api/partners/{id}/deactivate
   * @secure
   */
  deactivatePartner = (id: string, params: RequestParams = {}) =>
    this.request<DeactivatePartnerData, DeactivatePartnerError>({
      path: `/api/partners/${id}/deactivate`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PartnerManagement
   * @name ActivatePartner
   * @summary Reactivate a previously deactivated partner account.
   * @request PUT:/api/partners/{id}/activate
   * @secure
   */
  activatePartner = (id: string, params: RequestParams = {}) =>
    this.request<ActivatePartnerData, ActivatePartnerError>({
      path: `/api/partners/${id}/activate`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
 * @description Frontend usage: ```javascript const { publishableKey } = await fetch('/api/customer/payments/config').then(r => r.json()); const stripe = Stripe(publishableKey); ```
 *
 * @tags Payments
 * @name CustomerPaymentsConfigList
 * @summary Get Stripe configuration for frontend initialization.
Call this first to get the publishable key for Stripe.js.
 * @request GET:/api/customer/payments/config
 * @secure
 */
  customerPaymentsConfigList = (params: RequestParams = {}) =>
    this.request<CustomerPaymentsConfigListData, any>({
      path: `/api/customer/payments/config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * @description Frontend usage with Stripe Elements: ```javascript const { clientSecret } = await fetch('/api/customer/payments/create-intent', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ currency: 'eur' }) }).then(r => r.json()); const { error } = await stripe.confirmPayment({ elements, clientSecret, confirmParams: { return_url: 'https://yoursite.com/checkout/complete' } }); ```
 *
 * @tags Payments
 * @name CustomerPaymentsCreateIntentCreate
 * @summary Create a payment intent for the current cart.
Returns a client secret to confirm payment on the frontend.
 * @request POST:/api/customer/payments/create-intent
 * @secure
 */
  customerPaymentsCreateIntentCreate = (
    data: CustomerPaymentsCreateIntentCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsCreateIntentCreateData,
      CustomerPaymentsCreateIntentCreateError
    >({
      path: `/api/customer/payments/create-intent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Payments
   * @name CustomerPaymentsReconcileCreate
   * @request POST:/api/customer/payments/reconcile
   * @secure
   */
  customerPaymentsReconcileCreate = (
    data: CustomerPaymentsReconcileCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsReconcileCreateData,
      CustomerPaymentsReconcileCreateError
    >({
      path: `/api/customer/payments/reconcile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Payments
   * @name CustomerPaymentsStatusList
   * @request GET:/api/customer/payments/status
   * @secure
   */
  customerPaymentsStatusList = (
    query: CustomerPaymentsStatusListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsStatusListData,
      CustomerPaymentsStatusListError
    >({
      path: `/api/customer/payments/status`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Payments
 * @name CustomerPaymentsCreateIntentCustomCreate
 * @summary Create a payment intent for a specific amount (not cart-based).
Useful for additional charges like damage fees or extensions.
 * @request POST:/api/customer/payments/create-intent/custom
 * @secure
 */
  customerPaymentsCreateIntentCustomCreate = (
    data: CustomerPaymentsCreateIntentCustomCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsCreateIntentCustomCreateData,
      CustomerPaymentsCreateIntentCustomCreateError
    >({
      path: `/api/customer/payments/create-intent/custom`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * @description Frontend usage: ```javascript const { clientSecret } = await fetch('/api/customer/payments/setup-intent', { method: 'POST' }).then(r => r.json()); const { error } = await stripe.confirmSetup({ elements, clientSecret, confirmParams: { return_url: 'https://yoursite.com/account/payment-methods' } }); ```
 *
 * @tags Payments
 * @name CustomerPaymentsSetupIntentCreate
 * @summary Create a setup intent to save a payment method without charging.
Use this for saving cards for future deposit charges or recurring payments.
 * @request POST:/api/customer/payments/setup-intent
 * @secure
 */
  customerPaymentsSetupIntentCreate = (
    data: CustomerPaymentsSetupIntentCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsSetupIntentCreateData,
      CustomerPaymentsSetupIntentCreateError
    >({
      path: `/api/customer/payments/setup-intent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Payments
   * @name CustomerPaymentsPaymentMethodsList
   * @summary Get the customer's saved payment methods.
   * @request GET:/api/customer/payments/payment-methods
   * @secure
   */
  customerPaymentsPaymentMethodsList = (params: RequestParams = {}) =>
    this.request<CustomerPaymentsPaymentMethodsListData, any>({
      path: `/api/customer/payments/payment-methods`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Payments
   * @name CustomerPaymentsPaymentMethodsDefaultCreate
   * @summary Set a payment method as the default for the customer.
   * @request POST:/api/customer/payments/payment-methods/{paymentMethodId}/default
   * @secure
   */
  customerPaymentsPaymentMethodsDefaultCreate = (
    paymentMethodId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsPaymentMethodsDefaultCreateData,
      CustomerPaymentsPaymentMethodsDefaultCreateError
    >({
      path: `/api/customer/payments/payment-methods/${paymentMethodId}/default`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Payments
   * @name CustomerPaymentsPaymentMethodsDelete
   * @summary Remove a saved payment method.
   * @request DELETE:/api/customer/payments/payment-methods/{paymentMethodId}
   * @secure
   */
  customerPaymentsPaymentMethodsDelete = (
    paymentMethodId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsPaymentMethodsDeleteData,
      CustomerPaymentsPaymentMethodsDeleteError
    >({
      path: `/api/customer/payments/payment-methods/${paymentMethodId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
 * @description Frontend usage: 1. First create a setup intent or use a saved payment method 2. Call this endpoint with the booking ID, payment method, and commitment period 3. If RequiresAction is true, use Stripe.js to complete payment ```javascript const response = await fetch('/api/customer/payments/subscriptions', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customerBookingId: 'guid', paymentMethodId: 'pm_xxx', commitmentMonths: 3 }) }).then(r => r.json()); if (response.requiresAction) { const { error } = await stripe.confirmCardPayment(response.clientSecret); } ```
 *
 * @tags Payments
 * @name CustomerPaymentsSubscriptionsCreate
 * @summary Create a subscription for long-term equipment rental.
Use this for 3, 6, or 12-month commitment periods with monthly billing.
 * @request POST:/api/customer/payments/subscriptions
 * @secure
 */
  customerPaymentsSubscriptionsCreate = (
    data: CustomerPaymentsSubscriptionsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsSubscriptionsCreateData,
      CustomerPaymentsSubscriptionsCreateError
    >({
      path: `/api/customer/payments/subscriptions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Payments
 * @name CustomerPaymentsSubscriptionsCancelCreate
 * @summary Cancel a subscription.
If within commitment period, early termination charges may apply.
 * @request POST:/api/customer/payments/subscriptions/{customerBookingId}/cancel
 * @secure
 */
  customerPaymentsSubscriptionsCancelCreate = (
    customerBookingId: string,
    data: CustomerPaymentsSubscriptionsCancelCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsSubscriptionsCancelCreateData,
      CustomerPaymentsSubscriptionsCancelCreateError
    >({
      path: `/api/customer/payments/subscriptions/${customerBookingId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Payments
 * @name CustomerPaymentsSubscriptionsCancellationPreviewList
 * @summary Preview tier fallback penalty for cancelling a subscription.
Shows what charges would apply without actually cancelling.
 * @request GET:/api/customer/payments/subscriptions/{customerBookingId}/cancellation-preview
 * @secure
 */
  customerPaymentsSubscriptionsCancellationPreviewList = (
    customerBookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsSubscriptionsCancellationPreviewListData,
      CustomerPaymentsSubscriptionsCancellationPreviewListError
    >({
      path: `/api/customer/payments/subscriptions/${customerBookingId}/cancellation-preview`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Payments
   * @name CustomerPaymentsSubscriptionsStatusList
   * @summary Get subscription status for a booking.
   * @request GET:/api/customer/payments/subscriptions/{customerBookingId}/status
   * @secure
   */
  customerPaymentsSubscriptionsStatusList = (
    customerBookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsSubscriptionsStatusListData,
      CustomerPaymentsSubscriptionsStatusListError
    >({
      path: `/api/customer/payments/subscriptions/${customerBookingId}/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Payments
   * @name CustomerPaymentsSubscriptionsPaymentMethodUpdate
   * @summary Update payment method for an active subscription.
   * @request PUT:/api/customer/payments/subscriptions/{customerBookingId}/payment-method
   * @secure
   */
  customerPaymentsSubscriptionsPaymentMethodUpdate = (
    customerBookingId: string,
    data: CustomerPaymentsSubscriptionsPaymentMethodUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPaymentsSubscriptionsPaymentMethodUpdateData,
      CustomerPaymentsSubscriptionsPaymentMethodUpdateError
    >({
      path: `/api/customer/payments/subscriptions/${customerBookingId}/payment-method`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pricing
   * @name PricingCalculateItemCreate
   * @summary Calculate tiered price for a single item
   * @request POST:/api/pricing/calculate-item
   * @secure
   */
  pricingCalculateItemCreate = (
    data: PricingCalculateItemCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PricingCalculateItemCreateData, any>({
      path: `/api/pricing/calculate-item`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pricing
   * @name PricingCalculateCartCreate
   * @summary Calculate price for the entire cart
   * @request POST:/api/pricing/calculate-cart
   * @secure
   */
  pricingCalculateCartCreate = (
    data: PricingCalculateCartCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PricingCalculateCartCreateData, any>({
      path: `/api/pricing/calculate-cart`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pricing
   * @name PricingBreakdownCreate
   * @summary Get pricing breakdown for an item using tiered pricing
   * @request POST:/api/pricing/breakdown
   * @secure
   */
  pricingBreakdownCreate = (
    data: PricingBreakdownCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PricingBreakdownCreateData, any>({
      path: `/api/pricing/breakdown`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PublicPartners
   * @name PublicPartnersList
   * @summary Get all partner page data in a single request
   * @request GET:/api/public/partners
   * @secure
   */
  publicPartnersList = (params: RequestParams = {}) =>
    this.request<PublicPartnersListData, any>({
      path: `/api/public/partners`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PublicPartners
   * @name PublicPartnersSectionsList
   * @summary Get content sections only
   * @request GET:/api/public/partners/sections
   * @secure
   */
  publicPartnersSectionsList = (params: RequestParams = {}) =>
    this.request<PublicPartnersSectionsListData, any>({
      path: `/api/public/partners/sections`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PublicPartners
   * @name PublicPartnersSectionsDetail
   * @summary Get a specific content section by key
   * @request GET:/api/public/partners/sections/{key}
   * @secure
   */
  publicPartnersSectionsDetail = (key: string, params: RequestParams = {}) =>
    this.request<PublicPartnersSectionsDetailData, any>({
      path: `/api/public/partners/sections/${key}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PublicPartners
   * @name PublicPartnersCategoriesList
   * @summary Get all categories with their partners
   * @request GET:/api/public/partners/categories
   * @secure
   */
  publicPartnersCategoriesList = (params: RequestParams = {}) =>
    this.request<PublicPartnersCategoriesListData, any>({
      path: `/api/public/partners/categories`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PublicPartners
   * @name PublicPartnersInquiriesCreate
   * @summary Submit a partner inquiry
   * @request POST:/api/public/partners/inquiries
   * @secure
   */
  publicPartnersInquiriesCreate = (
    data: PublicPartnersInquiriesCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PublicPartnersInquiriesCreateData, any>({
      path: `/api/public/partners/inquiries`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name CustomerPurchaseQuotesRequestCreate
   * @summary Customer requests a quote to purchase the item they're currently renting.
   * @request POST:/api/customer/purchase-quotes/request
   * @secure
   */
  customerPurchaseQuotesRequestCreate = (
    data: CustomerPurchaseQuotesRequestCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPurchaseQuotesRequestCreateData,
      CustomerPurchaseQuotesRequestCreateError
    >({
      path: `/api/customer/purchase-quotes/request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name CustomerPurchaseQuotesBookingDetail
   * @summary Get purchase quote for a specific booking (customer view).
   * @request GET:/api/customer/purchase-quotes/booking/{bookingId}
   * @secure
   */
  customerPurchaseQuotesBookingDetail = (
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      CustomerPurchaseQuotesBookingDetailData,
      CustomerPurchaseQuotesBookingDetailError
    >({
      path: `/api/customer/purchase-quotes/booking/${bookingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name AdminPurchaseQuotesList
   * @summary Get all purchase quotes with optional filters (admin only).
   * @request GET:/api/admin/purchase-quotes
   * @secure
   */
  adminPurchaseQuotesList = (
    query: AdminPurchaseQuotesListParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminPurchaseQuotesListData, any>({
      path: `/api/admin/purchase-quotes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name AdminPurchaseQuotesDetail
   * @summary Get a specific purchase quote by ID (admin only).
   * @request GET:/api/admin/purchase-quotes/{quoteId}
   * @secure
   */
  adminPurchaseQuotesDetail = (quoteId: string, params: RequestParams = {}) =>
    this.request<AdminPurchaseQuotesDetailData, AdminPurchaseQuotesDetailError>(
      {
        path: `/api/admin/purchase-quotes/${quoteId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name AdminPurchaseQuotesReviewCreate
   * @summary Admin reviews a quote request and sets the purchase price.
   * @request POST:/api/admin/purchase-quotes/{quoteId}/review
   * @secure
   */
  adminPurchaseQuotesReviewCreate = (
    quoteId: string,
    data: AdminPurchaseQuotesReviewCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminPurchaseQuotesReviewCreateData,
      AdminPurchaseQuotesReviewCreateError
    >({
      path: `/api/admin/purchase-quotes/${quoteId}/review`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name AdminPurchaseQuotesSendCreate
   * @summary Admin sends the quote to the customer (sets 7-day expiry).
   * @request POST:/api/admin/purchase-quotes/{quoteId}/send
   * @secure
   */
  adminPurchaseQuotesSendCreate = (
    quoteId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminPurchaseQuotesSendCreateData,
      AdminPurchaseQuotesSendCreateError
    >({
      path: `/api/admin/purchase-quotes/${quoteId}/send`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name AdminPurchaseQuotesDeclineCreate
   * @summary Admin declines a purchase quote request.
   * @request POST:/api/admin/purchase-quotes/{quoteId}/decline
   * @secure
   */
  adminPurchaseQuotesDeclineCreate = (
    quoteId: string,
    data: AdminPurchaseQuotesDeclineCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminPurchaseQuotesDeclineCreateData,
      AdminPurchaseQuotesDeclineCreateError
    >({
      path: `/api/admin/purchase-quotes/${quoteId}/decline`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name AdminPurchaseQuotesExpireOverdueCreate
   * @summary CRON endpoint: Expire purchase quotes older than 7 days.
   * @request POST:/api/admin/purchase-quotes/expire-overdue
   * @secure
   */
  adminPurchaseQuotesExpireOverdueCreate = (params: RequestParams = {}) =>
    this.request<AdminPurchaseQuotesExpireOverdueCreateData, any>({
      path: `/api/admin/purchase-quotes/expire-overdue`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PurchaseQuotes
   * @name AdminPurchaseQuotesProcessPurchaseCreate
   * @summary Process purchase after payment is confirmed (called by payment webhook).
   * @request POST:/api/admin/purchase-quotes/process-purchase
   * @secure
   */
  adminPurchaseQuotesProcessPurchaseCreate = (
    data: AdminPurchaseQuotesProcessPurchaseCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminPurchaseQuotesProcessPurchaseCreateData,
      AdminPurchaseQuotesProcessPurchaseCreateError
    >({
      path: `/api/admin/purchase-quotes/process-purchase`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags PushSubscriptions
 * @name PushSubscriptionsUpdate
 * @summary Register (or refresh) this browser's push subscription for the current user.
Upserts by endpoint — a shared device is reassigned to the latest user.
 * @request PUT:/api/push-subscriptions
 * @secure
 */
  pushSubscriptionsUpdate = (
    data: PushSubscriptionsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<PushSubscriptionsUpdateData, PushSubscriptionsUpdateError>({
      path: `/api/push-subscriptions`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PushSubscriptions
   * @name PushSubscriptionsDelete
   * @summary Remove this browser's push subscription (per-device opt-out).
   * @request DELETE:/api/push-subscriptions
   * @secure
   */
  pushSubscriptionsDelete = (
    query: PushSubscriptionsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<PushSubscriptionsDeleteData, PushSubscriptionsDeleteError>({
      path: `/api/push-subscriptions`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags PushSubscriptions
 * @name PushSubscriptionsVapidPublicKeyList
 * @summary The VAPID public key browsers subscribe with.
204 when push is not configured in this environment.
 * @request GET:/api/push-subscriptions/vapid-public-key
 * @secure
 */
  pushSubscriptionsVapidPublicKeyList = (params: RequestParams = {}) =>
    this.request<PushSubscriptionsVapidPublicKeyListData, any>({
      path: `/api/push-subscriptions/vapid-public-key`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name CreateRental
   * @summary Creates a new rental location with name, area assignment, equipment types, associated companies, and timezone configuration (Admin, Manager roles only).
   * @request POST:/api/rentals
   * @secure
   */
  createRental = (data: CreateRentalPayload, params: RequestParams = {}) =>
    this.request<CreateRentalData, any>({
      path: `/api/rentals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRentals
   * @summary Returns a paginated list of rental locations accessible to the current user based on their role and area/location assignments.
   * @request GET:/api/rentals
   * @secure
   */
  getRentals = (query: GetRentalsParams, params: RequestParams = {}) =>
    this.request<GetRentalsData, any>({
      path: `/api/rentals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name UpdateRental
   * @summary Updates a rental location's name, description, equipment types, associated companies, sublocation links, or timezone (Admin, Manager roles only); returns no content.
   * @request PUT:/api/rentals/{Id}
   * @secure
   */
  updateRental = (
    id: string,
    data: UpdateRentalPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateRentalData, any>({
      path: `/api/rentals/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRentalById
   * @summary Returns the full details of a single rental location by ID, including equipment types, associated companies, and sublocation configuration.
   * @request GET:/api/rentals/{Id}
   * @secure
   */
  getRentalById = (id: string, params: RequestParams = {}) =>
    this.request<GetRentalByIdData, any>({
      path: `/api/rentals/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetAccessibleRentals
   * @summary Returns all rental locations accessible to the current user.
   * @request GET:/api/rentals/accessibleRentals
   * @secure
   */
  getAccessibleRentals = (params: RequestParams = {}) =>
    this.request<GetAccessibleRentalsData, any>({
      path: `/api/rentals/accessibleRentals`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetParentLocations
   * @summary Returns all top-level (parent) rental locations accessible to the current admin or area manager, used for hierarchical location management.
   * @request GET:/api/rentals/ParentLocations
   * @secure
   */
  getParentLocations = (params: RequestParams = {}) =>
    this.request<GetParentLocationsData, any>({
      path: `/api/rentals/ParentLocations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name SingleAndSublocations
   * @summary Returns standalone locations and their sublocations accessible to the current admin or area manager, optionally scoped to a specific parent rental (Admin, AreaManager only).
   * @request GET:/api/rentals/SingleAndSublocations
   * @secure
   */
  singleAndSublocations = (
    query: SingleAndSublocationsParams,
    params: RequestParams = {},
  ) =>
    this.request<SingleAndSublocationsData, any>({
      path: `/api/rentals/SingleAndSublocations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRelatedLocations
   * @summary Returns all related (sibling and child) locations for a given rental, used by staff to find alternative pickup/return points in the same area.
   * @request GET:/api/rentals/{Id}/relatedLocations
   * @secure
   */
  getRelatedLocations = (id: string, params: RequestParams = {}) =>
    this.request<GetRelatedLocationsData, any>({
      path: `/api/rentals/${id}/relatedLocations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRentalEquipment
   * @summary Returns a paginated list of physical equipment items stored at the given rental location, with optional serial number reference filter.
   * @request GET:/api/rentals/{Id}/equipment
   * @secure
   */
  getRentalEquipment = (
    { id, ...query }: GetRentalEquipmentParams,
    params: RequestParams = {},
  ) =>
    this.request<GetRentalEquipmentData, any>({
      path: `/api/rentals/${id}/equipment`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRentalEquipmentTypes
   * @summary Returns the equipment types configured for a rental location, including default pricing per type (Admin, Manager roles only).
   * @request GET:/api/rentals/{Id}/equipment-types
   * @secure
   */
  getRentalEquipmentTypes = (id: string, params: RequestParams = {}) =>
    this.request<GetRentalEquipmentTypesData, any>({
      path: `/api/rentals/${id}/equipment-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name CreateRentalEquipmentType
   * @summary Adds an equipment type to a rental location's configuration, enabling that type to be stocked and rented from this location (Admin, Manager roles only).
   * @request POST:/api/rentals/{Id}/equipment-types
   * @secure
   */
  createRentalEquipmentType = (
    id: string,
    data: CreateRentalEquipmentTypePayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateRentalEquipmentTypeData, any>({
      path: `/api/rentals/${id}/equipment-types`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name UpdateRentalEquipmentType
   * @summary Updates the equipment type configuration for a rental location (e.g., changes the assigned type); returns the updated configuration (Admin, Manager roles only).
   * @request PUT:/api/rentals/{Id}/equipment-types
   * @secure
   */
  updateRentalEquipmentType = (
    id: string,
    data: UpdateRentalEquipmentTypePayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateRentalEquipmentTypeData, any>({
      path: `/api/rentals/${id}/equipment-types`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name RentalsEquipmentTypesStockDetail
   * @summary Returns day-by-day availability counts for a specific equipment type at a rental location between the given start and end dates, used for stock availability checks.
   * @request GET:/api/rentals/{Id}/equipment-types-stock/{TypeId}
   * @secure
   */
  rentalsEquipmentTypesStockDetail = (
    { id, typeId, ...query }: RentalsEquipmentTypesStockDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      RentalsEquipmentTypesStockDetailData,
      RentalsEquipmentTypesStockDetailError
    >({
      path: `/api/rentals/${id}/equipment-types-stock/${typeId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRentalBookings
   * @summary Returns a paginated list of bookings for a rental location filtered by status (e.g., "active", "returned", "pending") and optional date range.
   * @request GET:/api/rentals/{Id}/bookings/{status}
   * @secure
   */
  getRentalBookings = (
    { id, status, ...query }: GetRentalBookingsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetRentalBookingsData, any>({
      path: `/api/rentals/${id}/bookings/${status}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRentalBookingStats
   * @summary Returns booking statistics for a rental location: today's pickups/returns, last 7 days, and last 30 days with overdue counts.
   * @request GET:/api/rentals/{Id}/bookings/stats
   * @secure
   */
  getRentalBookingStats = (id: string, params: RequestParams = {}) =>
    this.request<GetRentalBookingStatsData, any>({
      path: `/api/rentals/${id}/bookings/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Rentals
   * @name GetRentalsByName
   * @summary Searches rental locations by name and returns matching results as a lightweight list, useful for autocomplete and search UI components.
   * @request GET:/api/rentals/name/{name}
   * @secure
   */
  getRentalsByName = (name: string, params: RequestParams = {}) =>
    this.request<GetRentalsByNameData, any>({
      path: `/api/rentals/name/${name}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsRentalsEquipmentTypesList
   * @summary Returns a JSON report of rental bookings grouped by equipment type for a specified month and optional location, used for occupancy and revenue analysis.
   * @request GET:/api/reports/rentals-equipment-types
   * @secure
   */
  reportsRentalsEquipmentTypesList = (
    query: ReportsRentalsEquipmentTypesListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsRentalsEquipmentTypesListData, any>({
      path: `/api/reports/rentals-equipment-types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsRentalsEquipmentTypesExcelList
   * @summary Returns an Excel file of rental bookings grouped by equipment type for a specified month and optional location.
   * @request GET:/api/reports/rentals-equipment-types/excel
   * @secure
   */
  reportsRentalsEquipmentTypesExcelList = (
    query: ReportsRentalsEquipmentTypesExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsRentalsEquipmentTypesExcelListData, any>({
      path: `/api/reports/rentals-equipment-types/excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsRentalItemsNotReturnedExcelList
   * @summary Returns an Excel file listing all equipment items currently in active rentals or bookings that have not yet been returned, optionally filtered by location.
   * @request GET:/api/reports/rental-items-not-returned/excel
   * @secure
   */
  reportsRentalItemsNotReturnedExcelList = (
    query: ReportsRentalItemsNotReturnedExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsRentalItemsNotReturnedExcelListData, any>({
      path: `/api/reports/rental-items-not-returned/excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsUnseenRentalItemsExcelList
   * @summary Returns an Excel file of equipment items not scanned or seen recently (unseen) at their expected location, optionally filtered by location and month.
   * @request GET:/api/reports/unseen-rental-items/excel
   * @secure
   */
  reportsUnseenRentalItemsExcelList = (
    query: ReportsUnseenRentalItemsExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsUnseenRentalItemsExcelListData, any>({
      path: `/api/reports/unseen-rental-items/excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsEquipmentDemandForecastExcelList
   * @summary Returns an Excel file forecasting equipment demand by type by month for a given year, optionally filtered by location.
   * @request GET:/api/reports/equipment-demand-forecast/excel
   * @secure
   */
  reportsEquipmentDemandForecastExcelList = (
    query: ReportsEquipmentDemandForecastExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsEquipmentDemandForecastExcelListData, any>({
      path: `/api/reports/equipment-demand-forecast/excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsBookingActivityExcelList
   * @summary Returns an Excel file of all booking activity (pickups, returns, creation) within a date range, optionally filtered by location.
   * @request GET:/api/reports/booking-activity/excel
   * @secure
   */
  reportsBookingActivityExcelList = (
    query: ReportsBookingActivityExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsBookingActivityExcelListData, any>({
      path: `/api/reports/booking-activity/excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsUnpickedRequestsExcelList
   * @summary Returns an Excel file of booking requests that were not converted to active bookings ("unpicked") for a given month, optionally filtered by location.
   * @request GET:/api/reports/unpicked-requests/excel
   * @secure
   */
  reportsUnpickedRequestsExcelList = (
    query: ReportsUnpickedRequestsExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsUnpickedRequestsExcelListData, any>({
      path: `/api/reports/unpicked-requests/excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsCompanyCurrentRentalItemsExcelList
   * @summary Returns an Excel file listing all equipment items currently rented/on loan for a specific company, optionally filtered by location.
   * @request GET:/api/reports/company-current-rental-items/excel
   * @secure
   */
  reportsCompanyCurrentRentalItemsExcelList = (
    query: ReportsCompanyCurrentRentalItemsExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsCompanyCurrentRentalItemsExcelListData, any>({
      path: `/api/reports/company-current-rental-items/excel`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsCompanyRentalItemsExcelList
   * @summary Returns an Excel file of all historical rental items for a company within an optional date range, filterable by location.
   * @request GET:/api/reports/company-rental-items/excel
   * @secure
   */
  reportsCompanyRentalItemsExcelList = (
    query: ReportsCompanyRentalItemsExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsCompanyRentalItemsExcelListData, any>({
      path: `/api/reports/company-rental-items/excel`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsCompanyBookingsExcelList
   * @summary Returns an Excel file of all bookings for a company within an optional date range, filterable by location, showing booking details and status.
   * @request GET:/api/reports/company-bookings/excel
   * @secure
   */
  reportsCompanyBookingsExcelList = (
    query: ReportsCompanyBookingsExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<ReportsCompanyBookingsExcelListData, any>({
      path: `/api/reports/company-bookings/excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationSettlements
   * @name GetReservationSettlement
   * @request GET:/api/booking-requests/{requestId}/settlement
   * @secure
   */
  getReservationSettlement = (requestId: string, params: RequestParams = {}) =>
    this.request<GetReservationSettlementData, any>({
      path: `/api/booking-requests/${requestId}/settlement`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationSettlements
   * @name SaveReservationSettlement
   * @request POST:/api/booking-requests/{requestId}/settlement
   * @secure
   */
  saveReservationSettlement = (
    requestId: string,
    data: SaveReservationSettlementPayload,
    params: RequestParams = {},
  ) =>
    this.request<SaveReservationSettlementData, any>({
      path: `/api/booking-requests/${requestId}/settlement`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationSettlements
   * @name QuoteReservationSettlement
   * @request POST:/api/booking-requests/{requestId}/settlement/quote
   * @secure
   */
  quoteReservationSettlement = (
    requestId: string,
    data: QuoteReservationSettlementPayload,
    params: RequestParams = {},
  ) =>
    this.request<QuoteReservationSettlementData, any>({
      path: `/api/booking-requests/${requestId}/settlement/quote`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationSettlements
   * @name CancelReservationSettlement
   * @request POST:/api/booking-requests/{requestId}/settlement/cancel
   * @secure
   */
  cancelReservationSettlement = (
    requestId: string,
    params: RequestParams = {},
  ) =>
    this.request<CancelReservationSettlementData, any>({
      path: `/api/booking-requests/${requestId}/settlement/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationSettlements
   * @name RefreshReservationSettlement
   * @request POST:/api/booking-requests/{requestId}/settlement/refresh
   * @secure
   */
  refreshReservationSettlement = (
    requestId: string,
    params: RequestParams = {},
  ) =>
    this.request<RefreshReservationSettlementData, any>({
      path: `/api/booking-requests/${requestId}/settlement/refresh`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationSettlements
   * @name ResendReservationSettlement
   * @request POST:/api/booking-requests/{requestId}/settlement/reminder
   * @secure
   */
  resendReservationSettlement = (
    requestId: string,
    data: ResendReservationSettlementPayload,
    params: RequestParams = {},
  ) =>
    this.request<ResendReservationSettlementData, any>({
      path: `/api/booking-requests/${requestId}/settlement/reminder`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationShortages
   * @name GetReservationShortages
   * @request GET:/api/reservation-shortages
   * @secure
   */
  getReservationShortages = (params: RequestParams = {}) =>
    this.request<GetReservationShortagesData, any>({
      path: `/api/reservation-shortages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReservationShortages
   * @name GetReservationShortageForecast
   * @request GET:/api/reservation-shortages/forecast
   * @secure
   */
  getReservationShortageForecast = (
    query: GetReservationShortageForecastParams,
    params: RequestParams = {},
  ) =>
    this.request<GetReservationShortageForecastData, any>({
      path: `/api/reservation-shortages/forecast`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Roles
   * @name GetRoles
   * @summary Returns all available system roles for user assignment.
   * @request GET:/api/roles/roles
   * @secure
   */
  getRoles = (params: RequestParams = {}) =>
    this.request<GetRolesData, any>({
      path: `/api/roles/roles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RunningList
   * @name GetRunningList
   * @summary Returns the next upcoming bookings due for pickup or return for the current user's accessible locations, filterable by date or location.
   * @request GET:/api/running-list/getNext
   * @secure
   */
  getRunningList = (query: GetRunningListParams, params: RequestParams = {}) =>
    this.request<GetRunningListData, any>({
      path: `/api/running-list/getNext`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SavedBlocks
   * @name SavedBlocksList
   * @request GET:/api/saved-blocks
   * @secure
   */
  savedBlocksList = (
    query: SavedBlocksListParams,
    params: RequestParams = {},
  ) =>
    this.request<SavedBlocksListData, any>({
      path: `/api/saved-blocks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SavedBlocks
   * @name SavedBlocksCreate
   * @request POST:/api/saved-blocks
   * @secure
   */
  savedBlocksCreate = (
    data: SavedBlocksCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<SavedBlocksCreateData, SavedBlocksCreateError>({
      path: `/api/saved-blocks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SavedBlocks
   * @name SavedBlocksDetail
   * @request GET:/api/saved-blocks/{id}
   * @secure
   */
  savedBlocksDetail = (id: string, params: RequestParams = {}) =>
    this.request<SavedBlocksDetailData, SavedBlocksDetailError>({
      path: `/api/saved-blocks/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SavedBlocks
   * @name SavedBlocksUpdate
   * @request PUT:/api/saved-blocks/{id}
   * @secure
   */
  savedBlocksUpdate = (
    id: string,
    data: SavedBlocksUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<SavedBlocksUpdateData, SavedBlocksUpdateError>({
      path: `/api/saved-blocks/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SavedBlocks
   * @name SavedBlocksDelete
   * @request DELETE:/api/saved-blocks/{id}
   * @secure
   */
  savedBlocksDelete = (id: string, params: RequestParams = {}) =>
    this.request<SavedBlocksDeleteData, SavedBlocksDeleteError>({
      path: `/api/saved-blocks/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Scanner
   * @name Scan
   * @summary Scans an equipment serial number and returns full context including active booking, rental, and status; optionally updates LastHandledAt with a context string.
   * @request GET:/api/scanner/scan/{SerialNumber}
   * @secure
   */
  scan = ({ serialNumber, ...query }: ScanParams, params: RequestParams = {}) =>
    this.request<ScanData, any>({
      path: `/api/scanner/scan/${serialNumber}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsCreate
   * @summary Create a new shift. Requires manager permissions.
   * @request POST:/api/shifts
   * @secure
   */
  shiftsCreate = (data: ShiftsCreatePayload, params: RequestParams = {}) =>
    this.request<ShiftsCreateData, ShiftsCreateError>({
      path: `/api/shifts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsDetail
   * @summary Get a specific shift by ID.
   * @request GET:/api/shifts/{id}
   * @secure
   */
  shiftsDetail = (id: string, params: RequestParams = {}) =>
    this.request<ShiftsDetailData, ShiftsDetailError>({
      path: `/api/shifts/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsUpdate
   * @summary Update an existing shift. Requires manager permissions. Cannot update shifts that have already started.
   * @request PUT:/api/shifts/{id}
   * @secure
   */
  shiftsUpdate = (
    id: string,
    data: ShiftsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ShiftsUpdateData, ShiftsUpdateError>({
      path: `/api/shifts/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsDelete
   * @summary Delete a shift. Requires manager permissions. Cannot delete shifts that have already started.
   * @request DELETE:/api/shifts/{id}
   * @secure
   */
  shiftsDelete = (id: string, params: RequestParams = {}) =>
    this.request<ShiftsDeleteData, ShiftsDeleteError>({
      path: `/api/shifts/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsTeamDetail
   * @summary Get shifts for a specific team. Requires manager permissions.
   * @request GET:/api/shifts/team/{teamId}
   * @secure
   */
  shiftsTeamDetail = (
    { teamId, ...query }: ShiftsTeamDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<ShiftsTeamDetailData, any>({
      path: `/api/shifts/team/${teamId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsAllList
   * @summary Get shifts across all teams. Available to Admin and HR users.
   * @request GET:/api/shifts/all
   * @secure
   */
  shiftsAllList = (query: ShiftsAllListParams, params: RequestParams = {}) =>
    this.request<ShiftsAllListData, any>({
      path: `/api/shifts/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsMyList
   * @summary Get shifts for the current user.
   * @request GET:/api/shifts/my
   * @secure
   */
  shiftsMyList = (query: ShiftsMyListParams, params: RequestParams = {}) =>
    this.request<ShiftsMyListData, any>({
      path: `/api/shifts/my`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Shifts
 * @name ShiftsMyCreate
 * @summary Create a shift for yourself. Employees can schedule their own working hours.
Cannot create shifts in the past or overlapping with existing shifts.
 * @request POST:/api/shifts/my
 * @secure
 */
  shiftsMyCreate = (data: ShiftsMyCreatePayload, params: RequestParams = {}) =>
    this.request<ShiftsMyCreateData, ShiftsMyCreateError>({
      path: `/api/shifts/my`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Shifts
 * @name ShiftsMyTeamsList
 * @summary Get shifts for all teams the current user is assigned to.
Strictly membership-scoped for all callers, including Admin/HR — this is
the personal "my-teams" surface. Admin/HR management uses /api/shifts/all.
 * @request GET:/api/shifts/my-teams
 * @secure
 */
  shiftsMyTeamsList = (
    query: ShiftsMyTeamsListParams,
    params: RequestParams = {},
  ) =>
    this.request<ShiftsMyTeamsListData, any>({
      path: `/api/shifts/my-teams`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsLinkCreate
   * @summary Link a time entry to a shift. Requires manager permissions.
   * @request POST:/api/shifts/link
   * @secure
   */
  shiftsLinkCreate = (
    data: ShiftsLinkCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ShiftsLinkCreateData, ShiftsLinkCreateError>({
      path: `/api/shifts/link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags Shifts
 * @name ShiftsBulkCreate
 * @summary Bulk create multiple shifts. Validates each shift individually and returns per-shift results.
Shifts that fail validation are skipped, and successfully validated shifts are created in a batch.
 * @request POST:/api/shifts/bulk
 * @secure
 */
  shiftsBulkCreate = (
    data: ShiftsBulkCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ShiftsBulkCreateData, ShiftsBulkCreateError>({
      path: `/api/shifts/bulk`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Shifts
 * @name ShiftsCopyMonthCreate
 * @summary Copy an entire month's schedule (shifts and optionally day-offs) from a source month to a target month.
Preserves day-of-week alignment: a Monday shift in the source becomes a Monday shift in the target.
 * @request POST:/api/shifts/copy-month
 * @secure
 */
  shiftsCopyMonthCreate = (
    data: ShiftsCopyMonthCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ShiftsCopyMonthCreateData, ShiftsCopyMonthCreateError>({
      path: `/api/shifts/copy-month`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Shifts
   * @name ShiftsCopyWeekForwardCreate
   * @summary Copy one source week forward into the following weeks, optionally overwriting existing scheduled shifts and day-offs.
   * @request POST:/api/shifts/copy-week-forward
   * @secure
   */
  shiftsCopyWeekForwardCreate = (
    data: ShiftsCopyWeekForwardCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      ShiftsCopyWeekForwardCreateData,
      ShiftsCopyWeekForwardCreateError
    >({
      path: `/api/shifts/copy-week-forward`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Shifts
 * @name ShiftsMyUpdate
 * @summary Update your own shift. Can only update self-created shifts (not manager-assigned).
Cannot update shifts that have already started or completed.
 * @request PUT:/api/shifts/my/{id}
 * @secure
 */
  shiftsMyUpdate = (
    id: string,
    data: ShiftsMyUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<ShiftsMyUpdateData, ShiftsMyUpdateError>({
      path: `/api/shifts/my/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Shifts
 * @name ShiftsMyDelete
 * @summary Delete your own shift. Can only delete self-created shifts (not manager-assigned).
Cannot delete shifts that have already started or completed.
 * @request DELETE:/api/shifts/my/{id}
 * @secure
 */
  shiftsMyDelete = (id: string, params: RequestParams = {}) =>
    this.request<ShiftsMyDeleteData, ShiftsMyDeleteError>({
      path: `/api/shifts/my/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags SocialMediaAccounts
 * @name SocialMediaAccountsActiveList
 * @summary Public endpoint: Get active social media accounts, ordered by SortOrder.
Used by the customer-facing website footer.
 * @request GET:/api/social-media-accounts/active
 * @secure
 */
  socialMediaAccountsActiveList = (params: RequestParams = {}) =>
    this.request<SocialMediaAccountsActiveListData, any>({
      path: `/api/social-media-accounts/active`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaAccounts
   * @name SocialMediaAccountsList
   * @summary Admin: Get all social media accounts.
   * @request GET:/api/social-media-accounts
   * @secure
   */
  socialMediaAccountsList = (params: RequestParams = {}) =>
    this.request<SocialMediaAccountsListData, any>({
      path: `/api/social-media-accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaAccounts
   * @name SocialMediaAccountsCreate
   * @summary Admin: Create a new social media account.
   * @request POST:/api/social-media-accounts
   * @secure
   */
  socialMediaAccountsCreate = (
    data: SocialMediaAccountsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<SocialMediaAccountsCreateData, any>({
      path: `/api/social-media-accounts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaAccounts
   * @name SocialMediaAccountsDetail
   * @summary Admin: Get a single social media account by ID.
   * @request GET:/api/social-media-accounts/{id}
   * @secure
   */
  socialMediaAccountsDetail = (id: string, params: RequestParams = {}) =>
    this.request<SocialMediaAccountsDetailData, any>({
      path: `/api/social-media-accounts/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaAccounts
   * @name SocialMediaAccountsUpdate
   * @summary Admin: Update an existing social media account.
   * @request PUT:/api/social-media-accounts/{id}
   * @secure
   */
  socialMediaAccountsUpdate = (
    id: string,
    data: SocialMediaAccountsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<SocialMediaAccountsUpdateData, any>({
      path: `/api/social-media-accounts/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaAccounts
   * @name SocialMediaAccountsDelete
   * @summary Admin: Delete a social media account.
   * @request DELETE:/api/social-media-accounts/{id}
   * @secure
   */
  socialMediaAccountsDelete = (id: string, params: RequestParams = {}) =>
    this.request<SocialMediaAccountsDeleteData, any>({
      path: `/api/social-media-accounts/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags Staff
 * @name StaffAppVersionList
 * @summary Get the latest Staff app version information.
Called by Dorat.App.Staff on launch / foreground to check for updates.
No auth required — works before login and after expired tokens.
 * @request GET:/api/staff/app-version
 * @secure
 */
  staffAppVersionList = (
    query: StaffAppVersionListParams,
    params: RequestParams = {},
  ) =>
    this.request<StaffAppVersionListData, any>({
      path: `/api/staff/app-version`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Staff
 * @name StaffAppReleasesDownloadList
 * @summary Downloads a Staff app release file (APK) by proxying it from S3.
Streaming through the API keeps S3 private (no presigned URLs are
exposed) and serves the download from our own domain. Content-Length
is set explicitly so browsers can show the file size and a download ETA.
No auth required so the in-app updater can fetch the file without
re-authenticating mid-flow.
 * @request GET:/api/staff/app-releases/{id}/download
 * @secure
 */
  staffAppReleasesDownloadList = (id: string, params: RequestParams = {}) =>
    this.request<
      StaffAppReleasesDownloadListData,
      StaffAppReleasesDownloadListError
    >({
      path: `/api/staff/app-releases/${id}/download`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags Staff
 * @name StaffUpdateLogCreate
 * @summary Log an in-app update lifecycle event from the Staff app so update
failures (which the user has no log access for) can be diagnosed
server-side. No auth required — callable before login and after token
expiry during an update.
 * @request POST:/api/staff/update-log
 * @secure
 */
  staffUpdateLogCreate = (
    data: StaffUpdateLogCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<StaffUpdateLogCreateData, StaffUpdateLogCreateError>({
      path: `/api/staff/update-log`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags StaffAppReleases
   * @name CicdStaffAppReleasesVersionInfoList
   * @request GET:/api/cicd/staff-app-releases/version-info
   * @secure
   */
  cicdStaffAppReleasesVersionInfoList = (
    query: CicdStaffAppReleasesVersionInfoListParams,
    params: RequestParams = {},
  ) =>
    this.request<CicdStaffAppReleasesVersionInfoListData, any>({
      path: `/api/cicd/staff-app-releases/version-info`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StaffAppReleases
   * @name CicdStaffAppReleasesUploadCreate
   * @request POST:/api/cicd/staff-app-releases/upload
   * @secure
   */
  cicdStaffAppReleasesUploadCreate = (
    data: CicdStaffAppReleasesUploadCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      CicdStaffAppReleasesUploadCreateData,
      CicdStaffAppReleasesUploadCreateError
    >({
      path: `/api/cicd/staff-app-releases/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StaffAppReleases
   * @name CicdStaffAppReleasesExistsDetail
   * @request GET:/api/cicd/staff-app-releases/exists/{version}
   * @secure
   */
  cicdStaffAppReleasesExistsDetail = (
    { version, ...query }: CicdStaffAppReleasesExistsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<CicdStaffAppReleasesExistsDetailData, any>({
      path: `/api/cicd/staff-app-releases/exists/${version}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StrandedRentals
   * @name GetAdminStrandedRentals
   * @request GET:/api/admin/stranded-items
   * @secure
   */
  getAdminStrandedRentals = (
    query: GetAdminStrandedRentalsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetAdminStrandedRentalsData, any>({
      path: `/api/admin/stranded-items`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StrandedRentals
   * @name GetAdminStrandedCountsByLocation
   * @request GET:/api/admin/stranded-items/counts-by-location
   * @secure
   */
  getAdminStrandedCountsByLocation = (
    query: GetAdminStrandedCountsByLocationParams,
    params: RequestParams = {},
  ) =>
    this.request<GetAdminStrandedCountsByLocationData, any>({
      path: `/api/admin/stranded-items/counts-by-location`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StrandedRentals
   * @name AcknowledgeAdminStrandedRental
   * @request POST:/api/admin/stranded-items/acknowledge
   * @secure
   */
  acknowledgeAdminStrandedRental = (
    query: AcknowledgeAdminStrandedRentalParams,
    data: AcknowledgeAdminStrandedRentalPayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AcknowledgeAdminStrandedRentalData,
      AcknowledgeAdminStrandedRentalError
    >({
      path: `/api/admin/stranded-items/acknowledge`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * @description Handled event categories: **Payment Events:** - payment_intent.succeeded: Payment completed successfully - payment_intent.payment_failed: Payment failed - payment_intent.canceled: Payment was canceled - payment_intent.processing: Payment is being processed (bank transfers) - payment_intent.requires_action: Customer action needed (3D Secure) - payment_intent.amount_capturable_updated: Authorization hold updated **Charge Events:** - charge.succeeded: Charge completed - charge.failed: Charge failed - charge.refunded: Refund processed - charge.dispute.created: Customer disputed a charge - charge.dispute.closed: Dispute resolved - charge.dispute.updated: Dispute status changed **Subscription Events (Recurring Payments):** - customer.subscription.created: New subscription started - customer.subscription.updated: Subscription modified - customer.subscription.deleted: Subscription canceled - customer.subscription.paused: Subscription paused - customer.subscription.resumed: Subscription resumed - customer.subscription.trial_will_end: Trial ending soon **Invoice Events:** - invoice.paid: Invoice payment successful - invoice.payment_failed: Invoice payment failed - invoice.upcoming: Invoice will be created soon - invoice.finalized: Invoice finalized **Customer Events:** - customer.created: New Stripe customer created - customer.updated: Customer details updated - customer.deleted: Customer deleted **Payment Method Events:** - payment_method.attached: Card saved to customer - payment_method.detached: Card removed from customer **Setup Intent Events:** - setup_intent.succeeded: Card saved for future use - setup_intent.setup_failed: Failed to save card **Checkout Session Events:** - checkout.session.completed: Checkout completed successfully - checkout.session.expired: Checkout session expired
 *
 * @tags StripeWebhook
 * @name WebhooksStripeCreate
 * @summary Stripe webhook endpoint for receiving payment events.
Configure this URL in Stripe Dashboard: https://dashboard.stripe.com/webhooks
Production URL: https://api.yourdomain.com/api/webhooks/stripe
 * @request POST:/api/webhooks/stripe
 * @secure
 */
  webhooksStripeCreate = (params: RequestParams = {}) =>
    this.request<WebhooksStripeCreateData, WebhooksStripeCreateError>({
      path: `/api/webhooks/stripe`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags StripeWebhook
 * @name WebhooksStripeHealthList
 * @summary Health check endpoint for webhook connectivity testing.
Can be used to verify the webhook URL is accessible.
 * @request GET:/api/webhooks/stripe/health
 * @secure
 */
  webhooksStripeHealthList = (params: RequestParams = {}) =>
    this.request<WebhooksStripeHealthListData, any>({
      path: `/api/webhooks/stripe/health`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
 * No description
 *
 * @tags StripeWebhook
 * @name WebhooksStripeEventsList
 * @summary Get list of events that this webhook can process.
Useful for configuring Stripe webhook in dashboard.
 * @request GET:/api/webhooks/stripe/events
 * @secure
 */
  webhooksStripeEventsList = (params: RequestParams = {}) =>
    this.request<WebhooksStripeEventsListData, any>({
      path: `/api/webhooks/stripe/events`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsCreate
   * @summary Creates a new employee team for workforce management.
   * @request POST:/api/teams
   * @secure
   */
  teamsCreate = (data: TeamsCreatePayload, params: RequestParams = {}) =>
    this.request<TeamsCreateData, TeamsCreateError>({
      path: `/api/teams`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsList
   * @summary Returns a paginated list of all teams with summary information.
   * @request GET:/api/teams
   * @secure
   */
  teamsList = (query: TeamsListParams, params: RequestParams = {}) =>
    this.request<TeamsListData, any>({
      path: `/api/teams`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsDetail
   * @summary Returns full details of a team including its managers and members.
   * @request GET:/api/teams/{id}
   * @secure
   */
  teamsDetail = (id: string, params: RequestParams = {}) =>
    this.request<TeamsDetailData, TeamsDetailError>({
      path: `/api/teams/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsUpdate
   * @summary Updates an existing team's name or configuration.
   * @request PUT:/api/teams/{id}
   * @secure
   */
  teamsUpdate = (
    id: string,
    data: TeamsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TeamsUpdateData, TeamsUpdateError>({
      path: `/api/teams/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsDelete
   * @summary Deletes a team by ID.
   * @request DELETE:/api/teams/{id}
   * @secure
   */
  teamsDelete = (id: string, params: RequestParams = {}) =>
    this.request<TeamsDeleteData, TeamsDeleteError>({
      path: `/api/teams/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsManagersCreate
   * @summary Adds an existing user as a manager of the specified team.
   * @request POST:/api/teams/{id}/managers
   * @secure
   */
  teamsManagersCreate = (
    id: string,
    data: TeamsManagersCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TeamsManagersCreateData, TeamsManagersCreateError>({
      path: `/api/teams/${id}/managers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsManagersDelete
   * @summary Removes a manager from the specified team.
   * @request DELETE:/api/teams/{id}/managers/{userId}
   * @secure
   */
  teamsManagersDelete = (
    id: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<TeamsManagersDeleteData, TeamsManagersDeleteError>({
      path: `/api/teams/${id}/managers/${userId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsMembersCreate
   * @summary Adds an existing user as a member of the specified team.
   * @request POST:/api/teams/{id}/members
   * @secure
   */
  teamsMembersCreate = (
    id: string,
    data: TeamsMembersCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TeamsMembersCreateData, TeamsMembersCreateError>({
      path: `/api/teams/${id}/members`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsMembersDelete
   * @summary Removes a member from the specified team.
   * @request DELETE:/api/teams/{id}/members/{userId}
   * @secure
   */
  teamsMembersDelete = (
    id: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<TeamsMembersDeleteData, TeamsMembersDeleteError>({
      path: `/api/teams/${id}/members/${userId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsManagersCreateCreate
   * @summary Creates a new user with the Manager role and adds them to the specified team.
   * @request POST:/api/teams/{id}/managers/create
   * @secure
   */
  teamsManagersCreateCreate = (
    id: string,
    data: TeamsManagersCreateCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TeamsManagersCreateCreateData, TeamsManagersCreateCreateError>(
      {
        path: `/api/teams/${id}/managers/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Teams
   * @name TeamsMembersCreateCreate
   * @summary Creates a new user with the Employee role and adds them to the specified team.
   * @request POST:/api/teams/{id}/members/create
   * @secure
   */
  teamsMembersCreateCreate = (
    id: string,
    data: TeamsMembersCreateCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TeamsMembersCreateCreateData, TeamsMembersCreateCreateError>({
      path: `/api/teams/${id}/members/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags TimeEntries
 * @name TimeEntriesClockInCreate
 * @summary Clock in the current user. Creates a new active time entry session.
Requires geolocation data from the client.
 * @request POST:/api/time-entries/clock-in
 * @secure
 */
  timeEntriesClockInCreate = (
    data: TimeEntriesClockInCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesClockInCreateData, TimeEntriesClockInCreateError>({
      path: `/api/time-entries/clock-in`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags TimeEntries
 * @name TimeEntriesClockOutCreate
 * @summary Clock out the current user. Closes the active time entry session.
Requires geolocation data from the client.
 * @request POST:/api/time-entries/clock-out
 * @secure
 */
  timeEntriesClockOutCreate = (
    data: TimeEntriesClockOutCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesClockOutCreateData, TimeEntriesClockOutCreateError>(
      {
        path: `/api/time-entries/clock-out`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TimeEntriesActiveList
   * @summary Get the active time entry session for the current user, if any.
   * @request GET:/api/time-entries/active
   * @secure
   */
  timeEntriesActiveList = (params: RequestParams = {}) =>
    this.request<TimeEntriesActiveListData, any>({
      path: `/api/time-entries/active`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TimeEntriesMyList
   * @summary Get time entries for the current user.
   * @request GET:/api/time-entries/my
   * @secure
   */
  timeEntriesMyList = (
    query: TimeEntriesMyListParams,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesMyListData, any>({
      path: `/api/time-entries/my`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TimeEntriesAllList
   * @summary Get all time entries across all teams. Requires Admin or HR permissions.
   * @request GET:/api/time-entries/all
   * @secure
   */
  timeEntriesAllList = (
    query: TimeEntriesAllListParams,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesAllListData, any>({
      path: `/api/time-entries/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags TimeEntries
 * @name TimeEntriesExportList
 * @summary Get all time entries with full correction audit history for export.
Returns JSON consumed by the frontend to generate a CSV download.
Requires Admin or HR permissions.
 * @request GET:/api/time-entries/export
 * @secure
 */
  timeEntriesExportList = (
    query: TimeEntriesExportListParams,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesExportListData, any>({
      path: `/api/time-entries/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TimeEntriesTeamDetail
   * @summary Get time entries for a specific team. Requires manager permissions.
   * @request GET:/api/time-entries/team/{teamId}
   * @secure
   */
  timeEntriesTeamDetail = (
    { teamId, ...query }: TimeEntriesTeamDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesTeamDetailData, any>({
      path: `/api/time-entries/team/${teamId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TimeEntriesDetail
   * @summary Get a specific time entry by ID.
   * @request GET:/api/time-entries/{id}
   * @secure
   */
  timeEntriesDetail = (id: string, params: RequestParams = {}) =>
    this.request<TimeEntriesDetailData, TimeEntriesDetailError>({
      path: `/api/time-entries/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags TimeEntries
 * @name TimeEntriesUpdate
 * @summary Update an existing time entry with correction reason metadata.
Only HR and Admin roles may correct time entries. Proof URL from the upload endpoint is required.
 * @request PUT:/api/time-entries/{id}
 * @secure
 */
  timeEntriesUpdate = (
    id: string,
    data: TimeEntriesUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesUpdateData, TimeEntriesUpdateError>({
      path: `/api/time-entries/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TimeEntriesManualCreate
   * @summary Add a manual time entry. Requires manager permissions.
   * @request POST:/api/time-entries/manual
   * @secure
   */
  timeEntriesManualCreate = (
    data: TimeEntriesManualCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<TimeEntriesManualCreateData, TimeEntriesManualCreateError>({
      path: `/api/time-entries/manual`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags TimeEntries
 * @name TimeEntriesCorrectionProofCreate
 * @summary Upload proof for a time entry correction (screenshot, email, etc.).
Must be called before PUT {id} — returns the proof URL to include in the correction request.
 * @request POST:/api/time-entries/{id}/correction-proof
 * @secure
 */
  timeEntriesCorrectionProofCreate = (
    id: string,
    data: TimeEntriesCorrectionProofCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      TimeEntriesCorrectionProofCreateData,
      TimeEntriesCorrectionProofCreateError
    >({
      path: `/api/time-entries/${id}/correction-proof`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TeamsOvertimeList
   * @summary Get overtime report for a team. Requires manager permissions.
   * @request GET:/api/teams/{teamId}/overtime
   * @secure
   */
  teamsOvertimeList = (
    { teamId, ...query }: TeamsOvertimeListParams,
    params: RequestParams = {},
  ) =>
    this.request<TeamsOvertimeListData, any>({
      path: `/api/teams/${teamId}/overtime`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeEntries
   * @name TeamsHoursSummaryList
   * @summary Get hours summary report for a team comparing worked vs contracted hours. Requires manager permissions.
   * @request GET:/api/teams/{teamId}/hours-summary
   * @secure
   */
  teamsHoursSummaryList = (
    { teamId, ...query }: TeamsHoursSummaryListParams,
    params: RequestParams = {},
  ) =>
    this.request<TeamsHoursSummaryListData, any>({
      path: `/api/teams/${teamId}/hours-summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name CreateUser
   * @summary Creates a new system user with role, rental, and area assignments.
   * @request POST:/api/users
   * @secure
   */
  createUser = (data: CreateUserPayload, params: RequestParams = {}) =>
    this.request<CreateUserData, CreateUserError>({
      path: `/api/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUsers
   * @summary Returns a paginated list of all users, filterable by role, status, or search term.
   * @request GET:/api/users
   * @secure
   */
  getUsers = (query: GetUsersParams, params: RequestParams = {}) =>
    this.request<GetUsersData, any>({
      path: `/api/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUser
   * @summary Returns full profile details for a user by their ID.
   * @request GET:/api/users/{id}
   * @secure
   */
  getUser = (id: string, params: RequestParams = {}) =>
    this.request<GetUserData, GetUserError>({
      path: `/api/users/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUser
   * @summary Updates a user's profile, role, password, rental assignments, and area assignments.
   * @request PUT:/api/users/{id}
   * @secure
   */
  updateUser = (
    id: string,
    data: UpdateUserPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateUserData, UpdateUserError>({
      path: `/api/users/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name DeleteUser
   * @summary Soft-deletes a user account while freeing username and email for reuse.
   * @request DELETE:/api/users/{id}
   * @secure
   */
  deleteUser = (id: string, params: RequestParams = {}) =>
    this.request<DeleteUserData, DeleteUserError>({
      path: `/api/users/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name DeactivateUser
   * @summary Deactivates a user account without permanently deleting it.
   * @request POST:/api/users/{id}/deactivate
   * @secure
   */
  deactivateUser = (id: string, params: RequestParams = {}) =>
    this.request<DeactivateUserData, DeactivateUserError>({
      path: `/api/users/${id}/deactivate`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name MigrateUserRecords
   * @summary Reassigns all of a user's records (time entries, shifts, scans, reports…) to another user. Used to merge duplicate staff accounts.
   * @request POST:/api/users/{id}/migrate-records
   * @secure
   */
  migrateUserRecords = (
    id: string,
    data: MigrateUserRecordsPayload,
    params: RequestParams = {},
  ) =>
    this.request<MigrateUserRecordsData, MigrateUserRecordsError>({
      path: `/api/users/${id}/migrate-records`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ReactivateUser
   * @summary Reactivates a previously deactivated user account.
   * @request POST:/api/users/{id}/reactivate
   * @secure
   */
  reactivateUser = (id: string, params: RequestParams = {}) =>
    this.request<ReactivateUserData, ReactivateUserError>({
      path: `/api/users/${id}/reactivate`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GenerateApiKey
   * @summary Generates or regenerates an API key for a user, used for service account authentication.
   * @request POST:/api/users/{id}/generateApiKey
   * @secure
   */
  generateApiKey = (id: string, params: RequestParams = {}) =>
    this.request<GenerateApiKeyData, any>({
      path: `/api/users/${id}/generateApiKey`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetCurrentUser
   * @summary Returns the profile of the currently authenticated user.
   * @request GET:/api/users/me
   * @secure
   */
  getCurrentUser = (params: RequestParams = {}) =>
    this.request<GetCurrentUserData, GetCurrentUserError>({
      path: `/api/users/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateCurrentUser
   * @summary Updates the currently authenticated user's own profile information.
   * @request PUT:/api/users/me
   * @secure
   */
  updateCurrentUser = (
    data: UpdateCurrentUserPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCurrentUserData, UpdateCurrentUserError>({
      path: `/api/users/me`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetCurrentUserTeams
   * @summary Returns all team memberships for the currently authenticated user.
   * @request GET:/api/users/me/teams
   * @secure
   */
  getCurrentUserTeams = (params: RequestParams = {}) =>
    this.request<GetCurrentUserTeamsData, any>({
      path: `/api/users/me/teams`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetCurrentUserRentals
   * @summary Returns the rental locations assigned to the currently authenticated user.
   * @request GET:/api/users/me/rentals
   * @secure
   */
  getCurrentUserRentals = (params: RequestParams = {}) =>
    this.request<GetCurrentUserRentalsData, any>({
      path: `/api/users/me/rentals`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetCurrentUserAreas
   * @summary Returns the areas assigned to the currently authenticated user.
   * @request GET:/api/users/me/areas
   * @secure
   */
  getCurrentUserAreas = (params: RequestParams = {}) =>
    this.request<GetCurrentUserAreasData, any>({
      path: `/api/users/me/areas`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetScope
   * @request GET:/api/users/me/scope
   * @secure
   */
  getScope = (params: RequestParams = {}) =>
    this.request<GetScopeData, GetScopeError>({
      path: `/api/users/me/scope`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SetScope
   * @request POST:/api/users/me/scope
   * @secure
   */
  setScope = (data: SetScopePayload, params: RequestParams = {}) =>
    this.request<SetScopeData, any>({
      path: `/api/users/me/scope`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ChangeMyPassword
   * @request POST:/api/users/me/change-password
   * @secure
   */
  changeMyPassword = (
    data: ChangeMyPasswordPayload,
    params: RequestParams = {},
  ) =>
    this.request<ChangeMyPasswordData, ChangeMyPasswordError>({
      path: `/api/users/me/change-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Utils
   * @name GetTimezones
   * @summary Returns a list of all available IANA time zones with English display names.
   * @request GET:/api/utils
   * @secure
   */
  getTimezones = (params: RequestParams = {}) =>
    this.request<GetTimezonesData, any>({
      path: `/api/utils`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Utils
   * @name GetReleaseName
   * @summary Returns the current application release name.
   * @request GET:/api/utils/releaseName
   * @secure
   */
  getReleaseName = (params: RequestParams = {}) =>
    this.request<GetReleaseNameData, any>({
      path: `/api/utils/releaseName`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WooCommerceImport
   * @name AdminWoocommerceImportTestCreate
   * @summary Checks the site URL and key; returns the site's order count.
   * @request POST:/api/admin/woocommerce-import/test
   * @secure
   */
  adminWoocommerceImportTestCreate = (
    data: AdminWoocommerceImportTestCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminWoocommerceImportTestCreateData,
      AdminWoocommerceImportTestCreateError
    >({
      path: `/api/admin/woocommerce-import/test`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WooCommerceImport
   * @name AdminWoocommerceImportRunsCreate
   * @summary Starts a run: the site is pulled in the background. Poll `GET runs/{runId}`.
   * @request POST:/api/admin/woocommerce-import/runs
   * @secure
   */
  adminWoocommerceImportRunsCreate = (
    data: AdminWoocommerceImportRunsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminWoocommerceImportRunsCreateData,
      AdminWoocommerceImportRunsCreateError
    >({
      path: `/api/admin/woocommerce-import/runs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WooCommerceImport
   * @name AdminWoocommerceImportRunsDetail
   * @summary The run and its preview; order decisions filtered by `action` and paged.
   * @request GET:/api/admin/woocommerce-import/runs/{runId}
   * @secure
   */
  adminWoocommerceImportRunsDetail = (
    { runId, ...query }: AdminWoocommerceImportRunsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminWoocommerceImportRunsDetailData,
      AdminWoocommerceImportRunsDetailError
    >({
      path: `/api/admin/woocommerce-import/runs/${runId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WooCommerceImport
   * @name AdminWoocommerceImportRunsProductMappingsUpdate
   * @summary Maps a product (or variation) to an equipment type, or ignores it (null), and re-plans.
   * @request PUT:/api/admin/woocommerce-import/runs/{runId}/product-mappings/{productId}
   * @secure
   */
  adminWoocommerceImportRunsProductMappingsUpdate = (
    runId: string,
    productId: number,
    data: AdminWoocommerceImportRunsProductMappingsUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminWoocommerceImportRunsProductMappingsUpdateData,
      AdminWoocommerceImportRunsProductMappingsUpdateError
    >({
      path: `/api/admin/woocommerce-import/runs/${runId}/product-mappings/${productId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WooCommerceImport
   * @name AdminWoocommerceImportRunsApplyCreate
   * @summary Starts writing the preview in the background; poll `GET runs/{runId}` for the result.
   * @request POST:/api/admin/woocommerce-import/runs/{runId}/apply
   * @secure
   */
  adminWoocommerceImportRunsApplyCreate = (
    runId: string,
    data: AdminWoocommerceImportRunsApplyCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminWoocommerceImportRunsApplyCreateData,
      AdminWoocommerceImportRunsApplyCreateError
    >({
      path: `/api/admin/woocommerce-import/runs/${runId}/apply`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
